(function (angular) {
    'use strict';

    angular.module('app', [
        'ui.bootstrap',
        'ui.router',
        'angular-loading-bar',
        'ncy-angular-breadcrumb',
        'ngAnimate',
        'ngCacheBuster',
        'ngCookies',
        'ngFileUpload',
        'ngResource',
        'ngStorage',
        'ngTable',
        'ngTagsInput',
        'pascalprecht.translate',
        'ui-leaflet',
        'rzModule',
        'thatisuday.ng-image-gallery',
        'infinite-scroll',
        'angular-sortable-view',
        'oc.lazyLoad',
        'ngSanitize'

    ]).run(appRun);

    /* @ngInject */
    function appRun($rootScope, $translate, stateHandler) {

        stateHandler.initialize();

        $rootScope.changeLanguage = function (key) {
            $translate.use(key);
            $translate.refresh();
        };
    }
})
(angular);

(function () {
    'use strict';

    angular.module('app')
        .component('imagenPerfilVer', {
            templateUrl: "app/components/form/archivos/imagenperfilver/imagen-perfil-ver.html",
            controllerAs: 'ctrl',
            bindings: {
                usuario: '<',
                mini: '<'
            }
        });

})();

(function () {
    'use strict';

    angular.module('app')
        .component('imagenPerfil', {
            bindings: {
                ngModel: "=",
                indice: "=",
                imagenTemporal: "=",
                rutaCarpetaImagen: "@", // Opcional
                rutaImagenDefault: "@", // Opcional
                onUploadedImage: '&',
                onRemoveImage: '&'
            },
            templateUrl: "app/components/form/archivos/imagenperfil/imagen-perfil.html",
            controllerAs: 'ctrl',
            controller: ImagenPerfil
        });

    /* @ngInject */
    function ImagenPerfil(Upload, AlertService) {

        var vm = this;
        vm.editPreview = false;
        vm.myCroppedImage = '';
        vm.myImage = '';

        activate();

        function activate() {
            if (!vm.ngModel.rutaImagen) {
                if (vm.ngModel.path) {
                    vm.ngModel.rutaImagen = vm.rutaCarpetaImagen + "/" + vm.ngModel.path;
                    vm.myCroppedImage = vm.ngModel.rutaImagen;
                } else {
                    vm.ngModel.rutaImagen = null;
                }
            }
        }

        function onUploaded() {
            vm.onUploadedImage();
        }

        vm.isSubmitted = function (form) {
            while (!!form) {
                if (form.$submitted) return true;
                form = form.$$parentForm;
            }
            return false;
        };

        vm.eliminarImagen = function () {
            vm.ngModel.eliminar = true;
            vm.ngModel.rutaImagen = null;
            vm.ngModel.path = null;
            vm.ngModel.archivoTemporal = null;
            vm.myCroppedImage = '';

            // Llamamos al callback para eliminar el elemento de la lista
            vm.onRemoveImage({imagen: vm.ngModel});
        };

        function blobToFile(theBlob, fileName) {
            // A Blob() is almost a File() - it's just missing the two
            // properties below which we will add
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            return theBlob;
        }

        function dataURItoBlob(dataURI, type) {
            // convert base64 to raw binary data held in a string
            var byteString = atob(dataURI.split(',')[1]);

            // write the bytes of the string to an ArrayBuffer
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            // write the ArrayBuffer to a blob, and you're done
            return new Blob([ab], {type: type});
        }

        vm.onImagenSelect = function (files, form) {
            vm.editPreview = false;
            vm.ngModel.eliminar = false;
            if (files && files.length) {

                vm.ngModel.path = null;
                vm.progresoImagen = true;

                form.$setValidity('imagenSubida', false);

                // Subimos imagen
                Upload.upload({
                    url: "api/archivos-temporales",
                    data: {
                        file: blobToFile(dataURItoBlob(files, 'image/png'), vm.myImage.name),
                        ext: "jpeg,png,gif,jpg"
                    },
                    method: 'POST'
                }).success(function (response) {
                    vm.progresoImagen = null;
                    vm.ngModel.archivoTemporal = response.msg;
                    vm.ngModel.path = vm.myImage.name;
                    form.$setValidity('imagenSubida', true);
                    onUploaded();
                }).error(function (data) {
                    vm.progresoImagen = null;
                    form.$setValidity('imagenSubida', true);
                    vm.eliminarImagen();
                    if (data && data.msg === 'invalid extension') {
                        AlertService.error("error.invalidextension", {archivo: vm.myImage.name});
                    } else {
                        AlertService.error("admin.form.error.fail");
                    }
                });
            }
        };

        vm.clickUpload = function () {
            var indice = vm.indice ? vm.indice : '';
            document.getElementById('inputFoto' + indice).click();
        };

        vm.preview = function (files) {
            vm.myImage = files[0];
            vm.editPreview = true;
        }


    }

})();

(function () {
    'use strict';

    angular.module('app').directive('imagen', imagen);

    function imagen() {
        return {
            restrict: 'E',
            scope: {
                ngModel: "=",
                indice: "=",
                ngModelRadio: "=",
                imagenTemporal: "=",
                rutaCarpetaImagen: "@", // Opcional
                rutaImagenDefault: "@", // Opcional
                onUploadedImage: '&',
                onRemoveImage: '&',
                edicion: "=", // Opcional (default = true)
                error: "=",
                id: "@",
                mensaje: "@"    //Lo que queremos que se muestre en el botón
            },
            templateUrl: "app/components/form/archivos/imagen/imagen.html",
            controllerAs: 'ctrl',
            bindToController: true,
            controller: 'ImagenController'
        }
    }

})();

(function () {
    'use strict';

    angular.module('app').controller('ImagenController', ImagenController);

    /* @ngInject */
    function ImagenController($timeout, Upload, AlertService) {

        var vm = this;

        activate();

        vm.id = vm.id || vm.indice;

        function activate() {
            if (!vm.ngModel.rutaImagen) {
                if (vm.ngModel.path) {
                    vm.ngModel.rutaImagen = vm.rutaCarpetaImagen + "/n_" + vm.ngModel.path;
                } else {
                    vm.ngModel.rutaImagen = null;
                }
            }

            if (vm.edicion === null || vm.edicion === undefined) {
                vm.edicion = true;
            }
        }

        function onUploaded() {
            vm.onUploadedImage();
        }

        vm.isSubmitted = function (form) {
            while (!!form) {
                if (form.$submitted) return true;
                form = form.$$parentForm;
            }
            return false;
        };

        vm.eliminarImagen = function () {
            vm.ngModel.eliminar = true;
            vm.ngModel.rutaImagen = null;
            // vm.ngModel.path = null;
            vm.ngModel.archivoTemporal = null;

            // Llamamos al callback para eliminar el elemento de la lista
            vm.onRemoveImage({imagen: vm.ngModel});
        };

        function generateThumb(file) {
            if (file != null) {
                if (file.type.indexOf('image') > -1) {
                    $timeout(function () {
                        var fileReader = new FileReader();
                        fileReader.readAsDataURL(file);
                        fileReader.onload = function (e) {
                            $timeout(function () {
                                vm.ngModel.rutaImagen = e.target.result;
                            });
                        }
                    });
                }
            }
        }

        vm.onImagenSelect = function (files, form) {
            vm.ngModel.eliminar = false;
            if (files && files.length) {

                vm.ngModel.path = null;
                vm.progresoImagen = true;

                form.$setValidity('imagenSubida', false);

                // Previsualizamos imagen
                generateThumb(files[0]);

                // Subimos imagen
                Upload.upload({
                    url: "api/archivos-temporales",
                    data: {
                        file: files[0],
                        ext: "jpeg,png,gif,jpg"
                    },
                    method: 'POST'
                }).success(function (response) {
                    vm.progresoImagen = null;
                    vm.ngModel.archivoTemporal = response.msg;
                    vm.ngModel.path = files[0].name;
                    form.$setValidity('imagenSubida', true);
                    onUploaded();
                }).error(function (data) {
                    angular.element("html, body").animate({scrollTop: 0}, "slow");
                    vm.progresoImagen = null;
                    form.$setValidity('imagenSubida', true);
                    vm.eliminarImagen();
                    vm.ngModel.eliminar = false;
                    if (data && data.msg === 'invalid extension') {
                        AlertService.error("error.invalidextension", {archivo: files[0].name});
                    } else {
                        AlertService.error("admin.form.error.fail");
                    }
                });
            }
        };
        vm.clickUpload = function () {
            document.getElementById('inputFoto' + vm.id).click();
        };
    }
})();

(function () {
    'use strict';

    angular.module('app').directive('fileUpload', fileUpload);

    function fileUpload() {
        return {
            restrict: 'EA',
            scope: {
                id: '@',
                archivo: "=",
                archivoTemporal: "=",
                accept: "@",  // Opcional (default === todas las extensiones)
                error: "=", // Opcional
                url: "@", // Opcional (si no se pasa, no se permite descargar el archivo)
                authorities: "@", // Opcional (si no se indica ningún rol, será visible para todos. Ej:ROLE_ADMIN,ROLE_EDITOR_CONTENIDOS)
                onSelected: "<"
            },
            templateUrl: 'app/components/form/archivos/fileupload/file-upload.html',
            controllerAs: 'ctrl',
            bindToController: true,
            controller: 'FileUploadController'
        }
    }

})();

(function () {
    'use strict';

    angular.module('app').controller('FileUploadController', FileUploadController);

    /* @ngInject */
    function FileUploadController(Upload, AlertService) {
        var vm = this;

        vm.onArchivoSelect = onArchivoSelect;
        vm.eliminarArchivo = eliminarArchivo;

        vm.isSubmitted = isSubmitted;

        vm.upload = upload;

        function upload() {
            setTimeout(function () {
                angular.element("input#" + vm.id).trigger('click');
            }, 0);
        }

        function isSubmitted(form) {
            while (!!form) {
                if (form.$submitted)
                    return true;
                form = form.$$parentForm;
            }
            return false;
        }

        function onArchivoSelect(files, form) {
            console.log(form);

            if (files && files.length) {
                vm.progresoArchivo = true;
                vm.archivo = files[0].name;
                form.$setValidity('archivoSubido', false);
                Upload.upload({
                    url: "api/archivos-temporales",
                    data: {
                        file: files[0],
                        ext: vm.accept
                    },
                    method: 'POST'
                }).success(function (response) {
                    console.log("Archivo subido");
                    vm.progresoArchivo = false;
                    vm.archivoTemporal = response.msg;
                    form.$setValidity('archivoSubido', true);

                    if (vm.onSelected) {
                        vm.onSelected(vm.archivoTemporal, vm.archivo);
                    }

                }).error(function (data) {
                    // TODO: Gestión de errores en el servidor
                    angular.element("html, body").animate({scrollTop: 0}, "slow");
                    console.log("Error subiendo");
                    vm.progresoArchivo = false;
                    vm.archivo = null;
                    form.$setValidity('archivoSubido', true);
                    if (data && data.msg === 'invalid extension') {
                        AlertService.error("error.invalidextension", {archivo: files[0].name});
                    } else {
                        AlertService.error("admin.form.error.fail");
                    }
                });
            }
        }

        function eliminarArchivo() {
            vm.archivo = null;
        }

    }

})();

(function () {
    'use strict';

    angular.module('app').directive('download', download);

    function download() {

        return {
            restrict: 'EA',
            scope: {
                archivo: "=",
                url: "@",
                showLabel: "="
            },
            templateUrl: 'app/components/form/archivos/download/download.html',
            controllerAs: 'ctrl',
            bindToController: true,
            controller: 'DownloadController'
        }
    }

})();

(function () {
    'use strict';

    angular.module('app').controller('DownloadController', DownloadController);

    function DownloadController() {
        var vm = this;

        vm.descargarArchivo = descargarArchivo;

        function descargarArchivo() {
            window.open(vm.url + vm.archivo, '_blank');
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .controller('UbicacionFormController', Controller);

    /* @ngInject */
    function Controller($scope, $timeout, item, ModalService, AlertService, Geonames, Lugar) {
        var vm = this;

        vm.item = item;

        vm.propuestas = [];
        vm.selected = {};
        vm.loading = true;


        function initRadio() {
            if (vm.item.lat == null || vm.item.lng == null) return;

            vm.markers.push({
                lat: vm.item.lat,
                lng: vm.item.lng,
                draggable: true
            });

            vm.propuestas.forEach(function (item, index) {
                if (item.lat == vm.item.lat && item.lng == vm.item.lng) {
                    vm.selected = index;
                }
            });
        }

        vm.onChangeRadio = function () {
            if (vm.propuestas && vm.propuestas[vm.selected]) {
                initMarkers();
                vm.center.lat = vm.markers[0].lat = vm.item.lat = vm.propuestas[vm.selected].lat;
                vm.center.lng = vm.markers[0].lng = vm.item.lng = vm.propuestas[vm.selected].lng;
            }
        };

        vm.onChangeLatLong = function () {
            vm.selected = {};

            if (vm.item.lat != null && vm.item.lng != null) {
                if (!vm.markers[0]) {
                    initMarkers();
                }
                vm.center.lat = vm.markers[0].lat = vm.item.lat;
                vm.center.lng = vm.markers[0].lng = vm.item.lng;
            }
        };

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        // Cargamos las propuestas a partir del nombre del lugar
        Geonames.get({nombre: vm.item.nombre}).$promise.then(function (response) {
            vm.propuestas = response;
            initRadio();
            vm.loading = false;

        }, function (error) {
            AlertService.error("admin.lugar.geonames.error");
        });

        vm.save = function () {
            Lugar.updateCoordenadas(vm.item).$promise.then(function (result) {
                console.log("Guardado");
                ModalService.close(result);
            });
        };

        vm.clear = function () {
            ModalService.dismiss('cancel');
        };

        // *** Mapa

        vm.markers = [];

        function initMarkers() {
            if (!vm.markers[0]) {
                vm.markers.push({draggable: true});
            }
        }

        angular.extend(vm, {
            defaults: {
                tileLayer: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
                maxZoom: 18,
                minZoom: 2,
                zoom: 3
            },
            center: {
                lat: vm.item.lat,
                lng: vm.item.lng,
                zoom: 5
            },
            events: {
                map: {
                    enable: ['dragend', 'click']
                }
            }
        });

        $scope.$on('leafletDirectiveMap.mymap.click', function (event, args) {
            vm.selected = {};
            initMarkers();
            vm.markers[0].lat = vm.item.lat = args.leafletEvent.latlng.lat;
            vm.markers[0].lng = vm.item.lng = args.leafletEvent.latlng.lng;

        });

        $scope.$on('leafletDirectiveMarker.mymap.dragend', function (event, args) {
            vm.selected = {};
            vm.markers[args.modelName].lat = vm.item.lat = args.model.lat;
            vm.markers[args.modelName].lng = vm.item.lng = args.model.lng;
        });

        // *** Fin mapa

    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('EmailFormController', Controller);

    /* @ngInject */
    function Controller($scope, $timeout, item, ModalService, AlertService, Exportar) {
        var vm = this;

        vm.cargando = false;
        vm.item = item;

        vm.propuestas = [];
        vm.selected = {};
        vm.loading = true;
        vm.dismiss = ModalService.dismiss;

        vm.save = function () {
            vm.cargando = true;
            Exportar.exportar(item);
        };

        vm.clear = function () {
            ModalService.dismiss('cancel');
        };

    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('AyudaController', AyudaController);

    /* @ngInject */
    function AyudaController(ModalService) {
        var vm = this;
        vm.dismiss = ModalService.dismiss;

    }
})();

(function () {
    'use strict';

    // Componente para modificar la contraseña

    angular
        .module('app')
        .component('changePassword', {
            templateUrl: 'app/public/components/password/password.html',
            controller: PasswordController,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function PasswordController($timeout, Auth, AlertService) {
        var vm = this;

        vm.form = {};

        $timeout(function () {
            angular.element('[ng-model="registerAccount.login"]').focus();
        });

        vm.save = function () {
            if (vm.form.newpassword !== vm.confirmPassword) {
                AlertService.error("admin.register.error.dontmatch");
            } else {
                Auth.changePassword(vm.form).then(function () {
                    AlertService.success("admin.changepassword.success");
                    vm.form = {};
                    vm.confirmPassword = "";

                }).catch(function (response) {
                    if (response.status === 200) {
                        AlertService.success("admin.changepassword.success");
                    } else if (response.status === 400 && response.data.msg === 'incorrect password') {
                        AlertService.error("admin.changepassword.error.incorrect");
                    } else {
                        AlertService.error("admin.form.error.fail");
                    }
                });
            }
        };
    }

})();

(function (angular) {
    'use strict';

    // Componente para la paginación.
    // El nº de elementos por página va en una constante.

    // currentPage: Página activa.
    // totalElements: Número de elementos totales.

    angular
        .module('app')
        .component('pagination', {
            bindings: {
                currentPage: "<",
                totalElements: "<",
                sortProperty : "<"
            },
            templateUrl: 'app/public/components/pagination/pagination.html',
            controller: function ($state, NG_LIST_DEFAULT_PARAMS_PUBLIC) {
                var vm = this;

                vm.itemsPerPage = NG_LIST_DEFAULT_PARAMS_PUBLIC.size;

                vm.pageChanged = function () {
                    var params = angular.copy($state.params);
                    params.page = vm.currentPage;
                    $state.go($state.current, params);
                };

            },
            controllerAs: 'ctrl'
        });
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .controller('BuscadorControllerComponent', Controller);

    /* @ngInject */
    function Controller($stateParams, Idioma, Biblioteca) {
        var vm = this;

        vm.search = function () {
            vm.onBuscar(false);
        };

        vm.clear = function () {
            vm.onClear();
        };

        // Servicios para los tesauros
        vm.idiomaService = Idioma;
        vm.bibliotecaService = Biblioteca;
    }

})();

(function () {
    'use strict';

    //definimos el binding bidireccional (=)
    angular
        .module('app')
        .component('buscadorBasico', {
            bindings: {
                ediciones: '=',
                onBuscar: '<',
                onClear: '<',
                filter: '<'
            },
            templateUrl: 'app/public/components/buscador/buscador.basico.html',
            controller: "BuscadorControllerComponent",
            controllerAs: 'ctrl'
        });

})();

(function () {
    'use strict';

    //definimos el binding bidireccional (=)
    angular
        .module('app')
        .component('buscadorAvanzado', {

            bindings: {
                ediciones: '=',
                tipologias: '<',
                subgeneros: '<',
                modalidades: '<',
                tamanos:'<',
                onBuscar: '<',
                onClear: '<',
                filter: '<'
            },
            templateUrl: 'app/public/components/buscador/buscador.avanzado.html',
            controller: "BuscadorControllerComponent",
            controllerAs: 'ctrl'
        });

})();

(function (angular) {
    'use strict';
    //check: para que se muestren o no los checkboxes a la izquierda de cada elemento (para la exportacion)
    angular
        .module('app')
        .component('edicionList', {
            bindings: {
                ediciones: '<',
                check: '<'
            },
            templateUrl: 'app/public/components/listado/edicion.list.html',
            /* @ngInject */
            controller: function () {
                var vm = this;
            },
            controllerAs: 'ctrl'

        });

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .component('login', {
            templateUrl: 'app/public/components/login/login.html',
            controller: LoginController,
            bindings: {
                libro: '<',
                foco: '<'
            }
        });

    /* @ngInject */
    function LoginController($state, $timeout, Auth, AlertService, ADMIN_PRINCIPAL) {
        var vm = this;

        vm.user = {};
        vm.rememberMe = false;

        if (vm.foco) {
            $timeout(function () {
                angular.element('.form-group:eq(0)>input').focus();
            });
        }

        vm.login = function () {
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function (data) {
                vm.authenticationError = false;
                $state.go(ADMIN_PRINCIPAL);
            }).catch(function () {
                AlertService.error("login.form.error.authentication");
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Geonames', Geonames);

    // Ejemplo: http://iconclass.org/22C.json

    /* @ngInject */
    function Geonames($resource) {
        return $resource('api/geonames/:nombre', {}, {
            'get': {
                isArray: true
            }
        });
    }
})();

/* globals $ */
(function () {
    'use strict';

    // Módulos requeridos:
    //
    // label: Etiqueta que se mostrará en el tooltip
    // position: Posición del tooltip. Por defecto: right

    angular
        .module('app')
        .directive('tooltip', Tooltip);

    function Tooltip() {
        var directive = {
            replace: true,
            restrict: 'E',
            templateUrl: 'app/components/form/tooltip/tooltip.html',
            scope: {
                label: '@',
                position: '@'
            }
        };
        return directive;
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:textArea
     * @description
     * Componente que añade un editor de texto enriquecido.
     *
     * Referencia: {@link https://docs.ckeditor.com/ckeditor4/docs/}.
     *
     * @param {Object} model Campo que se modificará
     * @param {String} id Identificador del elemento
     * @param {String} name Nombre del elemento. En caso de no indicarse nada, se utilizará el ID
     * @param {String} label Etiqueta
     * @param {Boolean} [disabled=false] Editor deshabilitado
     * @param {Boolean} [required=false] Campo obligatorio
     * @param {String} [tipo=basico] Tipo de editor. Tipos existentes: basico, normal, completo|estatica
     * @param {Number} [height=250] Altura del editor
     * @param {Number} [max=-1] Número máximo de caracteres
     *
     * @requires app.directive:ckEditor
     *
     */
    angular
        .module('app')
        .component('textArea', {
            template: '<label-form key="{{ctrl.label}}" for="{{ctrl.id}}" required="ctrl.required"></label-form>' +
                '<textarea ck-editor id="{{ctrl.id}}" ng-model="ctrl.model" class="{{ctrl.class}}"' +
                ' tipo="{{ctrl.tipo}}" height="{{ctrl.height}}" max="{{ctrl.max}}"' +
                ' ng-required="ctrl.required" ng-disabled="ctrl.disabled"></textarea>',
            bindings: {
                model: '=',
                id: '@',
                name: '@',
                label: '@',
                disabled: '<',
                required: '<',
                tipo: '@',
                height: '@',
                max: '@',
                class: '@'
            },
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller() {
        var vm = this;

        vm.tipo = vm.tipo || 'basico';
        vm.height = vm.height || 250;
        vm.max = vm.max || -1;
    }

})();

(function () {
    'use strict';

    // Requiere: label-form
    // Módulos requeridos:
    // "ng-tags-input": "3.0.0"
    // "angular-bootstrap": "1.3.3"

    // id: ID del input.
    // multiple: Boolean. True para usar las etiquetas y false para usar un autcompletado simple.
    // as-list: Boolean. Añadir clase as-list a los elementos para mostrarlos uno debajo de otro.
    // restricted: Boolean. Solo permite añadir elementos que están en el autocompletado.
    // disabled: Boolean. Permite deshabilitar los inputs.
    // minLength: Número de caracteres requeridos para mostrar el autocompletado.
    // key: Clave para el track by
    // display: Propiedad que se va a mostrar (por defecto 'nombre')
    // method: Método del servicio (por defecto 'query')
    // parameters: Parámetros que se pueden añadir a la petición
    // required: Campo obligatorio.
    // resource: Tipo $resource del tesauro. El servicio tiene que implementar la operación query en el controlador.
    //      Ej: IdiomaService. (/idioma/query?query=x)
    // queryParam: Atributo en el que va a ir la query (por defecto 'query')
    // templateUrl: URL a un archivo HTML, o nombre del ID del HTML. En app/templates/tesauro.templates.html se pueden definir las que se utilicen más de una vez.
    // eliminable: Muestra el botón de eliminar en los tesauros simples.

    angular
        .module('app')
        .directive('tesauro', Tesauro);

    function Tesauro() {
        return {
            replace: true,
            restrict: 'E',
            controller: Controller,
            controllerAs: 'ctrl',
            bindToController: true,
            templateUrl: 'app/components/form/tesauro/tesauro.html',
            scope: {
                id: '@',
                label: '@',
                placeholder: '@',
                tooltip: '@',
                resource: '=',
                ngModel: '=',
                multiple: '=',
                asList: '=',
                key: '@',
                display: '@',
                method: '@',
                parameters: '=',
                restricted: '=',
                disabled: '=',
                minLength: '@',
                required: '=',
                queryParam: '@',
                templateUrl: '@',
                eliminable: '=',
                simpleListForm: '<'
            }
        };
    }

    /* @ngInject */
    function Controller(JsonUtils) {
        var vm = this;

        // Valores por defecto
        vm.key = vm.key || "id";
        vm.display = vm.display || "nombre";
        vm.method = vm.method || "query";
        vm.queryParam = vm.queryParam || "query";
        vm.minLength = vm.minLength || 1;

        //

        vm.clear = function () {
            if (!vm.simpleListForm) {
                console.log("Not list form");
                vm.ngModel = null;
            } else {
                JsonUtils.cleanJson(vm.ngModel);
            }
        };

        vm.onBlur = function () {
            if ((!vm.ngModel || !vm.ngModel[vm.display]) && vm.restricted) {
                vm.clear();
            }
        };

        vm.setElement = function (item) {
            if (item.id) {
                angular.extend(vm.ngModel, item);
            }
        };

        vm.loadTags = function (query) {
            var params = !vm.parameters ? {} : vm.parameters;
            params[vm.queryParam] = query;
            // angular.merge(params, {query: query});
            return vm.resource[vm.method](params).$promise.then(function (data) {
                if (Array.isArray(data)) {
                    return data;
                } else {
                    return data.content;
                }
            });
        };

    }

})();

(function () {
    'use strict';

    // Requiere: label-form

    // id: Identificador del select.
    // label: etiqueta
    // model: Campo que se modificará.
    // disabled
    // required
    // options: Opciones del select.
    // base: Clave base para los enumerados.
    // display: Propiedad del objeto que se usará para internacionalizar el contenido.

    // FORMATEADO: Se acepta dar un formato especial a los selects. Para esto habrá que pasar listas de elementos, separadas por comas, en display y base, además del campo format.
    // Este campo tendrá un _ en cada variable que se quiera rellenar (uno por cada display).

    var selectForm = {
        templateUrl: 'app/components/form/select/select.form.html',
        /* @ngInject */
        controller: function ($translate) {
            var vm = this;

            if (!vm.display) {
                vm.display = "nombre";
            }
            var list = vm.display.split(",");

            if (!vm.base) {
                vm.base = "";
            }
            var base = vm.base.split(",");

            if (!vm.format) {
                vm.format = "_";
            }

            // FIXME: Esta operación se llama cada vez que se interactúa con un select para recalcular el valor de TODOS los options de todos los selects.
            vm.formatElement = function (element) {
                var formated = vm.format;
                angular.forEach(list, function (elementDisplay, index) {
                    var baseText = base[index] ? base[index].trim() : "";
                    var translated = $translate.instant(baseText + element[elementDisplay.trim()]);
                    formated = formated.replace("_", translated);
                });
                return formated;
            }
        },
        controllerAs: 'ctrl',
        bindings: {
            id: '@',
            label: '@',
            tooltip: '@',
            model: '=', // required
            change: '=',
            display: '@', // required
            format: '@',
            disabled: '=',
            required: '=',
            options: '=', // required
            base: '@' // required
        }
    };

    angular
        .module('app')
        .component('selectForm', selectForm);

})();

/* globals $ */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar() {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
            '<small translate="admin.register.password.strength">Password strength:</small>' +
            '<ul id="strengthBar">' +
            '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
            '</ul>' +
            '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return {idx: idx + 1, col: this.colors[idx]};
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({'background-color': '#DDD'})
                        .slice(0, c.idx)
                        .css({'background-color': c.col});
                }
            });
        }
    }
})();

(function () {
    'use strict';

    // Lista de elementos dinámicos. Este componente incluye la gestión: añadir y eliminar.

    // label: Texto para la etiqueta.
    // tooltip: Texto para el tooltip.
    // list: Lista de elementos que se modificará.
    // resolve: Información del controller desde donde es invocado el componente. Ej: resolve="{agenteService: ctrl.agenteService, openAgenteModal: ctrl.openAgenteModal}"
    // templateUrl: Plantilla HTML que se mostrará, con los diferentes inputs.
    // required: Boolean. Si es true, siempre habrá al menos un elemento en la lista.
    // acordeon: Boolean. Indica si cada elemento se incluye en un acordeón. Se usa para ajustar el botón de eliminar.

    // Ejemplo: original-form.admin.html
    // Hay que trabajar sobre la variable element, ya que será así como se llame a cada objeto sobre el que se itere en el array.

    angular
        .module('app')
        .component('listForm', {
            templateUrl: 'app/components/form/listform/list-form.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                label: '@',
                tooltip: '@',
                list: '=',
                resolve: '<',
                templateUrl: '@',
                required: '<',
                acordeon: '<'
            }
        });

    /* @ngInject */
    function Controller() {
        var vm = this;

        function initList() {
            if (!vm.list) {
                vm.list = [];
                if (vm.required) {
                    vm.list.push({});
                }
            } else if (!vm.list.length && vm.required) {
                vm.list.push({});
            }
        }

        vm.addElement = function () {
            vm.list.push({desplegado: true});
        };

        vm.removeElement = function (element) {
            vm.list.splice(vm.list.indexOf(element), 1);
            initList();
        };

        initList();

    }

})();

(function () {
    'use strict';

    // Requiere: tooltip

    // key: Clave del fichero de mensajes.
    // for: ID del input asociado.
    // tooltip: Mensaje mostrado como ayuda
    // position: Posición del tooltip
    // required: Muestra u oculta el * en función de si es obligatorio o no.

    var labelForm = {
        template: '<label ng-if="$ctrl.key" class="control-label" ng-class="{\'required\' : $ctrl.required}" for="{{$ctrl.for}}">' +
        '{{$ctrl.key | translate}}<span ng-if="$ctrl.required">*</span>' +
        '</label><tooltip ng-if="$ctrl.tooltip" label="{{$ctrl.tooltip}}" position="{{$ctrl.position}}"></tooltip>',
        bindings: {
            key: '@', // required
            for: '@',
            tooltip: '@',
            position: '@',
            required: '='
        }
    };

    angular
        .module('app')
        .component('labelForm', labelForm);

})();

(function () {
    'use strict';

    var filter = {
        templateUrl: 'app/components/form/filter/filter.input.template.html',
        bindings: {
            filter: '='
        }
    };

    angular
        .module('app')
        .component('filter', filter);

})();

(function (angular) {
    'use strict';

    //Si se le pasa un ejemplarId: se trata de las páginas digitalizadas de un ejemplar
    //Si se le pasa un edicionId: se trata de las imágenes de las ilustraciones de una edición
    angular
        .module('app')
        .component('imagenes', {
            bindings: {
                elements: '=',
                mode: '<',
                ejemplarId: '<',
                edicionId: '<',
                ilustracionId: '<',
                // propietarioId: '<'
                // selected: '='
                idBloque: '@',
                mensaje: '@' //Mensaje para mostrar en el boton
            },
            templateUrl: 'app/components/form/imagenes/imagenes.form.html',
            /* @ngInject */
            controller: function ($timeout) {
                var vm = this;
                vm.imagenes = angular.copy(vm.elements);

                $timeout(function () {
                    angular.element('.form-group:eq(0)>input').focus();
                });

                function cleanList() {
                    if (typeof(vm.elements) == 'undefined') {
                        vm.elements = [];
                    }
                    vm.elements = vm.elements.filter(function (imagen) {
                        return imagen.path;
                    });
                }

                if (vm.ejemplarId) {
                    vm.rutaCarpetaImagen = "upload/ejemplares/" + vm.ejemplarId + "/pagsDigitalizadas";
                } else {
                    if (vm.edicionId && vm.ilustracionId) {
                        vm.rutaCarpetaImagen = "upload/ediciones/" + vm.edicionId + "/ilustraciones/" + vm.ilustracionId;
                    } else {
                        console.log("No proporcionó información suficiente para encontrar el elemento multimedia");
                    }
                }


                // *** Imágenes ***

                function initImagenes() {
                    if (!vm.elements || !vm.elements.length) {
                        vm.elements = [];
                    }
                    addEmptyImagen();
                }

                function addEmptyImagen() {
                    vm.elements.push({});
                    vm.sortableOptions();
                }

                vm.onUploadedImage = function () {
                    addEmptyImagen();
                };

                vm.onRemoveImage = function (imagen) {
                    // if (imagen.principal) {
                    //     vm.selected = 0;
                    // }
                    // vm.elements.splice(vm.elements.indexOf(imagen), 1);
                };

                vm.sortableOptions = function () {
                    if (vm.imagenes) {
                        if (vm.imagenes.length < (vm.elements.length - 1)) {
                            vm.imagenes = vm.imagenes.concat(vm.elements[(vm.elements.length - 2)]);
                        }
                        for (i = 0; i < vm.imagenes.length; i++) {
                            vm.imagenes[i].orden = i + 1;
                            vm.elements[i] = angular.copy(vm.imagenes[i]);
                        }
                    }
                };

                cleanList();
                initImagenes();

                // initPrincipal();

                //El último elemento de la lista es vacío, ya que se corresponde con el boton de "añadir"
                //Para evitar que sea un elemento ordenable, es necesario crear una nueva lista sin dicho elemento, y pasarsela al sv-part
                if (vm.elements.length > 1) {
                    vm.imagenes = angular.copy(vm.elements);
                    vm.imagenes.splice(-1, 1);
                }
            },
            controllerAs: 'formCtrl'
        });
})(angular);

(function () {
    'use strict';

    // id: Identificador del select.
    // label: etiqueta
    // model: Campo que se modificará.
    // disabled
    // required
    // options: Opciones del select.
    // base: Clave base para los enumerados.
    // display: Propiedad del objeto que se usará para internacionalizar el contenido.
    // empty: Clave de mensaje para mostrar en la opción vacía

    // Nota: Para utilizar como un campo booleano (Null/Sí/No), pasar como options: [true, false].

    angular
        .module('app')
        .component('enumSelect', {
            templateUrl: 'app/components/form/enum/enum-select.html',
            bindings: {
                id: '@',
                label: '@',
                model: '=',
                change: '=',
                display: '@',
                empty: '@',
                disabled: '=',
                required: '=',
                options: '=',
                base: '@'
            },
            controllerAs: 'ctrl',
            /* @ngInject */
            controller: function () {
                var vm = this;

                vm.onChange = function (item) {
                    if (!item) {
                        vm.model = null;
                    }

                    if (vm.change) {
                        vm.change(item);
                    }
                }

            }
        });

})();

(function () {
    'use strict';

    angular.module('app')
        .controller('EntityDeleteModalController', EntityDeleteModalController);

    /* @ngInject */
    function EntityDeleteModalController(item, params, ModalService) {
        var vm = this;

        vm.dismiss = ModalService.dismiss;
        vm.item = item;
        vm.params = params;
        vm.confirmRemove = confirmRemove;

        cleanString();

        //Para eliminar caracteres que pueden hacer que no se muestre el texto en la ventana modal
        function cleanString() {
            if (vm.item[vm.params.property]) {
                vm.item[vm.params.property] = vm.item[vm.params.property].replace("'", "");
                vm.item[vm.params.property] = vm.item[vm.params.property].replace("<", "");
                vm.item[vm.params.property] = vm.item[vm.params.property].replace(">", "");
                vm.item[vm.params.property] = vm.item[vm.params.property].replace("&", "");
            }
        }

        function confirmRemove() {
            vm.item.$remove({id: vm.item.id}).then(function () {
                ModalService.close();
            });
        }
    }
})();

(function () {
    'use strict';

    // id: Identificador del select.
    // label: etiqueta
    // model: Campo que se modificará.
    // disabled
    // required
    // options: Opciones del select.
    // format: Formato de la fecha
    // change: Función que se llamará al cambiar el input.
    // showBar: Booleano para mostrar u ocultar la barra inferior del DatePicker. (default: true)
    // readonly: Booleano para deshabilitar el input (default: false)

    var datePicker = {
        templateUrl: 'app/components/form/date/date-picker.html',
        bindings: {
            id: '@',
            label: '@',
            model: '=', // required
            disabled: '=',
            required: '=',
            options: '=',
            format: '@',
            change: '=',
            showBar: '=?', // opcional
            readonly: '=?' // opcional
        },
        controller: Controller
    };

    angular
        .module('app')
        .component('datePicker', datePicker);

    function Controller() {
        var vm = this;

        vm.opened = false;
        if (!vm.format) {
            vm.format = 'dd/MM/yyyy';
        }

        if (typeof(vm.showBar) === 'undefined') {
            vm.showBar = true;
        }

        if (typeof(vm.readonly) === 'undefined') {
            vm.readonly = false;
        }

        // Si recibimos la fecha del servidor, convertimos segundos a milisegundos
        if (angular.isNumber(vm.model)) {
            vm.model = vm.model * 1000;
        }

        if (vm.options && vm.options.minDate === 'today') {
            vm.options.minDate = new Date();
        }

        vm.dateOptions = {
            datepickerMode: 'year',
            formatYear: 'yyyy',
            maxDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        angular.merge(vm.dateOptions, vm.options);

        vm.openDatePicker = function () {
            vm.opened = true;
        };

    }

})();

(function (angular) {
    'use strict';

    /**
     * @ngdoc directive
     * @name app.directive:ckEditor
     * @description
     * Directiva que incluye un editor de texto CKEditor.
     *
     * __Nota: No utilizar directamente. Usar el componente {@link app.component:textArea}.
     *
     * @requires app.component:textArea
     */
    angular.module('app')
        .directive('ckEditor', directive);

    /* @ngInject */
    function directive($ocLazyLoad, Language, RutasService, $window) {
        console.log("Context:", RutasService.getContext());
        $window.CKEDITOR_BASEPATH = RutasService.getContext() + '/assets/ckeditor/';

        return {
            require: '?ngModel',
            link: function (scope, elm, attr, ngModel) {
                // Ocultamos el textarea mientras no se carga el editor
                elm[0].hidden = true;

                // Cargamos el JS de CKEditor sólo cuando es necesario
                $ocLazyLoad.load({
                    name: 'CKEditor',
                    files: [
                        'assets/ckeditor/ckeditor.js'
                    ]
                }).then(function () {
                    link(scope, elm, attr, ngModel);
                });
            },
            scope: {
                tipo: '@',
                height: '@',
                max: '@',
                class: '@'
            }
        };

        function link(scope, elm, attr, ngModel) {
            // Ponemos el timestamp a null, porque si no añade un parámetro a los CSS y elementos y devuelven un 404.
            CKEDITOR.timestamp = null;

            // Instanciamos el editor
            var ck = CKEDITOR.replace(elm[0], {
                extraPlugins: 'find,justify,wordcount,html5video,html5audio'
            });

            if (!ngModel) return;
            ck.on('instanceReady', function () {
                ck.setData(ngModel.$viewValue);
            });

            function updateModel() {
                scope.$apply(function () {
                    ngModel.$setViewValue(ck.getData());
                });
            }

            ck.on('change', updateModel);
            ck.on('key', updateModel);
            ck.on('dataReady', updateModel);

            ngModel.$render = function () {
                ck.setData(ngModel.$viewValue);
            };

            // Configuración de la Toolbar

            ck.config.toolbar_basico = [
                ['Source'],
                ['Bold', 'Italic', 'Underline'],
                ['Undo', 'Redo'],
                ['Link']
            ];

            ck.config.toolbar_normal = ck.config.toolbar_estatica = [
                ['Source'],
                ['Bold', 'Italic', 'Underline'],
                ['Undo', 'Redo'],
                ['NumberedList', 'BulletedList'],
                ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'Outdent', 'Indent'],
                ['Link'],
                ['Maximize']
            ];

            ck.config.toolbar_completo = ck.config.toolbar_estatica = [
                ['Source'],
                ['Bold', 'Italic', 'Underline'],
                ['Undo', 'Redo'],
                ['Cut', 'Copy', 'Find'],
                ['NumberedList', 'BulletedList'],
                ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'Outdent', 'Indent'],
                ['Link', 'Image', 'Html5video', 'Html5audio'],
                ['Format', 'RemoveFormat'],
                ['Maximize']
            ];

            // Otras configuraciones

            ck.config.toolbar = scope.tipo;
            ck.config.height = scope.height + 'px';

            ck.config.wordcount = {
                showParagraphs: false,
                showCharCount: true,
                maxCharCount: scope.max
            };

            ck.config.language = Language.getCurrent();

            // TODO: CKFINDER. Añadir a la URL el tipo de documento que se quiere mostrar...? ?type=img,doc
            ck.config.filebrowserBrowseUrl = RutasService.getBaseUrl(true) + '/explorador-archivos';

            ck.config.contentsCss = RutasService.getContext() + '/assets/css/main.css';
            ck.config.bodyClass = scope.class;
        }
    }
})(angular);

(function () {
    'use strict';

    var buttons = {
        templateUrl: 'app/components/form/buttons/buttons.form.template.html',
        bindings: {
            canSave: '<',
            mode: '<'
        }
    };

    angular
        .module('app')
        .component('buttons', buttons);

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin/estaticas', {
                parent: 'admin',
                url: '/admin/estaticas/:nombre',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'estaticas.title'
                },
                views: {
                    'content@': {
                        template: '<estatica-form estatica="$resolve.estatica" idiomas="$resolve.idiomas"></estatica-form>',
                        controllerAs: 'ctrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    estatica: function (Estatica, $stateParams) {
                        return Estatica.getByNombre({nombre: $stateParams.nombre}).$promise.then(function (data) {
                            return data;
                        });
                    },
                    /* @ngInject */
                    idiomas: function (EnumService) {
                        return EnumService.get('idioma-app');
                    }
                },
                ncyBreadcrumb: {
                    label: 'estaticas.title'
                }
            });
    }
})();

(function (angular) {
    'use strict';

    // estatica: Objeto a modificar.
    // idiomas: Idiomas en los que pueden estar las páginas estáticas.

    angular
        .module('app')
        .component('estaticaForm', {
            bindings: {
                estatica: '<',
                idiomas: '<'
            },
            templateUrl: 'app/components/estaticas/admin/estatica-form.admin.html',
            controllerAs: 'ctrl',
            controller: function (Estatica) {
                var vm = this;

                vm.mode = 'edit';
                vm.canSave = true;

                vm.init = function (estatica, index, idioma) {
                    if (!estatica.estaticasI18n[index]) estatica.estaticasI18n[index] = {};

                    if (!estatica.estaticasI18n[index].idioma) {
                        estatica.estaticasI18n[index].idioma = idioma;
                    }
                };

                vm.validar = function () {
                    for (var i = 0; i < vm.idiomas.length; i++) {
                        var idioma = vm.idiomas[i];
                        for (var j = 0; j < vm.estatica.estaticasI18n.length; j++) {
                            var estaticaI18n = vm.estatica.estaticasI18n[j];
                            if (estaticaI18n.idioma === idioma && estaticaI18n.titulo === undefined) {
                                vm.active = i;
                                i = vm.idiomas.length;
                                break;
                            }
                        }
                    }
                };

                vm.save = function () {
                    Estatica.save(vm.estatica);
                };
            }
        });
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('logout', {
            parent: 'public',
            data: {
                authorities: ['ROLE_AUTHENTICATED']
            },
            views: {
                'content@': {
                    controller: 'LogoutController'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .controller('LogoutController', LogoutController);

    /* @ngInject */
    function LogoutController($state, Auth) {
        Auth.logout();

        $state.go('home');
    }
})();

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/subgenero";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/subgenero/subgenero",
            controller: 'SubgeneroAdminController',
            controllerForm: 'SubgeneroFormAdminController',
            translateBase: "admin.subgenero."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar
        angular.merge(state.list, {
            resolve: {

                /* @ngInject */
                tipologias: function (Tipologia) {
                    return Tipologia.findAll().$promise.then(function (data) {
                        return data.content;
                    });
                }
            }
        });


        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list);
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('SubgeneroAdminController', SubgeneroAdminController);

    /* @ngInject */
    function SubgeneroAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                    ModalService, Subgenero, tipologias) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.originalData = [];


        vm.item = Subgenero;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined
        };

        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));


        // Eliminar
        vm.showRemoveConfirmation = function (id) {


            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Subgenero.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.subgenero.delete.name',
                                body: 'admin.subgenero.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                var originalTable = vm.tableParams;
                for (i = 0; i < originalTable.data.length; i++) {
                    if (originalTable.data[i].id == id) {
                        originalTable.data.splice(i, 1);
                    }
                }

            });
        };


        //Añadir un elemento a la tabla
        vm.addElementTable = function () {

            var originalTable = vm.tableParams;

            //no se permite añadir varios simulatenamente
            if ((originalTable.data.length == 0) || (originalTable.data[0].id)) {

                var copia = {isEditing: true};
                originalTable.data.unshift(copia);
            }
        };


        //Edicion en linea: Guardar una copia de la fila que se va a editar
        vm.saveState = function (row, rowForm) {
            vm.originalData = angular.copy(row);
            var originalTable = vm.tableParams;

        };

        //Cancelar la edición de una fila
        vm.cancel = function (row, rowForm) {
            var originalTable = vm.tableParams;

            //Si se estaba añadiendo una nueva fila -> se elimina
            if (!row.id) {
                originalTable.data.shift();

            } else { //sino, se queda como estaba

                var originalRow = angular.copy(vm.originalData);
                angular.extend(row, originalRow);
                row.isEditing = false

            }
        };

        vm.save = function (row, rowForm) {

            new Subgenero(row).$save().then(function (data) {
                row.isEditing = false;
                rowForm.$setPristine();
                angular.extend(row, data);
            });

        };

        vm.tipologias = tipologias;
    }

})(angular);



(function () {
    'use strict';

    angular.module('app')
        .controller('AdminFormController', AdminFormController);

    /* @ngInject */
    function AdminFormController($timeout, $state, AlertService, Auth, roles, itemData) {
        var vm = this;


        vm.registerAccount = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';
        $timeout(function () {
            angular.element('.form-group:eq(0)>input')[0].focus();
        });

        vm.roles = roles;


        vm.register = function () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                AlertService.error("admin.register.error.dontmatch");
            } else {
                Auth.createAccount(vm.registerAccount).then(function () {
                    $state.go("admin/admin/list");
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/admin";
        var params = {
            base: base,
            parent: 'admin',
            baseUrl:  "/" + base,
            templateUrlBase: "app/admin/user/admin/admin",
            controller: 'AdminAdminController',
            controllerForm: 'AdminFormController',
            translateBase: "admin.admin."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            }
        });
        // Listar
        angular.merge(state.list, {});

        var genericResolves = {
            /* @ngInject */
            roles: function (EnumService) {
                return EnumService.get("rol").then(function (result) {
                    return result;
                });
            }
        };

        // Crear
        angular.merge(state.create, {
            resolve: angular.merge(genericResolves, {
                /* @ngInject */
                itemData: function (User) {
                    return new User();
                }
            })
        });

        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(genericResolves, {
                /* @ngInject */
                itemData: function (User, $stateParams) {
                    return User.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);

    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('AdminAdminController', AdminAdminController);

    /* @ngInject */
    function AdminAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                  ModalService, User) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.item = User;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {};
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {login: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (login) {
            ModalService.open({
                templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                controller: 'EntityDeleteModalController',
                controllerAs: 'ctrl',
                resolve: {
                    item: function () {
                        return User.get({id: login}).$promise;
                    },
                    params: function () {
                        return {
                            title: 'admin.list-users.delete.title',
                            body: 'admin.list-users.delete.confirm',
                            property: 'login'
                        };
                    }
                }
            }).result.then(function () {
                vm.tableParams.reload();
            });
        };

    }

})(angular);

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/tipologia";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/tipologia/tipologia",
            controller: 'TipologiaAdminController',
            controllerForm: 'TipologiaFormAdminController',
            translateBase: "admin.tipologia."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear


        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('TipologiaAdminController', TipologiaAdminController);

    /* @ngInject */
    function TipologiaAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                      ModalService, Tipologia) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.originalData = [];


        vm.item = Tipologia;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined
        };

        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));


        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Tipologia.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.tipologia.delete.name',
                                body: 'admin.tipologia.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                var originalTable = vm.tableParams;
                for (i = 0; i < originalTable.data.length; i++) {
                    if (originalTable.data[i].id == id) {
                        originalTable.data.splice(i, 1);
                    }
                }
            });
        };


        //Añadir un elemento a la tabla
        vm.addElementTable = function () {

            var originalTable = vm.tableParams;

            //no se permite añadir varios simulatenamente
            if ((originalTable.data.length == 0) || (originalTable.data[0].id)) {

                var copia = {isEditing: true};
                originalTable.data.unshift(copia);
            }
        };


        //Edicion en linea: Guardar una copia de la fila que se va a editar
        vm.saveState = function (row, rowForm) {
            vm.originalData = angular.copy(row);
            var originalTable = vm.tableParams;

        };

        //Cancelar la edición de una fila
        vm.cancel = function (row, rowForm) {
            var originalTable = vm.tableParams;

            //Si se estaba añadiendo una nueva fila -> se elimina
            if (!row.id) {
                originalTable.data.shift();

            } else { //sino, se queda como estaba

                var originalRow = angular.copy(vm.originalData);
                angular.extend(row, originalRow);
                row.isEditing = false

            }
        };

        vm.save = function (row, rowForm) {

            new Tipologia(row).$save().then(function (data) {
                row.isEditing = false;
                rowForm.$setPristine();
                angular.extend(row, data);
            });

        };
    }

})(angular);



/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/responsable";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/responsable/responsable",
            controller: 'ResponsableAdminController',
            controllerForm: 'ResponsableFormAdminController',
            translateBase: "admin.responsable."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar y letras
        angular.merge(state.list, {
            resolve: {
                /* @ngInject */
                letras: function (Responsable) {
                    return Responsable.findUsedLetters().$promise.then(function (data) {
                        return data;
                    });
                 }
            },
            url: '/listar/:letra/:page',
            params: {
                page:'1',
                letra: 'TODO'
             }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)


    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('ResponsableAdminController', ResponsableAdminController);

    /* @ngInject */
    function ResponsableAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                        ModalService, Responsable, AlertService, letras, $state) {
        var vm = this;

        // Letras
        vm.letras = letras;
        vm.values = {};


        vm.esCanonico = false;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.originalData = [];


        vm.item = Responsable;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            letra: $stateParams.letra,
            revisado: undefined
        };


        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));


        // Eliminar
        vm.showRemoveConfirmation = function (responsable) {

            //si tiene alguna obra, no se puede eliminar
            if ((responsable.numAutor > 0) || (responsable.numImpresor > 0) || (responsable.numEditor > 0)
                || (responsable.numTraductor > 0) || (responsable.numOtros > 0)) {
                AlertService.warning("admin.responsable.error.notdeleteablePorObras");
                return;
            }
            //si tiene alguna variante asociada, no se puede eliminar
            if ((responsable.variantes !== null) && (responsable.variantes.length > 0)) {
                AlertService.warning("admin.responsable.error.notdeleteablePorVariantes");
                return;
            }
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Responsable.get({id: responsable.id}).$promise;
                        },
                        params: function () {

                            return {
                                title: 'admin.responsable.delete.name',
                                body: 'admin.responsable.delete.confirm',
                                property: 'nombreCompleto'
                            };
                        }
                    }
                }
            ).result.then(function () {
                    var originalTable = vm.tableParams;
                    for (i = 0; i < originalTable.data.length; i++) {
                        var originalData = originalTable.data[i];

                        if (originalData.id === responsable.id) {
                            originalTable.data.splice(i, 1);
                        } else {
                            if (originalData.variantes.length > 0) {
                                for (var j = 0; j < originalData.variantes.length; j++) {
                                    if (originalData.variantes[j].id === responsable.id) {
                                        originalData.variantes.splice(j, 1);
                                    }
                                }
                            }
                        }
                    }
                }
            );
        };


        //Añadir un elemento a la tabla
        vm.addElementTable = function () {

            var originalTable = vm.tableParams;
            //no se permite añadir varios elementos simulatenamente
            if ((originalTable.data.length === 0) || (originalTable.data[0].id)) {

                var copia = {isEditing: true};
                originalTable.data.unshift(copia);
            }
        };


        //Edicion en linea: Guardar una copia de la fila que se va a editar
        vm.saveState = function (row, rowForm) {
            vm.originalData = angular.copy(row);
            var originalTable = vm.tableParams;

        };

        //Cancelar la edición de una fila
        vm.cancel = function (row, rowForm) {
            var originalTable = vm.tableParams;

            //Si se estaba añadiendo una nueva fila -> se elimina
            if (!row.id) {
                originalTable.data.shift();

            } else { //sino, se queda como estaba
                var originalRow = angular.copy(vm.originalData);
                angular.extend(row, originalRow);
                row.isEditing = false
            }
        };

        vm.setRevisado = function (data) {
            Responsable.setRevisado({id: data.id, revisado: data.revisado}).$promise.then(function () {
                vm.tableParams.reload();
            });
        };

        /**
         * responsableCanonico: es el objeto Responsable, que es un atributo de la clase Responsable
         * A mayores, tambien tiene un id_canonico y un nombre_canonico, propios del ResponsableDTO
         * es_canonico es necesario para implementar el checkbox
         * @param row
         * @param rowForm
         */
        vm.save = function (row, rowForm) {
            var originalRow = angular.copy(vm.originalData);

            var antesNumeroVariantes = null;

            if (originalRow.variantes != null) {
                antesNumeroVariantes = originalRow.variantes.length;
            }

            var antesIdCanonico = null;

            if (originalRow.responsablecanonico != null) {
                antesIdCanonico = originalRow.responsablecanonico.id;
            }

            var ahoraEsCanonico = (row.es_canonico);
            var ahoraTieneNombrecanonico = (row.responsablecanonico != null);
            var ahoraIdCanonico = null;
            if (row.responsablecanonico != null) {
                ahoraIdCanonico = row.responsablecanonico.id;
            }

            //Si tiene el nombre y el apellido en blanco -> no se puede guardar
            if (row.nombre == null && row.apellidos == null || row.nombre == '' && row.apellidos == '') {
                AlertService.warning("admin.responsable.error.responsableSinDatos");
                return;
            }

            //Si no es canonico y no le añades un nombre de canonico
            //A pesar del required, puede ocurrir
            if (!ahoraEsCanonico && !ahoraTieneNombrecanonico) {
                AlertService.warning("admin.responsable.error.responsableIncompleto");
                return;
            }

            //Si es canonico, ponemos la variable asociada responsableCanonico a null(problemas de compatibilidad con backend)
            if (ahoraEsCanonico) {
                row.responsablecanonico = null;
            }

            //Modificar responsable: Si antes era canonico, tiene variantes, y ahora se quiere convertir a variante -> no se puede ACTUALIZAR
            // (ej: si antes era canonico, y ahora lo sigue siendo, sí se podría actualizar
            if (antesIdCanonico == null && !ahoraEsCanonico && antesNumeroVariantes > 0) {
                AlertService.warning("admin.responsable.error.notdeleteablePorVariantes");
                return;
            }

            new Responsable(row).$save().then(function (data) {
                row.isEditing = false;
                rowForm.$setPristine();
                angular.extend(row, data);

                vm.tableParams.reload();
            });
        };

        //Ir a las relaciones de un autor
        vm.verRelaciones = function (id, nombre, apellidos) {
            var nombreAEnviar = "";
            if(nombre != null){
                nombreAEnviar= nombreAEnviar.concat(nombre);
            }if(apellidos != null){
                nombreAEnviar= nombreAEnviar.concat(" " + apellidos);
            }
            $state.go("admin/relacion/list", {idAutor:id, nombreAutor: nombreAEnviar});
        };

        //Ir a las ediciones de un responsable
        vm.verEdiciones = function (id, nombre, apellidos, rol) {
            var nombreAEnviar = "";
            if(nombre != null){
                nombreAEnviar= nombreAEnviar.concat(nombre);
            }if(apellidos != null){
                nombreAEnviar= nombreAEnviar.concat(" " + apellidos);
            }
            $state.go("admin/buscador/list", {idResponsable:id, nombreResponsable: nombreAEnviar, rolResponsable: rol});
        };

        vm.responsableService = Responsable;
    }
})(angular);

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/lugar";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/lugar/lugar",
            controller: 'LugarAdminController',
            controllerForm: 'LugarFormAdminController',
            translateBase: "admin.lugar."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            }
        });
        // Listar y letras
        angular.merge(state.list, {
            resolve: {
                /* @ngInject */
                letras: function (Lugar) {
                    return Lugar.findUsedLetters().$promise.then(function (data) {
                        return data;
                    });
                 }
            },
            url: '/listar/:letra/:page',
            params: {
                page:'1',
                letra: 'TODO'
             }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('LugarAdminController', LugarAdminController);

    /* @ngInject */
    function LugarAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                  ModalService, Lugar, AlertService, letras) {
        var vm = this;

        // Letras
        vm.letras = letras;
        vm.values = {};


        vm.esCanonico = false;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.originalData = [];


        vm.item = Lugar;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            letra: $stateParams.letra,
            revisado: undefined
        };


        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));


        // Eliminar
        vm.showRemoveConfirmation = function (lugar) {

            //si tiene alguna variante asociada, no se puede eliminar
            if ((lugar.variantes != null) && (lugar.variantes.length > 0)) {
                AlertService.warning("admin.lugar.error.notdeleteablePorVariantes");
                return;
            }
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        /* @ngInject */
                        item: function (Lugar) {
                            return Lugar.get({id: lugar.id}).$promise;
                        },
                        params: function () {

                            return {
                                title: 'admin.lugar.delete.name',
                                body: 'admin.lugar.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                    var originalTable = vm.tableParams;
                    for (i = 0; i < originalTable.data.length; i++) {
                        var originalData = originalTable.data[i];

                        if (originalData.id == lugar.id) {
                            originalTable.data.splice(i, 1);
                        } else {
                            if (originalData.variantes.length > 0) {
                                for (var j = 0; j < originalData.variantes.length; j++) {
                                    if (originalData.variantes[j].id == lugar.id) {
                                        originalData.variantes.splice(j, 1);
                                    }
                                }
                            }
                        }
                    }
                }
            );
        };


        //Añadir un elemento a la tabla
        vm.addElementTable = function () {

            var originalTable = vm.tableParams;
            //no se permite añadir varios elementos simulatenamente
            if ((originalTable.data.length == 0) || (originalTable.data[0].id)) {

                var copia = {isEditing: true};
                originalTable.data.unshift(copia);
            }
        };


        //Edicion en linea: Guardar una copia de la fila que se va a editar
        vm.saveState = function (row, rowForm) {
            vm.originalData = angular.copy(row);
            var originalTable = vm.tableParams;
        };

        //Cancelar la edición de una fila
        vm.cancel = function (row, rowForm) {
            var originalTable = vm.tableParams;

            //Si se estaba añadiendo una nueva fila -> se elimina
            if (!row.id) {
                originalTable.data.shift();

            } else { //sino, se queda como estaba
                var originalRow = angular.copy(vm.originalData);
                angular.extend(row, originalRow);
                row.isEditing = false
            }
        };

        // Abrir ventana modal para establecer coordenadas
        vm.openLocationModal = function (lugar) {
            ModalService.open({
                templateUrl: 'app/admin/tesauro/lugar/ubicacion/ubicacion.form.modal.html',
                controller: 'UbicacionFormController',
                controllerAs: 'ctrl',
                backdrop: 'static',
                windowClass: 'modal-map',
                size: 'lg',
                resolve: {
                    /* @ngInject */
                    item: function (Lugar) {
                        return Lugar.get({id: lugar.id}).$promise;
                    }
                }
            }).result.then(function (data) {
                // TODO: Hacer algo con la información que se devuelve?
                // var itemOriginal = vm.originalData.filter(function (r) {
                //     return r.id === row.id;
                // });
                // angular.extend(itemOriginal, data);
                // angular.extend(row, data);
            });
        };

        vm.setRevisado = function (data) {
            Lugar.setRevisado({id: data.id, revisado: data.revisado}).$promise.then(function () {
                vm.tableParams.reload();
            });
        };
        /**
         * lugarCanonico: es el objeto Lugar, que es un atributo de la clase Lugar
         * A mayores, tambien tiene un id_canonico y un nombre_canonico, propios del LugarDTO
         * es_canonico es necesario para implementar el checkbox
         * @param row
         * @param rowForm
         */
        vm.save = function (row, rowForm) {
            var originalRow = angular.copy(vm.originalData);
            var antesNumeroVariantes = originalRow.numVariantes;
            var antesIdCanonico = originalRow.id_canonico;


            var ahoraEsCanonico = (row.es_canonico);
            var ahoraTieneNombrecanonico = (row.lugarcanonico != null);
            var ahoraIdCanonico = row.id_canonico;


            //Si no es canonico y no le añades un nombre de canonico
            //A pesar del required, puede ocurrir
            if (!ahoraEsCanonico && !ahoraTieneNombrecanonico) {
                AlertService.warning("admin.lugar.error.lugarIncompleto");
                return;
            }

            //Si es canonico, ponemos la variable asociada lugarCanonico a null(problemas de compatibilidad con backend)
            if (ahoraEsCanonico) {
                row.lugarcanonico = null;
            }

            //Modificar lugar: Si antes era canonico, tiene variantes, y ahora se quiere convertir a variante -> no se puede ACTUALIZAR
            // (ej: si antes era canonico, y ahora lo sigue siendo, sí se podría actualizar
            if (antesIdCanonico == null && !ahoraEsCanonico && antesNumeroVariantes > 0) {
                AlertService.warning("admin.lugar.error.notdeleteablePorVariantes");
                return;
            }

            new Lugar(row).$save().then(function (data) {
                row.isEditing = false;
                rowForm.$setPristine();
                angular.extend(row, data);

                vm.tableParams.reload();
            });
        };
        vm.lugarService = Lugar;
    }
})(angular);

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/idioma";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/idioma/idioma",
            controller: 'IdiomaAdminController',
            controllerForm: 'IdiomaFormAdminController',
            translateBase: "admin.idioma."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar
        angular.merge(state.list, {});

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)

    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('IdiomaAdminController', IdiomaAdminController);

    /* @ngInject */
    function IdiomaAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                    ModalService, Idioma) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.originalData = [];


        vm.item = Idioma;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined
        };

        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));


        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Idioma.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.idioma.delete.name',
                                body: 'admin.idioma.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                var originalTable = vm.tableParams;
                for (i = 0; i < originalTable.data.length; i++) {
                    if (originalTable.data[i].id == id) {
                        originalTable.data.splice(i, 1);
                    }
                }
            });
        };


        //Añadir un elemento a la tabla
        vm.addElementTable = function () {

            var originalTable = vm.tableParams;

            //no se permite añadir varios simulatenamente
            if ((originalTable.data.length == 0) || (originalTable.data[0].id)) {

                var copia = {isEditing: true};
                originalTable.data.unshift(copia);
            }
        };


        //Edicion en linea: Guardar una copia de la fila que se va a editar
        vm.saveState = function (row, rowForm) {
            vm.originalData = angular.copy(row);
            var originalTable = vm.tableParams;

        };

        //Cancelar la edición de una fila
        vm.cancel = function (row, rowForm) {
            var originalTable = vm.tableParams;

            //Si se estaba añadiendo una nueva fila -> se elimina
            if (!row.id) {
                originalTable.data.shift();

            } else { //sino, se queda como estaba

                var originalRow = angular.copy(vm.originalData);
                angular.extend(row, originalRow);
                row.isEditing = false

            }
        };

        vm.save = function (row, rowForm) {

            new Idioma(row).$save().then(function (data) {
                row.isEditing = false;
                rowForm.$setPristine();
                angular.extend(row, data);
            });

        };
    }

})(angular);



/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/epiteto";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/epiteto/epiteto",
            controller: 'EpitetoAdminController',
            controllerForm: 'EpitetoFormAdminController',
            translateBase: "admin.epiteto."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar y letras
        angular.merge(state.list, {
            resolve: {
                /* @ngInject */
                letras: function (Epiteto) {
                    return Epiteto.findUsedLetters().$promise.then(function (data) {
                        return data;
                    });
                 }
            },
            url: '/listar/:letra/:page',
            params: {
                page:'1',
                letra: 'TODO'
            }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)


    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EpitetoAdminController', EpitetoAdminController);

    /* @ngInject */
    function EpitetoAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                    ModalService, Epiteto,  letras) {
        var vm = this;

        // Letras
        vm.letras = letras;


        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.originalData = [];


        vm.item = Epiteto;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            letra: $stateParams.letra
        };

        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));


        // Eliminar
        vm.showRemoveConfirmation = function (id) {


            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Epiteto.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.epiteto.delete.name',
                                body: 'admin.epiteto.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                var originalTable = vm.tableParams;
                for (i = 0; i < originalTable.data.length; i++) {
                    if (originalTable.data[i].id == id) {
                        originalTable.data.splice(i, 1);
                    }
                }

            });
        };


        //Añadir un elemento a la tabla
        vm.addElementTable = function () {

            var originalTable = vm.tableParams;

            //no se permite añadir varios simulatenamente
            if ((originalTable.data.length == 0) || (originalTable.data[0].id)) {

                var copia = {isEditing: true};
                originalTable.data.unshift(copia);
            }
        };


        //Edicion en linea: Guardar una copia de la fila que se va a editar
        vm.saveState = function (row, rowForm) {
            vm.originalData = angular.copy(row);
            var originalTable = vm.tableParams;

        };

        //Cancelar la edición de una fila
        vm.cancel = function (row, rowForm) {
            var originalTable = vm.tableParams;

            //Si se estaba añadiendo una nueva fila -> se elimina
            if (!row.id) {
                originalTable.data.shift();

            } else { //sino, se queda como estaba

                var originalRow = angular.copy(vm.originalData);
                angular.extend(row, originalRow);
                row.isEditing = false

            }
        };

        vm.save = function (row, rowForm) {

            new Epiteto(row).$save().then(function (data) {
                row.isEditing = false;
                rowForm.$setPristine();
                angular.extend(row, data);
            });

        };



    }


})(angular);



/**
 * Created by vblanco on 13/06/2017.
 */

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/catalogo";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/catalogo/catalogo",
            controller: 'CatalogoAdminController',
            translateBase: "admin.catalogo."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar
        angular.merge(state.list, {});


        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
    }
})();

/**
 * Created by vblanco on 13/062017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('CatalogoAdminController', CatalogoAdminController);

    /* @ngInject */
    function CatalogoAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                    ModalService, Catalogo) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.originalData = [];


        vm.item = Catalogo;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
        };

        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));


        // Eliminar
        vm.showRemoveConfirmation = function (id) {


            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Catalogo.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.catalogo.delete.name',
                                body: 'admin.catalogo.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                var originalTable = vm.tableParams;
                for (i = 0; i < originalTable.data.length; i++) {
                    if (originalTable.data[i].id == id) {
                        originalTable.data.splice(i, 1);
                    }
                }

            });
        };


        //Añadir un elemento a la tabla
        vm.addElementTable = function () {

            var originalTable = vm.tableParams;

            //no se permite añadir varios simulatenamente
            if ((originalTable.data.length == 0) || (originalTable.data[0].id)) {

                var copia = {isEditing: true};
                originalTable.data.unshift(copia);
            }
        };


        //Edicion en linea: Guardar una copia de la fila que se va a editar
        vm.saveState = function (row, rowForm) {
            vm.originalData = angular.copy(row);
            var originalTable = vm.tableParams;

        };

        //Cancelar la edición de una fila
        vm.cancel = function (row, rowForm) {
            var originalTable = vm.tableParams;

            //Si se estaba añadiendo una nueva fila -> se elimina
            if (!row.id) {
                originalTable.data.shift();

            } else { //sino, se queda como estaba

                var originalRow = angular.copy(vm.originalData);
                angular.extend(row, originalRow);
                row.isEditing = false

            }
        };

        vm.save = function (row, rowForm) {

            new Catalogo(row).$save().then(function (data) {
                row.isEditing = false;
                rowForm.$setPristine();
                angular.extend(row, data);
            });

        };
    }

})(angular);



/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('BibliotecaFormAdminController', BibliotecaFormAdminController);

    /* @ngInject */
    function BibliotecaFormAdminController($timeout, $state, itemData, previousParams, Principal, AlertService) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.item = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        if (vm.mode === 'edit') {
            Principal.hasAuthority("ROLE_ADMIN").then(function (esAdmin) {
                if (!esAdmin) {
                    AlertService.warning("admin.biblioteca.error.unauthorized", null, 0);
                }
            });
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                $state.go('admin/biblioteca/list', previousParams);
            });
        };
    }

})(angular);

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/biblioteca";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/biblioteca/biblioteca",
            controller: 'BibliotecaAdminController',
            controllerForm: 'BibliotecaFormAdminController',
            translateBase: "admin.biblioteca."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar
        angular.merge(state.list, {
            resolve: {
                /* @ngInject */
                letras: function (Biblioteca) {
                    return Biblioteca.findUsedLetters().$promise.then(function (data) {
                        return data;
                    });
                }
            },
            url: '/listar/:letra/:page',
            params: {
                page: '1',
                letra: 'TODO'
            }

        });


        // Crear
        angular.merge(state.create, {
            resolve: {
                /* @ngInject */
                itemData: function (Biblioteca) {
                    return new Biblioteca();
                }

            }
        });
        // Editar
        angular.merge(state.edit, {
            resolve: {
                /* @ngInject */
                itemData: function (Biblioteca, $stateParams) {
                    return Biblioteca.get({id: $stateParams.id}).$promise;
                }
            }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('BibliotecaAdminController', BibliotecaAdminController);

    /* @ngInject */
    function BibliotecaAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                       ModalService, Biblioteca, letras) {
        var vm = this;

        vm.letras = letras;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });


        vm.item = Biblioteca;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            letra: $stateParams.letra


        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {ciudad: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Biblioteca.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.biblioteca.delete.name',
                                body: 'admin.biblioteca.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        }

    }

})(angular);

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, NG_TABLE_DEFAULT_PARAMS) {
        var base = "admin/buscador";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/edicion/edicion.total/edicion.total",
            controller: 'EdicionAdminController',
            controllerForm: 'EdicionFormAdminController',
            translateBase: "admin.edicion.total"
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR'],
                pageTitle: 'ediciontotal.title'
            }
        });

        // Listar
        angular.merge(state.list, {
            url: '/listar/:page',
            params: {
                page: '1',
                filter: {sortProperty: 'titulo', sortDirection: 'ASC', size: NG_TABLE_DEFAULT_PARAMS.size},
                idResponsable: null,
                nombreResponsable: null,
                rolResponsable: null,
                idLugar: null,
                nombreLugar: null

            }, resolve: {
                /* @ngInject */
                ediciones: function () {
                    return {};
                },
                /* @ngInject */
                tipologias: function (Tipologia) {
                    return Tipologia.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                        return data.content;
                    });
                },
                /* @ngInject */
                subgeneros: function (Subgenero) {
                    return Subgenero.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                        return data.content;
                    });
                },
                /* @ngInject */
                modalidades: function (EnumService) {
                    return EnumService.get("modalidaddiscurso");
                },
                /* @ngInject */
                tamanos: function (EnumService) {
                    return EnumService.get("tamano");
                },
                /* @ngInject */
                stateParams: function ($stateParams) {
                    return $stateParams;
                }
            }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list);
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HeaderBidisoController', ["$window", HeaderBidisoController]);

    /* @ngInject */
    function HeaderBidisoController($window) {
        var vm = this;

        vm.openNav =  function () {
            $window.document.getElementById("mySidenav").style.width = "350px";
        };
        vm.closeNav = function () {
            $window.document.getElementById("mySidenav").style.width = "0";
        };
    }

})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HeaderController', HeaderController);

    /* @ngInject */
    function HeaderController() {
        var vm = this;


    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'site',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                ncyBreadcrumb: {
                    skip: true
                }
            })
            .state('accessdenied', {
                parent: 'public',
                url: '/acceso-denegado',
                data: {
                    authorities: [],
                    pageTitle: 'error.accessdenied.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                ncyBreadcrumb: {
                    skip: true
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', '$rootScope'];

    function Principal($q, Account, $rootScope) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;

            console.log("lanzando broadcast changedIdentity");
            $rootScope.$broadcast('changedIdentity');
        }

        function hasAnyAuthority(authorities) {
            if (authorities.indexOf("ROLE_ANONYMOUS") >= 0 && !_authenticated && !_identity) {
                return true;
            }

            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            if (authorities.indexOf("ROLE_AUTHENTICATED") >= 0
                && _identity.authorities && _identity.authorities.length > 0) {
                return true;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function () {
                return false;
            });
        }

        function identity(force, login) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get({login: login}).$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                console.log("lanzando broadcast changedIdentity");
                $rootScope.$broadcast('changedIdentity');
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
                $rootScope.$broadcast('changedIdentity');
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }
    }
})();

(function (angular) {
    'use strict';

    angular.module('app')
        .factory('Auth', Auth);

    /* ngInject */
    function Auth($rootScope, $state, $sessionStorage, $q, $http, AuthServerProvider, Principal, User, Password) {
        return {
            login: login,
            loginWithToken: loginWithToken,
            logout: logout,
            authorize: authorize,
            createAccount: createAccount,
            validateAccount: validateAccount,
            changePassword: changePassword,
            resetPasswordInit: resetPasswordInit,
            resetPasswordFinish: resetPasswordFinish
        };

        function validateAccount(key) {
            return $http({
                method: 'GET',
                url: 'api/public/cuenta/validar',
                params: {key: key}
            });
        }

        function login(credentials, callback) {
            /* jshint validthis:true */
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            var login = credentials.username;

            AuthServerProvider.login(credentials).then(function (jwt) {
                // retrieve the logged account information
                Principal.identity(true, login).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration

                    // $translate.use(account.langKey);
                    deferred.resolve(account);
                });
                return cb();
            }).catch(function (err) {
                this.logout();
                deferred.reject(err);
                return cb(err);
            }.bind(this));

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function authorize(force, authorities) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account'
                    && ($rootScope.toState.name === 'login'
                    || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth'
                    || $rootScope.toState.name === 'recuperar/init' || $rootScope.toState.name === 'recuperar/finish')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && (!$rootScope.fromState || !$rootScope.fromState.name) && $sessionStorage.previousStateName) {
                    var previousStateName = $sessionStorage.previousStateName;
                    var previousStateParams = $sessionStorage.previousStateParams;
                    delete $sessionStorage.previousStateName;
                    delete $sessionStorage.previousStateParams;
                    $state.go(previousStateName, previousStateParams);
                }

                if (($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities))
                    || (authorities && authorities.length > 0 && !Principal.hasAnyAuthority(authorities))) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        $sessionStorage.previousStateName = $rootScope.toState.name;
                        $sessionStorage.previousStateParams = $rootScope.toStateParams;

                        if ($rootScope.toState.name.startsWith("admin/")) {
                            // now, send them to the signin state so they can log in
                            $state.go('login');
                        } else {
                            $state.go('registro/info');
                        }
                    }
                }
            }
        }

        function createAccount(account, callback) {
            /* jshint validthis:true */
            var cb = callback || angular.noop;

            return User.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    // this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(email) {
            return $http({
                method: 'GET',
                url: 'api/public/cuenta/reset-contrasena/init',
                params: {email: email}
            });
        }

        function resetPasswordFinish(keyAndPassword) {
            return $http({
                method: 'GET',
                url: 'api/public/cuenta/reset-contrasena/finish',
                params: {
                    email: keyAndPassword.email,
                    key: keyAndPassword.key,
                    newPassword: keyAndPassword.newPassword
                }
            });
        }
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken() {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function hasValidToken() {
            var token = this.getToken();
            return token && token.expires && token.expires > new Date().getTime();
        }

        function login(credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/account/authenticate', data).then(authenticateSuccess);

            function authenticateSuccess(data) {
                var status = data.status;
                var headers = data.headers;
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if (true) {
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout() {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Account', Account);

    /* @ngInject */
    function Account($resource) {
        return $resource('api/account/account', {}, {
            'get': {
                method: 'GET',
                params: {login: '@login'},
                isArray: false,
                interceptor: {
                    response: function (response) {
                        // expose response
                        return response;
                    }
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('lugares', {
                parent: 'public',
                redirectTo: 'lugares/list',
                data: {
                    authorities: []
                }
            })
            .state('lugares/list', {
                parent: 'lugares',
                url: '/lugares',
                params: {page: {value: '1', dynamic: true}},
                data: {
                    pageTitle: 'lugares.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/public/lugar/lugares.html',
                        controller: 'LugarController',
                        controllerAs: 'ctrl'
                    }
                }
            });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('LugarController', LugarController);

    /* @ngInject */
    function LugarController($translate, Edicion, Lugar, NG_LIST_DEFAULT_PARAMS_PUBLIC_MAP) {
        var vm = this;
        var page = 0;
        var filtros;
        vm.lugares = [];
        vm.entidades = [];
        vm.tipoBD = []; // Por ahora no se utiliza. Pero esto ayuda a preparar la generalización para múltiples BD
        vm.tiposEntidad = [];
        vm.tipoEntidad = "CBDRS_EDICION";
        vm.tipoEntidadFecha = "CBDRS_EDICION";
        vm.loadingEntidades = false;

        // *** Mapa

        var map = L.map('mymap', {
            center: [10.0, 5.0],
            minZoom: 2,
            zoom: 2
        });

        L.Icon.Default.imagePath = 'assets/images/static/leaflet';

        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }
        ).addTo(map);

        var markerClusters = L.markerClusterGroup({zoomToBoundsOnClick: false, spiderfyOnMaxZoom: false});
        map.addLayer(markerClusters);

        markerClusters.on('clusterclick', function (a) {
            showEntidades(a.layer.getAllChildMarkers());
        });

        markerClusters.on('click', function (a) {
            showEntidades([a.layer]);
        });

        function populateMap() {
            markerClusters.clearLayers();
            var markersTemp = [];
            var greenIcon = L.icon({
                iconSize: [40, 40], // size of the icon
                iconUrl: L.Icon.Default.imagePath + '/marker-icon.png'
            });
            vm.lugares.forEach(function (item) {
                var lugar = item;
                if (item.lugarcanonico) {
                    lugar = item.lugarcanonico;
                }

                if (lugar && lugar.lat && lugar.lng) {
                    var marker = {
                        lat: lugar.lat,
                        lng: lugar.lng,
                        focus: true
                    };
                    // A mayores almacenamos el ID del objeto EntidadToponimo para luego recuperarlo
                    markersTemp.push(L.marker(marker, {id: item.id, title: item.nombre, icon: greenIcon}));
                }
            });
            markerClusters.addLayers(markersTemp);
            console.log("Número de markers:" + vm.lugares.length);
        }

        var activeClass = 'btn-primary-public';

        // Añadir un control (botón) para filtrar por tipo de entidad en el mapa
        function crearFiltroMapa(tipo) {
            var MapControl = L.Control.extend({
                options: {
                    position: 'topright'
                },
                onAdd: function (map) {
                    var container = L.DomUtil.create('div', 'ctrl-tipo btn btn-xs btn-default');
                    if (tipo == vm.tipoEntidad) {
                        container.classList.add(activeClass);
                    }

                    container.textContent = $translate.instant('tipos.tiposentidad.select.lugar.' + tipo);

                    L.DomEvent.addListener(container, 'click', function () {
                        angular.forEach(document.getElementsByClassName("ctrl-tipo"), function (element) {
                            element.classList.remove(activeClass);
                        });

                        container.classList.add(activeClass);
                        changeTipoEntidad(tipo);
                    });
                    return container;
                }
            });
            return new MapControl();
        }

        function addFiltroPorTipoToMap() {
            vm.tiposEntidad.forEach(function (tipo) {
                map.addControl(crearFiltroMapa(tipo));
            });
        }

        // Fin mapa ***

        // Obtener entidades por topónimo (cluster seleccionado)
        vm.showEntidades = function (markers) {
        };

        function showEntidades(markers) {
            clearEntidades();

            vm.loadingEntidades = true;
            vm.tipoEntidadActiva = vm.tipoEntidad;

            var markerIds = [];
            markers.forEach(function (marker) {
                markerIds.push(marker.options.id);
            });

            filtros = getFiltros();
            filtros.toponimoIds = markerIds;
            $("html, body").animate({scrollTop: $('#listado').offset().top - 50}, 1000);

            Edicion.filterGis(filtros).$promise.then(function (data) {
                vm.entidades = data.content;
                vm.loadingEntidades = false;
                filtros.totalElements = data.totalElements;
            });
        }

        // Filtro por años

        vm.filtro = {
            anoInicioEdicion: null,
            anoFinEdicion: null
        };

        vm.filtrar = function () {
            console.log("Filtrando");
            clearEntidades();

            Lugar.filterGis(getFiltros()).$promise.then(function (result) {
                vm.lugares = result;
                populateMap();

            });
        };

        vm.filtrar();

        function changeTipoEntidad(tipo) {
            vm.tipoEntidad = tipo;
            vm.filtrar();
        }

        // Filtros de búsqueda
        function getFiltros() {
            return {
                tipoEntidad: vm.tipoEntidad,
                tipoEntidadFecha: vm.tipoEntidadFecha,
                inicio: vm.filtro.anoInicioEdicion,
                fin: vm.filtro.anoFinEdicion,
                nombreLugar: vm.filtro.nombreLugar,
                revisado: true,
                size: NG_LIST_DEFAULT_PARAMS_PUBLIC_MAP.size,
                page: page,
                totalElements: 0
            }
        }

        vm.tiposEntidad = ["CBDRS_EDICION", "CBDRS_RELACION"];
        addFiltroPorTipoToMap();

        // Infinite Scroll. Obtenemos todas las entidades pero las vamos mostrando poco a poco
        function clearEntidades() {
            vm.entidades = [];
            vm.items = [];
            //se inicializa así porque solo se usa en loadMoore y cuando entra ahí es para obtener la segunda pagina
            vm.begin = NG_LIST_DEFAULT_PARAMS_PUBLIC_MAP.size;
        }

        clearEntidades();

        //cada vez que llega abajo de la lista, se lanza una peticion al servidor y trae los siguientes 50 elementos
        vm.loadMore = function () {
            if (vm.entidades && vm.entidades.length && (vm.begin < filtros.totalElements)) {
                vm.loadingEntidades = true;
                var max = NG_LIST_DEFAULT_PARAMS_PUBLIC_MAP.size;
                filtros.page += 1;
                Edicion.filterGis(filtros).$promise.then(function (data) {
                    vm.items = data.content;
                    vm.loadingEntidades = false;
                    for (var i = 0; i < (vm.items.length); i++) {
                        vm.entidades.push(vm.items[i]);
                    }
                    vm.begin += max;
                });
            }
        };

        vm.lugarService = Lugar;
        vm.edicionService = Edicion;

    }
})
(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'public',
            url: '/',
            redirectTo: 'buscador',             // Redireccion al buscador simple
            data: {
                pageTitle: 'global.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'ctrl'
                }
            }
        })
        ;
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HomeController', HomeController);

    /* @ngInject */
    function HomeController($timeout, $stateParams) {
        var vm = this;
    }

})(angular);

/**
 * Created by vblanco on 28/08/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    //Aquí defino el estado de edicion details
    /* @ngInject */
    function stateConfig($stateProvider) {
        //ESTADO ABSTRACTO

        $stateProvider.state('ejemplarDetails', {
            parent: 'edicionDetails',

            url: '/ejemplar/:ejemplarId',
            data: {
                pageTitle: 'ejemplarDetails.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/ejemplar/ejemplar.details.html',
                    controller: 'EjemplarDetailsController',
                    controllerAs: 'ctrlDetails'
                }
            },
            // Listar
            resolve: {
                /* @ngInject */
                ejemplar: function (Ejemplar, $stateParams) {
                    return Ejemplar.get({id: $stateParams.ejemplarId}).$promise.then(function (data) {
                        return data;
                    });
                }
            }
        });
    }
})();


(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EjemplarDetailsController', EjemplarDetailsController);

    /* @ngInject */
    function EjemplarDetailsController($stateParams, RutasService, ejemplar) {
        var vm = this;

        vm.ejemplar = ejemplar;

        vm.urlBaseTranscrito = RutasService.getEjemplarTranscritoUrl($stateParams.ejemplarId);
        vm.urlBaseDigitalizado = RutasService.getEjemplarDigitalizadoUrl($stateParams.ejemplarId);

        // Gallery
        vm.paginas = [];
        if(vm.ejemplar.paginas!= null){
            vm.ejemplar.paginas.forEach(function (pagina) {
                if (pagina.path) {
                    vm.paginas.push({
                        id: pagina.id,
                        url: 'upload/ejemplares/' + vm.ejemplar.id + '/pagsDigitalizadas' + '/' + pagina.path,
                        thumbUrl: 'upload/ejemplares/' + vm.ejemplar.id + '/pagsDigitalizadas' + '/n_' + pagina.path
                    });
                }
            });
        }

    }

})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EdicionDetailsController', EdicionDetailsController);

    /* @ngInject */
    function EdicionDetailsController($timeout, $stateParams, edicion) {
        var vm = this;

        vm.edicion = edicion;
        vm.responsables = edicion.responsables;

        vm.editores = vm.responsables.filter(function (elemento) {
            return elemento.rol === "EDIT";
        });

        vm.impresores = vm.responsables.filter(function (elemento) {
            return elemento.rol === "IMPR";
        });

        vm.traductores = vm.responsables.filter(function (elemento) {
            return elemento.rol === "TRAD";
        });

        vm.otros = vm.responsables.filter(function (elemento) {
            return elemento.rol === "OTRO";
        });

        // Gallery
        //Mostrar las imágenes aquí tiene su dificultad, dado que hay que separarlas por cada ilustración
        //Lo que se ha hecho, es añadir un campo en cada edicion.ilustraciones[numeroIlustracion], que será una lista con las imagenes (elem multimedia asociados)
        vm.numeroIlustracion = 0;
        vm.edicion.ilustraciones.forEach(function (ilustracion) {
            vm.imagenesAux= [];
            ilustracion.imagenes.forEach(function (imagen) {
                if (imagen.path) {
                    vm.imagenesAux.push({
                        id: imagen.id,
                        url: 'upload/ediciones/' + vm.edicion.id + '/ilustraciones' + '/' + ilustracion.id + '/' + imagen.path,
                        thumbUrl: 'upload/ediciones/' + vm.edicion.id + '/ilustraciones' + '/' + ilustracion.id + '/n_' + imagen.path
                    });
                }
            });
            vm.edicion.ilustraciones[vm.numeroIlustracion].imagenesMostrar= [];
            vm.edicion.ilustraciones[vm.numeroIlustracion].imagenesMostrar = vm.imagenesAux;
            vm.numeroIlustracion++;
        });
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    //Aquí defino los 3 estados: abstracto, edicion list y edicion details
    /* @ngInject */
    function stateConfig($stateProvider, NG_LIST_DEFAULT_PARAMS_PUBLIC) {
        $stateProvider.state('buscador', {
            parent: 'public',
            url: '/ediciones',
            redirectTo: 'buscador/basico',
            data: {
                authorities: []
            },
            resolve: {
                ediciones: function () {
                    return {};
                }
            }
            //  Estado en el buscador básico
        }).state('buscador/basico', {
            parent: 'buscador',
            url: '/buscador-basico/p/:page',
            data: {
                pageTitle: 'edicionList.title'
            },
            params: {
                page: {value: '1', dynamic: true},
                filter: {
                    sortProperty: 'autor',
                    sortDirection: 'ASC',
                    size: NG_LIST_DEFAULT_PARAMS_PUBLIC.size
                }
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/edicion/buscador.basico.edicion.html',
                    controller: 'BuscadorController',
                    controllerAs: 'ctrl'
                }
            }

            //ESTADO En el buscador avanzado
        }).state('buscador/avanzado', {
            parent: 'buscador',
            url: '/buscador-avanzado/p/:page',
            data: {
                pageTitle: 'edicionList.title'
            },
            params: {
                page: {value: '1', dynamic: true},
                filter: {
                    sortProperty: 'autor',
                    sortDirection: 'ASC',
                    size: NG_LIST_DEFAULT_PARAMS_PUBLIC.size
                }
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/edicion/buscador.avanzado.edicion.html',
                    controller: 'BuscadorController',
                    controllerAs: 'ctrl'
                }
            },
            // Listar
            resolve: {
                /* @ngInject */
                tipologias: function (Tipologia) {
                    return Tipologia.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                        return data.content;
                    });
                },
                /* @ngInject */
                subgeneros: function (Subgenero) {
                    return Subgenero.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                        return data.content;
                    });
                },
                /* @ngInject */
                modalidades: function (EnumService) {
                    return EnumService.get("modalidaddiscurso");
                },
                /* @ngInject */
                tamanos: function (EnumService) {
                    return EnumService.get("tamano");
                }
            }

            //ESTADO DETAILS
        }).state('edicionDetails', {
            parent: 'buscador',

            url: '/BDRS:bdrs/:edicionId',
            data: {
                pageTitle: 'edicionDetails.title'
            },
            params: {
                relacionId: 'relacionId'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/edicion/edicion.details.html',
                    controller: 'EdicionDetailsController',
                    controllerAs: 'ctrlDetails'
                }
            },
            // Listar
            resolve: {
                /* @ngInject */
                edicion: function (Edicion, $stateParams) {
                    return Edicion.publicGet({id: $stateParams.edicionId}).$promise.then(function (data) {
                        return data;
                    });
                },
                /* @ngInject */
                ejemplares: function (Ejemplar, $stateParams) {
                    return Ejemplar.findEjemplaresDTOByEdicion({id: $stateParams.edicionId}).$promise.then(function (data) {
                        return data;
                    });
                },
                /* @ngInject */
                edicionesHermanas: function (Edicion, $stateParams) {
                    return Edicion.findByRelacion({
                        edicionId: $stateParams.edicionId,
                        bdrs: $stateParams.bdrs
                    }).$promise.then(function (data) {
                        return data;
                    });
                }
            }
        });
    }
})();


(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('BuscadorController', BuscadorController);

    /* @ngInject */
    function BuscadorController(Edicion, Exportar, ediciones, $state, $stateParams, ModalService, JsonUtils) {
        var vm = this;
        var todasSeleccionadas = false;

        vm.filter = $stateParams.filter;
        vm.pagina = $stateParams.page;

        vm.buscar = function (pageChange) {
            if (!vm.filter.sortProperty) {
                vm.filter.sortProperty = 'autor';
            }

            // Se utiliza una variable para que la página activa sólo se modifique cuando se hayan cargado los datos.
            var pagina = vm.pagina;
            if (!pageChange) {
                pagina = 1;
            }
            vm.filter.page = pagina - 1;

            Edicion.publicSearch(vm.filter).$promise.then(function (data) {
                data.content.forEach(function (element) {
                    element.titulo = corregirTitulo(element.titulo);
                });
                angular.extend(ediciones, data);

                vm.pagina = pagina;
                $state.go(".", {filter: vm.filter, page: vm.pagina}, {notify: false});
            });
        };

        vm.cambiarCriterioOrdenacion = function (sortProperty) {
            vm.filter.sortProperty = sortProperty;
            vm.buscar(false);
        };

        //seleccionar todos los elementos de una pagina a exportar -> si ya están marcados todos, se desmarca
        vm.seleccionarTodas = function () {
            if (!todasSeleccionadas) {
                ediciones.content.forEach(function (element) {
                    element.seleccionada = true;
                    todasSeleccionadas = true;
                });
            } else {
                ediciones.content.forEach(function (element) {
                    element.seleccionada = false;
                    todasSeleccionadas = false;
                });
            }
        };

        vm.exportarAPDF = function () {
            var edicionesAExportar = [];
            ediciones.content.forEach(function (element) {
                if (element.seleccionada) {
                    edicionesAExportar.push(element.id);
                }
            });
            var filterPdf = angular.copy(vm.filter);
            filterPdf.edicionesAExportar = edicionesAExportar;
            filterPdf.formatoExportacion = 'PDF';
            return Exportar.exportar(filterPdf);
        };

        //Enviar por email: abrir ventana modal
        vm.enviarEmail = function () {
            var edicionesAExportar = [];
            ediciones.content.forEach(function (element) {
                if (element.seleccionada) {
                    edicionesAExportar.push(element.id);
                }
            });
            var filterPdf = angular.copy(vm.filter);
            filterPdf.edicionesAExportar = edicionesAExportar;
            filterPdf.formatoExportacion = 'EMAIL';

            ModalService.open({
                templateUrl: 'app/public/edicion/email/email.form.modal.html',
                controller: 'EmailFormController',
                controllerAs: 'ctrl',
                resolve: {
                    /* @ngInject */
                    item: function () {
                        return filterPdf;
                    }
                }
            }).result.then(function (data) {
            });
        };



        // Abrir ventana modal para ver las instrucciones para la búsqueda
        vm.openInstructions = function () {
            ModalService.open({
                templateUrl: 'app/public/edicion/ayuda/ayuda.modal.html',
                controller: 'AyudaController',
                controllerAs: 'ctrl',
                size: 'lg'
            });
        };

        // Limpiar formulario y hacer búsqueda
        vm.clear = function () {
            var filterCopy = angular.copy(vm.filter);
            JsonUtils.cleanJson(vm.filter);
            vm.filter.size = filterCopy.size;
            vm.buscar(false);
        };


        vm.cambiarBuscador = function (avanzado) {
            // vm.clear();
            // Se ponen a null los campos que no tiene el otro buscador y se mantienen el resto.
            if (avanzado) {
                vm.filter.general = null;
                vm.filter.persona = null;
                vm.filter.anoEdicion = null;

                $state.go("buscador/avanzado", {filter: vm.filter});
            } else {
                vm.filter.tituloRelacion = null;
                vm.filter.autor = null;
                vm.filter.anonima = null;
                vm.filter.lugarAcontecimiento = null;
                vm.filter.bdrs = null;
                vm.filter.anoInicioAcontecimiento = null;
                vm.filter.anoFinAcontecimiento = null;
                vm.filter.sinAnoAcontecimiento = null;
                vm.filter.modalidadDiscurso = null;
                vm.filter.tamano= null;
                vm.filter.impresor = null;
                vm.filter.sinImpresor = null;
                vm.filter.editor = null;
                vm.filter.traductor = null;
                vm.filter.otrosRoles = null;
                vm.filter.idioma = null;
                vm.filter.tipologia = null;
                vm.filter.subgenero = null;
                vm.filter.biblioteca = null;
                vm.filter.pais = null;
                vm.filter.epiteto = null;
                vm.filter.variasEdiciones = null;
                vm.filter.tieneIlustraciones = null;


                $state.go("buscador/basico", {filter: vm.filter});
            }
        };

        function corregirTitulo(titulo) {
            if (!titulo.endsWith(".")) {
                titulo = titulo.concat(".");
            }
            return titulo;
        }

        // Hacemos una búsqueda inicial
        vm.buscar(true);
    }
})
(angular);

/**
 * Created by vblanco on 28/08/2017.
 */

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    //Aquí defino el estado de edicion details
    /* @ngInject */
    function stateConfig($stateProvider) {
        //ESTADO ABSTRACTO

        $stateProvider.state('bibliotecaDetails', {
            parent: 'ejemplarDetails',

            url: '/biblioteca/:idBiblioteca',
            data: {
                pageTitle: 'bibliotecaDetails.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/biblioteca/biblioteca.details.html',
                    controller: 'BibliotecaDetailsController',
                    controllerAs: 'ctrlDetails'
                }
            },
            // Listar
            resolve: {
                /* @ngInject */
                biblioteca: function (Biblioteca, $stateParams) {
                    return Biblioteca.get({id: $stateParams.idBiblioteca}).$promise.then(function (data) {
                        return data;
                    });
                }
            }
        });
    }
})();


(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('BibliotecaDetailsController', BibliotecaDetailsController);

    /* @ngInject */
    function BibliotecaDetailsController($timeout, $stateParams) {
        var vm = this;

        vm.esBuscadorBasico = true;
        // console.log(vm.esBuscadorBasico);

        vm.pagina = $stateParams.page ? $stateParams.page : 1;
    }

})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('ResourceHelper', ResourceHelper);

    // La ruta para las operaciones de crear, actualizar y eliminar es la de admin.

    /* @ngInject */
    function ResourceHelper($resource) {

        return {
            getResource: getResource
        };

        function getResource(entidad, params, newFunctions, publico) {
            var functions = {
                'query': {
                    method: 'GET',
                    url: 'api/public/' + entidad + '/query',
                    isArray: true
                },
                'get': {
                    method: 'GET',
                    url: 'api/public/' + entidad + '/:id',
                    isArray: false
                },
                'findAll': {
                    method: 'GET',
                    url: 'api/public/' + entidad + '/findAll',
                    isArray: false
                }
            };
            angular.extend(functions, newFunctions);

            var baseUrl = 'admin';
            if (publico) {
                baseUrl = 'public';
            }

            return $resource('api/' + baseUrl + '/' + entidad + '/:id', params, functions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['AlertService'];

    function notificationInterceptor(AlertService) {
        var service = {
            response: response
        };

        return service;

        function response(response) {
            var alertKey = response.headers('X-app-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, {param: response.headers('X-app-params')});
            }
            return response;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (!(response.status === 401 && response.data &&
                (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account/account') === 0 )))) {
                $rootScope.$emit('app.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$localStorage', '$sessionStorage'];

    function authInterceptor($localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request(config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;

            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }

            return config;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

/**
 * Created by vblanco on 08/06/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Tipologia', Tipologia);

    /* @ngInject */
    function Tipologia($resource) {
        return $resource('api/admin/tipologia/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/tipologia/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/tipologia/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/tipologia/findAll'
            }
        });
    }
})();

/**
 * Created by vblanco on 12/06/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Subgenero', Subgenero);

    /* @ngInject */
    function Subgenero($resource) {
        return $resource('api/admin/subgenero/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/subgenero/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/subgenero/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/subgenero/findAll'
            },
            'findAllTipologias': {
                method: 'GET',
                isArray: false,
                url: 'api/public/tipologia/findAll'
            }
        });
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Responsable', Responsable);

    /* @ngInject */
    function Responsable($resource) {
        return $resource('api/admin/responsable/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/responsable/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/responsable/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/responsable/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/responsable/findUsedLetters'
            },
            'simpleFilter': {
                method: 'GET',
                isArray: false,
                url: 'api/public/responsable/simpleFilter'
            },
            'canonicoFilter': {
                method: 'GET',
                isArray: false,
                url: 'api/public/responsable/canonicoFilter'
            },
            'setRevisado': {
                method: 'POST',
                isArray: false,
                url: 'api/admin/responsable/setRevisado'
            }
        });
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Lugar', Lugar);

    /* @ngInject */
    function Lugar($resource) {
        return $resource('api/admin/lugar/:id', {}, {
            'updateCoordenadas': {
                method: 'POST',
                isArray: false,
                url: 'api/admin/lugar/updateCoordenadas'
            },
            'setRevisado': {
                method: 'POST',
                isArray: false,
                url: 'api/admin/lugar/setRevisado'
            },
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/lugar/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/lugar/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/lugar/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/lugar/findUsedLetters'
            },
            'simpleFilter': {
                method: 'GET',
                isArray: false,
                url: 'api/public/lugar/simpleFilter'
            },
            'canonicoFilter': {
                method: 'GET',
                isArray: false,
                url: 'api/public/lugar/canonicoFilter'
            },
            'filterGis': {
                method: 'GET',
                isArray: true,
                url: 'api/public/lugar/filterGis'
            }
        });
    }
})();

/**
 * Created by vblanco on 08/06/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Idioma', Idioma);

    /* @ngInject */
    function Idioma($resource) {
        return $resource('api/admin/idioma/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/idioma/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/idioma/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/idioma/findAll'
            }
        });
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Epiteto', Epiteto);

    /* @ngInject */
    function Epiteto($resource) {
        return $resource('api/admin/epiteto/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/epiteto/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/epiteto/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/epiteto/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/epiteto/findUsedLetters'
            }
        });
    }
})();

/**
 * Created by vblanco on 13/06/2017.
 */

(function () {
    'use strict';

    angular.module('app')
        .factory('Catalogo', Catalogo);

    /* @ngInject */
    function Catalogo($resource) {
        return $resource('api/admin/catalogo/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/catalogo/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/catalogo/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/catalogo/findAll'
            }
        });
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Biblioteca', Biblioteca);

    /* @ngInject */
    function Biblioteca($resource) {
        return $resource('api/admin/biblioteca/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/biblioteca/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/biblioteca/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/biblioteca/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/biblioteca/findUsedLetters'
            }
            ,
            'findAllPaises': {
                method: 'GET',
                isArray: false,
                url: 'api/public/biblioteca/findAllPaises'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .service('ParseLinks', ParseLinks);

    /* @ngInject */
    function ParseLinks() {
        this.parse = function (header) {
            if (angular.isUndefinedOrNull(header)) {
                return {};
            }

            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function ($0, $1, $2, $3) {
                        queryString[$1] = $3;
                    }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        };
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .service('MediaService', MediaService);

    /* @ngInject */
    function MediaService($window) {
        this.esMovil = function(){
            return $window.innerWidth < 1170;
        };
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .directive('compile', ['$compile', function ($compile) {
            return function (scope, element, attrs) {
                scope.$watch(
                    function (scope) {
                        // watch the 'compile' expression for changes
                        return scope.$eval(attrs.compile);
                    },
                    function (value) {
                        // when the 'compile' expression changes
                        // assign it into the current DOM
                        element.html(value);

                        // compile the new DOM and link it to the current
                        // scope.
                        // NOTE: we only compile .childNodes so that
                        // we don't get into infinite loop compiling ourselves
                        $compile(element.contents())(scope);
                    }
                );
            };
        }])
})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .directive('hasNoAuthority', hasNoAuthority);

    function hasNoAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasNoAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            console.log("Result: " + result);
                            if (result) {
                                setHidden();
                            } else {
                                setVisible();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            if (attrs.hasAnyAuthority === "") {
                return;
            }

            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('hasAnyAuthorityOrState', hasAnyAuthorityOrState);

    function hasAnyAuthorityOrState(Principal, $state) {
        var directive = {
            restrict: 'A',
            link: linkFunc,
            replace: false,
            scope: {
                authorities: "=",
                states: "="
            }
        };
        return directive;

        function linkFunc(scope, element) {

            var setVisible = function () {
                element.removeClass('hidden');
            };
            var setHidden = function () {
                element.addClass('hidden');
            };

            var defineVisibility = function (reset) {
                var result = true;

                if (reset) {
                    setVisible();
                }

                if (scope.authorities) {
                    var authorities = scope.authorities.replace(/\s+/g, '').split(',');
                    result = result && Principal.hasAnyAuthority(authorities);

                }
                if (scope.states) {
                    var states = scope.states.replace(/\s+/g, '').split(',');
                    var results = states.filter(function (state) {
                        return $state.includes(state);
                    });
                    result = result && results.length;
                }

                if (result) {
                    setVisible();
                } else {
                    setHidden();
                }
            };

            if (scope.authorities) {
                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }

            if (scope.states) {
                scope.$on('$stateChangeSuccess',
                    function () {
                        defineVisibility(true);
                    }
                );
            }

            if (scope.authorities || scope.states) {
                defineVisibility(true);
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('NgTableHelper', NgTableHelper);

    /* @ngInject */
    function NgTableHelper($state) {
        return {
            settings: settings
        };

        function settings(vm) {
            var firstLoad = true;

            if (!vm.function) {
                vm.function = "findAll";
            }

            return {
                defaultSort: 'asc',
                counts: [],
                getData: function (params) {
                    if (firstLoad) {
                        vm.loading = true;
                    }
                    firstLoad = false;

                    var sortProperty = null;
                    var sortDir = null;
                    if (params.orderBy()[0]) {
                        sortProperty = params.orderBy()[0].replace("-", "").replace("+", "");
                        sortDir = params.sorting()[sortProperty].toUpperCase();
                    }

                    var request = {
                        size: vm.elementosPorPagina,
                        page: params.page() - 1,
                        sortProperty: sortProperty,
                        sortDirection: sortDir,
                        query: vm.filter.key
                    };

                    angular.extend(request, vm.filter);

                    // Modificamos la URL con el nuevo número de página
                    $state.go('.', {page: params.page()}, {notify: false});

                    // return [{
                    //     "id": 1,
                    //     "nombre": "Paquito",
                    //     "variantes": [{"id": 2, "nombre": "Variante de Paquito"}, {
                    //         "id": 3,
                    //         "nombre": "Variante de Paquito2"
                    //     }]
                    // }, {"id": 4, "nombre": "Otro", "variantes": [{"id": 5, "nombre": "Variante de Otro"}]}];

                   return  vm.item[vm.function](request).$promise.then(function (data) {
                        vm.loading = false;
                        if (Array.isArray(data)) {
                            params.total(data.length);
                            params.count(data.length);
                            vm.empty = !data || data.length == 0;
                            return data;
                        } else {
                            params.total(data.totalElements);
                            vm.empty = !data.content || data.content.length == 0;
                            return data.content;
                        }
                    });
                }
            }
        }
    }
})
();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .directive('submenu', submenuDirective);

    submenuDirective.$inject = [];

    function submenuDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                menu: '='
            },
            templateUrl: 'app/components/menu/submenu.html'
        };
    }
})(angular);

(function (angular) {
    'use strict';

    angular
        .module('app')
        .factory('Menu', Menu);

    Menu.$inject = ['$q', '$http'];

    function Menu($q, $http) {
        return {
            getMenu: getMenu
        };

        function getMenu(position) {
            var deferred = $q.defer();
            $http.get('menu/' + position + '.json').then(function (response) {
                deferred.resolve(response.data);
            });

            return deferred.promise;
        }
    }
})(angular);

(function (angular) {
    'use strict';

    /**
     * Requires directives:
     *   * has-any-authority-or-state
     *   * uib-dropdown-toggle
     */
    angular
        .module('app')
        .component('miMenu', {
            bindings: {
                menu: '<',
                navCollapsed: '<',
                modal: '&',
                lateral: '<'
            },
            templateUrl: 'app/components/menu/menu.html',
            /* @ngInject */
            controller: function ($state, EstaticaModal, $scope, $window, MediaService) {
                var vm = this;

                vm.checkActiveStates = function (activeStates) {
                    var active = false;
                    if (activeStates) {
                        var states = activeStates.replace(/\s+/g, '').split(',');
                        states.forEach(function (state) {
                            if ($state.includes(state)) {
                                active = true;
                            }
                        });
                    }
                    return active;
                };

                vm.modal = function (id) {
                    EstaticaModal.open(id);
                };

                vm.itemClick = function(){
                    if (vm.esMovil) {
                        vm.navCollapsed = !vm.navCollapsed;
                    }
                };

                function resize() {
                    vm.esMovil = MediaService.esMovil();
                }

                angular.element($window).on('resize', function () {
                    resize();
                    $scope.$apply();
                });
                resize();
            }
        });
})(angular);

/**
 * Based on:
 *
 * The MIT License (MIT)
 * Copyright (c) 2015 Eugenio Lentini
 * https://github.com/blackat/ui-navbar
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .directive('menuItem', menuItemDirective);

    menuItemDirective.$inject = ['$compile'];

    function menuItemDirective($compile) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/menu/menu-item.html',
            link: function (scope, element, attrs) {
                if (angular.isArray(scope.leaf.subtree)) {
                    element.append('<submenu menu="leaf.subtree"></submenu>');

                    // find the parent of the element
                    var parent = element.parent();
                    var classFound = false;

                    // check if in the hierarchy of the element exists a dropdown with class navbar-right
                    while (parent.length > 0 && !classFound) {
                        // check if the dropdown has been push to right
                        if (parent.hasClass('navbar-right')) {
                            classFound = true;
                        }
                        parent = parent.parent();
                    }

                    // add a different class according to the position of the dropdown
                    if (classFound) {
                        element.addClass('dropdown-submenu-right');
                    } else {
                        element.addClass('dropdown-submenu');
                    }

                    $compile(element.contents())(scope);
                }
            },
            scope: {
                leaf: '='
            }
        };
    }
})(angular);

(function (angular) {
    'use strict';

    /**
     * Requires directives:
     *   * has-any-authority-or-state
     *   * uib-dropdown-toggle
     */
    angular
        .module('app')
        .component('miMenuBidiso', {
            bindings: {
                menu: '<',
                navCollapsed: '<',
                lateral: '<'
            },
            templateUrl: 'app/components/menu/menu-bidiso.html',
            /* @ngInject */
            controller: function ($state) {
                var vm = this;

                vm.checkActiveStates = function (activeStates) {
                    var active = false;
                    if (activeStates) {
                        var states = activeStates.replace(/\s+/g, '').split(',');
                        states.forEach(function (state) {
                            if ($state.includes(state) || state === 'lugares') {
                                active = true;
                            }
                        });
                    }
                    return active;
                };
            }
        });
})(angular);

(function () {
    'use strict';

    // Campos:
    // isLoading: Campo para saber si está oculto o no.
    // class: Clase a mayores de la de por defecto.
    // img: Ruta al icono de carga. Por defecto loading.svg

    var loading = {
        template: '<img ng-show="$ctrl.isLoading" ' +
        'ng-src="{{$ctrl.img || \'assets/images/loading.svg\'}}" ' +
        'class="loading {{$ctrl.class}}"/>',
        bindings: {
            isLoading: '<',
            class: '@',
            img: '@'
        }
    };

    angular
        .module('app')
        .component('loading', loading);

})();

(function (angular) {
    'use strict';

    angular.module('app')
        .service('ModalService', ModalService);

    /* @ngInject */
    function ModalService($uibModal, AlertService) {
        var opened = false;
        var modal = null;

        return {
            opened: function () {
                return opened;
            },
            open: open,
            close: close,
            dismiss: dismiss
        };

        function open(params) {
            if (modal) {
                modal.close();
            }

            opened = true;
            modal = $uibModal.open(params);

            // En caso de que se pulse fuera de la modal, hacemos un dismiss
            modal.result.catch(function (data) {
                if (data === 'backdrop click') {
                    dismiss(data);
                }
            });

            AlertService.clear();
            return modal;
        }

        function close(data) {
            console.log("close");
            opened = false;
            modal.close(data);
        }

        function dismiss(data) {
            console.log("dismiss");
            opened = false;
            modal.dismiss(data);
        }
    }

})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('LetrasService', LetrasService);

    /* @ngInject */
    function LetrasService(Unaccent) {

        return {
            getMapaLetras: getMapaLetras
        };

        // Creación de un mapa cuya clave son las letras del alfabeto y su valor los elementos que comienzan por esa letra.
        // No se tienen en cuenta mayúsculas ni símbolos.
        function getMapaLetras(elementos, atributo) {
            var tmp = {};
            var letter = '';
            for (var i = 0; i < elementos.length; i++) {
                if (elementos[i][atributo] === undefined) {
                    letter = '-';
                } else {
                    letter = Unaccent.unaccent(elementos[i][atributo].charAt(0).toUpperCase());
                    if (!letter.match(/^[a-zA-Z]+$/)) {
                        letter = Unaccent.unaccent(elementos[i][atributo].charAt(1).toUpperCase());
                    }
                }
                if (tmp[letter] === undefined) {
                    tmp[letter] = [];
                }
                tmp[letter].push(elementos[i]);
            }
            return tmp;
        }

    }

})();

(function (angular) {
    'use strict';

    // elementos: Mapa<Letra, List<Object>>. Mapa cuya clave son las letras del alfabeto y su valor los elementos que comienzan por dicha letra.
    // estado: String. Nombre del estado al que ir.
    // sinvalor: String. Añade un botón a la lista de letras que permite saltar a los elementos que no tienen nombre.
    // en caso de no estar vacío. Se le pasa el nombre de la entidad de acuerdo al fichero de mensajes.

    // Se necesita utilizar la operación LetrasService.getMapaLetras para generar el mapa, ignorando mayúsculas y símbolos.

    angular
        .module('app')
        .component('letras', {
            bindings: {
                elementos: '<',
                estado: '@',
                sinvalor: '<',
                todos: '<'
            },
            templateUrl: 'app/components/letras/letras.html',
            /* @ngInject */
            controller: function (ALFABETOingles, $state, $stateParams) {
                var vm = this;
                vm.alfabeto = ALFABETOingles.toUpperCase();
                vm.letraSeleccionada = $stateParams.letra;

                // FIXME: Este sistema es bastante ineficiente.
                // Igual sería mejor generar una única vez una lista que tenga la letra y si tiene elementos.
                // Así no se haría el bucle por cada letra del abecedario.
                // Tal vez el Mapa ya debería traer todas las letras. Para eso habría que modificar la operación de LetrasService.getMapaLetras.

                // Función que comprueba si la letra contiene elementos
                vm.letraContenidaElementos = function (letter) {
                    if ((letter == 'TODO') && ( vm.elementos.length > 0)){
                        return true;
                    }
                    for (i = 0; i < vm.elementos.length; i++) {
                        if (letter == vm.elementos[i]) {
                            return true;
                        }
                    }
                    return false;
                };

                vm.showByLetter = function (letra) {
                    var params = angular.copy($stateParams);
                    params.page = 1;
                    params.letra = letra;
                    $state.go($state.current, params);
                }

            },
            controllerAs: 'ctrl'

        });

})(angular);

(function (angular) {
    'use strict';

    angular.module('app').factory('Language', factory);

    factory.$inject = ['$translate'];

    function factory($translate) {
        return {
            getCurrent: getCurrent
        };

        function getCurrent() {
            if ($translate.use()) return $translate.use();
            return $translate.preferredLanguage();
        }
    }
})(angular);

(function () {
    'use strict';

    angular.module('app')
        .directive('showValidation', showValidation);

    function showValidation() {
        var directive = {
            require: 'form',
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element) {
            element.find('.form-group').each(function () {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function () {
                        var $input = angular.element(this);
                        scope.$watch(function () {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function (isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

/* globals $ */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('radio', radio);

    function radio() {
        return {
            restrict: 'E',
            scope: {
                name: '@',
                model: '=',
                change: '=',
                value: '=',
                label: '@',
                text: '='
            },
            template: '' +
            '<label ng-click="model=value"><input type="radio" name="{{name}}" ng-model="model" ng-value="value"' +
            ' ng-checked="model==value" ng-click="model=value" ng-change="change"/>' +
            '<span class="texto" ng-if="label">{{label | translate}}</span>' +
            '<span class="texto" ng-if="text" ng-bind-html="text"></span></label>',

            compile: function (tElt) {
                tElt.addClass('sm-radio');
            }
        };
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name app.filter:unsafe
     * @description
     * Cuando se utiliza la directiva `ngBindHtml`, al HTML se le eliminan las etiquetas _style_.
     * Añadiendo el filtro `unsafe`, el HTML se muestra tal cual es.
     *
     * @returns {String} Se marca el HTML como que es de confianza, por lo que no sufre modificaciones.
     */
    angular
        .module('app')
        .filter('unsafe', filter);

    /* @ngInject */
    function filter($sce) {
        return filter;

        function filter(input) {
            return $sce.trustAsHtml(input);
        }
    }
})();

/**
 * Filters out all duplicate items from an array by checking the specified key
 * @param [key] {string} the name of the attribute of each object to compare for uniqueness
 if the key is empty, the entire object will be compared
 if the key === false then no filtering will be performed
 * @return {array}
 */
// Acepta dos niveles de filtrado. Ejemplo en fuentes.form.modal.html
angular.module('app').filter('unique', function () {

    return function (items, filterOn, filterOnSecondLevel) {

        if (filterOn === false) {
            return items;
        }

        if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
            var hashCheck = {}, newItems = [];

            var extractValueToCompare = function (item) {
                if (angular.isObject(item) && angular.isString(filterOn)) {
                    if (filterOnSecondLevel && angular.isString(filterOnSecondLevel)) {
                        if (item[filterOn]) {
                            return item[filterOn][filterOnSecondLevel];
                        } else {
                            return item[filterOn];
                        }
                        // FIXME: Creo que está añadiendo los elementos vacíos también
                    } else {
                        return item[filterOn];
                    }
                } else {
                    return item;
                }
            };

            angular.forEach(items, function (item) {
                var valueToCheck, isDuplicate = false;

                for (var i = 0; i < newItems.length; i++) {
                    if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                        isDuplicate = true;
                        break;
                    }
                }
                if (!isDuplicate) {
                    newItems.push(item);
                }

            });
            items = newItems;
        }
        return items;
    };
});

(function (angular) {
    'use strict';

    // String to Int
    angular.module('app').filter('num', function () {
        return function (input) {
            return parseInt(input, 10);
        }
    });

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter(input) {
            if (input && input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function (angular) {
    'use strict';

    angular.module('app').config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('estatica', {
            parent: 'site',
            url: '/estatica/:id',
            params: {
                language: ['Language',
                    function (Language) {
                        return Language.getCurrent();
                    }
                ]
            },
            data: {
                authorities: []
            },
            // FIXME: Se puede comprobar si existe la página? En caso de que no exista, apuntar a una que sí. Si no, la página se queda en blanco sin dar error.
            views: {
                'content@': {
                    templateUrl: function (params) {
                        return 'estaticas/' + params.id + '/' + params.id + '.' + params.language + '.html';
                    }
                }
            }
        });
    }
})(angular);

(function () {
    'use strict';

    angular.module('app')
        .factory('Estatica', Service);

    /* @ngInject */
    function Service($resource) {
        return $resource('api/admin/estaticas/:id', {}, {
            'get': {
                method: 'GET',
                url: 'api/public/estaticas/:id'
            },
            'getByNombre': {
                method: 'GET',
                url: 'api/public/estaticas/nombre/:nombre'
            },
            'getByNombreIdioma': {
                method: 'GET',
                url: 'api/public/estaticas/getByNombreIdioma'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/estaticas/findAll'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .service('EstaticaModal', EstaticaModal);

    // TODO: Mejora: Se podría refactorizar haciendo que la plantilla fuese el header y footer del modal y el contenido un include de la página en concreto.
    // TODO: Sólo acepta páginas estáticas

    /* @ngInject */
    function EstaticaModal(ModalService, Language) {
        return {
            open: open
        };

        /**
         * @param id nombre del archivo
         */
        function open(id) {
            ModalService.open({
                    templateUrl: function () {
                        return 'estaticas/' + id + '/' + id + '.' + Language.getCurrent() + '.html';
                    },
                    /* @ngInject */
                    controller: function Controller(ModalService, title) {
                        var vm = this;

                        vm.title = title;
                        vm.close = function () {
                            ModalService.dismiss();
                        };

                    },
                    controllerAs: 'ctrl',
                    resolve: {
                        title: function () {
                            return 'estatica.' + id + ".title"
                        }
                    }
                }
            );
        }
    }

})();

(function (angular) {
    'use strict';

    // id: Identificador de la página estática. (Nombre del archivo o identificador de BD).
    // carpeta: Ruta a la página en caso de que haya alguna carpeta intermedia.
    // bd: Boolean. Si se obtiene de BD, se carga el archivo estatica.html y se muestra el contenido.
    // sinTitulo: Boolean. Si es true, el título de la sección se ocultará.

    // TODO: Recargar página estática cuando se cambia de idioma.

    angular
        .module('app')
        .component('estatica', {
            bindings: {
                id: '@', // required
                carpeta: '@',
                bd: '<',
                sinTitulo: '<',
                clase: '@'
            },
            /* @ngInject */
            templateUrl: function ($element, $attrs, Language) {
                if ($attrs.bd === "true") {
                    return 'app/components/estaticas/estatica.html';
                } else {
                    var carpeta = "";
                    if ($attrs.carpeta) {
                        carpeta = $attrs.carpeta + "/";
                    }
                    return 'estaticas/' + carpeta + $attrs.id + '/' + $attrs.id + '.' + Language.getCurrent() + '.html';
                }
            },
            /* @ngInject */
            controller: function (Estatica, Language, $attrs) {
                var vm = this;
                Estatica.getByNombreIdioma({
                    'nombre': $attrs.id,
                    'idioma': Language.getCurrent()
                }).$promise.then(function (data) {
                    vm.estaticai18n = data;
                });
            },
            controllerAs: 'ctrl'
        });
})(angular);

(function () {
    'use strict';

    // value: Valor booleano (true/false -> Sí/No).

    var booleano = {
        template: '{{"enum.boolean." + ctrl.value | translate}}',
        controllerAs: 'ctrl',
        bindings: {
            value: '@'
        }
    };

    angular
        .module('app')
        .component('booleano', booleano);

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('exploradorArchivos', {
            url: '/explorador-archivos',
            data: {
                pageTitle: 'exploradorArchivos.title',
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'filemanager@': {
                    template: '<explorador-archivos></explorador-archivos>'
                }
            },
            resolve: {
                /* @ngInject */
                authorize: function (Auth) {
                    return Auth.authorize();
                },
                /* @ngInject */
                isFilemanager: function ($rootScope) {
                    $rootScope.isFilemanager = true;
                },
                isAdmin: function ($rootScope) {
                    $rootScope.isAdmin = true;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:exploradorArchivos
     * @description
     * Componente que muestra un explorador de archivos.
     *
     * Se integra con CKEditor y permite seleccionar archivos.
     *
     * También permite edición de ciertos archivos y previsualización.
     *
     * Referencia: https://github.com/joni2back/angular-filemanager
     *
     * __Requiere__ AngularFilemanager y ocLazyLoad.
     */
    angular
        .module('app')
        .component('exploradorArchivos', {
            template: '<span oc-lazy-load="FileManagerApp">' +
            '<angular-filemanager></angular-filemanager>' +
            '</span>',
            controllerAs: 'ctrl',
            controller: Controller
        });

    /* @ngInject */
    function Controller($injector, $ocLazyLoad) {
        // Cargamos los archivos necesarios de angular-filemanager y CKEditor.
        $ocLazyLoad.load({
            name: 'FileManagerApp',
            files: [
                'assets/bower/angular-filemanager/angular-filemanager.min.js',
                'assets/bower/angular-filemanager/angular-filemanager.min.css',
                'assets/ckeditor/ckeditor.js',
                'assets/js/file-manager.service.js'
            ]
        }).then(function () {
            var FileManagerService = $injector.get('FileManagerService');

            // TODO: Se puede parametrizar la configuración para recibir información. Ejemplo: tipo de elementos que hay que mostrar
            FileManagerService.config();
        });

    }

})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('RelacionFormAdminController', RelacionFormAdminController);

    /* @ngInject */
    function RelacionFormAdminController($timeout, $state, itemData, Principal, AlertService, Responsable, Lugar,
                                         tipologias, subgeneros, previousParams) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.item = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole =  Principal.identity().$$state.value.role;

        if (vm.mode === 'edit') {
            Principal.hasAuthority("ROLE_ADMIN").then(function (esAdmin) {
                if (!esAdmin && vm.item.nombreUsuario != vm.userName) {
                    AlertService.warning("admin.relacion.error.unauthorized", null, 0);
                }
            });
        }

        // Guardar formulario
        vm.save = function () {
            if (vm.item.tipologiaPrincipal == null && vm.item.subgeneroPrincipal != null
                || vm.item.tipologiaAlternativa == null && vm.item.subgeneroAlternativo != null) {
                AlertService.warning("admin.relacion.error.subgenerosintipologia");
                return;
            }
            if (vm.mode === 'edit') {
                vm.item.$save().then(function (data) {
                    $state.go('admin/relacion/list', previousParams);
                });
            }
            if (vm.mode === 'create') {
                vm.item.$save().then(function (data) {
                    $state.go('admin/edicion/list', {relacionId: data.id});
                });
            }
        };

        vm.tipologias = tipologias;
        vm.subgeneros = subgeneros;
        vm.responsableService = Responsable;
        vm.lugarService = Lugar;
    }

})(angular);

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/relacion";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/relacion/relacion",
            controller: 'RelacionAdminController',
            controllerForm: 'RelacionFormAdminController',
            translateBase: "admin.relacion."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']

            }
        });


        // Listar
        angular.merge(state.list, {
            url: '/listar/:page',
            params: {
                page: '1',
                idAutor: null,
                nombreAutor: null,
                idLugar: null,
                nombreLugar: null
            }
        });

        var resolve = {
            /* @ngInject */
            tipologias: function (Tipologia) {
                return Tipologia.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                    return data.content;
                });
            },
            /* @ngInject */
            subgeneros: function (Subgenero) {
                return Subgenero.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                    return data.content;
                });
            }
        };

        // Crear
        angular.merge(state.create, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Relacion) {
                    return new Relacion();
                }
            })
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Relacion, $stateParams) {
                    return Relacion.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('RelacionAdminController', RelacionAdminController);

    /* @ngInject */
    function RelacionAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                     ModalService, Relacion, $translate, Principal) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });


        vm.item = Relacion;

        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole =  Principal.identity().$$state.value.role;

        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            revisado: undefined,
            repasado: undefined,
            idAutor: $stateParams.idAutor,
            nombreAutor: $stateParams.nombreAutor,
            idLugar: $stateParams.idLugar,
            nombreLugar: $stateParams.nombreLugar
        };

        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {titulo: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Relacion.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.relacion.delete.name',
                                body: 'admin.relacion.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        }

    }

})(angular);

(function () {
    'use strict';

    // base: Clave base para el fichero de mensajes.
    // value: Valor.

    var enumerado = {
        template: '{{enumCtrl.base + "." + enumCtrl.value | translate}}',
        controllerAs: 'enumCtrl',
        bindings: {
            value: '@',
            base: '@'
        }
    };

    angular
        .module('app')
        .component('enumerado', enumerado);

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('EnumService', EnumService);

    /* @ngInject */
    function EnumService($http, $q) {
        var cache = {};

        return {
            get: get
        };

        function get(tipo) {
            if (cache[tipo]) {
                var defered = $q.defer();
                var promise = defered.promise;
                defered.resolve(cache[tipo]);
                return promise;
            }

            // FIXME: Así sea cachea durante la sesión. Una vez se recarga la página la caché se pierde. Se puede también cachear la petición cambiando la URL base (lo que está en /api no se cachea)
            return $http.get('api/public/enum/' + tipo, {cache: true}).then(function (result) {
                cache[tipo] = result.data;
                return result.data;
            });
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name app.component:descargar
     * @description
     * Componente que permite la descarga de un archivo, mostrando un icono u otro en función de la extensión del mismo.
     *
     * @param {Object} archivo Nombre del archivo
     * @param {String} url URL del directorio donde se encuentra el archivo
     * @param {String} [texto=ctrl.archivo] Texto que se mostrará.
     * Si no se indica ninguno, se mostrará el nombre del archivo. Si se indica cadena vacía, no se mostrará ningún texto.
     * @param {String} [titulo='descargar.titulo'] Texto que se muestra al poner el ratón sobre el enlace
     * @param {Boolean} [mostrarBoton=false] Booleano para indicar si el elemento se muestra en formato botón o como un link
     *
     */
    angular.module('app')
        .component('descargar', {
            templateUrl: 'app/components/descargar/descargar.html',
            controllerAs: 'ctrl',
            controller: Controller,
            bindings: {
                archivo: '<',
                url: '@',
                texto: '@',
                titulo: '@',
                mostrarBoton: '<'
            }
        });

    function Controller() {
        var vm = this;

        // Valores por defecto
        // Si se envía un string vacío, entonces no se mostrará texto.
        if (vm.texto === undefined) {
            vm.texto = vm.archivo;
        }
        vm.titulo = vm.titulo || "descargar.titulo";

        //

        vm.descargarArchivo = function () {
            window.open(vm.url + vm.archivo, '_blank');
        };

        vm.getClase = function () {
            var extension = vm.archivo.split('.').pop();
            switch (extension) {
                // Documentos
                case 'pdf':
                    return 'fa fa-file-pdf-o';
                case 'txt':
                case 'text':
                    return 'fa fa-file-text-o';
                case 'doc':
                case 'docx':
                    return 'fa fa-file-word-o';
                case 'xls':
                case 'xlsx':
                    return 'fa fa-file-excel-o';
                case 'ppt':
                case 'pptx':
                    return 'fa fa-file-powerpoint-o';
                case 'html':
                    return 'fa fa-file-code-o';
                // Vídeos
                case 'mp4':
                case 'webm':
                case 'avi':
                    return 'fa fa-file-video-o';
                // Audios
                case 'mp3':
                case 'ogg':
                    return 'fa fa-file-audio-o';
                // Imágenes
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'bmp':
                case 'gif':
                    return 'fa fa-file-image-o';
                // Otros
                case 'zip':
                    return 'fa fa-file-archive-o';
                default:
                    return 'fa fa-download';
            }
        }
    }

})();

(function () {
    'use strict';

    //

    var date = {
        template: '{{ctrl.result | date:ctrl.format}}',
        bindings: {
            model: '<', // required
            format: '@',
            fecha: '<',
            hora: '<'
        },
        /* @ngInject */
        controller: function ($scope) {
            var vm = this;
            if (!vm.format) {
                if (vm.fecha) {
                    vm.format = 'dd/MM/yyyy';
                } else {
                    if (vm.hora) {
                        vm.format = 'HH:mm';
                    } else {
                        vm.format = 'dd/MM/yyyy, HH:mm';
                    }
                }
            }

            function init() {
                // Si recibimos la fecha del servidor, convertimos segundos a milisegundos
                if (angular.isNumber(vm.model)) {
                    vm.result = vm.model * 1000;
                }
            }

            $scope.$watch(function () {
                return vm.model;
            }, function () {
                init();
            });
        },
        controllerAs: 'ctrl'
    };

    angular
        .module('app')
        .component('date', date);

})();

(function () {
    'use strict';

    angular
        .module('app')
        .provider('AlertService', AlertService);

    function AlertService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function (isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService($timeout, $sce, $translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                clearPermanent: clearPermanent,
                get: get,
                success: success,
                error: error,
                info: info,
                warning: warning
            };

            function isToast() {
                return toast;
            }

            function getTimeout(time) {
                if (time == null) return timeout;
                return time;
            }

            function clear() {
                alerts.splice(0, alerts.length);
            }

            function clearPermanent() {
                alerts.forEach(function (alert, index) {
                    if (alert.timeout == 0) {
                        alerts.splice(index, 1);
                    }
                });
            }

            function get() {
                return alerts;
            }

            function success(msg, params, time, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, time, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, time, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, time, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: getTimeout(time),
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if (!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function (e) {
                    return e.id;
                }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';

    var alert = {
        template: '<div class="alerts" ng-cloak="" ng-show="!$ctrl.modalService() || ($ctrl.modal && $ctrl.modalService())">' +
        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
        '<div uib-alert ng-cloak="" type="{{alert.type}}" ng-class="\'alert-\' + alert.type" close="alert.close($ctrl.alerts)">' +
        '<span ng-bind-html="alert.msg"></span></div>' +
        '</div>' +
        '</div>',
        controller: alertController,
        bindings: {
            modal: '<'
        }
    };

    angular
        .module('app')
        .component('alert', alert);

    /* @ngInject */
    function alertController($scope, AlertService, ModalService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = AlertService.get();
        vm.modalService = ModalService.opened;

        function addErrorAlert(message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
            // Si se produce un error se sube al principio de la página para ver el alert
            angular.element("html, body").animate({scrollTop: 0}, "slow");
        }

        // TODO: Adaptar. Crear ficheros de mensajes.

        var cleanHttpErrorListener = $rootScope.$on('app.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            console.log("Mostrando error");
            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    addErrorAlert('Server not reachable', 'error.servernotreachable');
                    break;

                case 400:
                    var errorHeader = httpResponse.headers('X-app-error');
                    var entityKey = httpResponse.headers('X-app-params');

                    if (errorHeader) {
                        var entityName = $translate.instant('global.menu.entities.' + entityKey);
                        addErrorAlert(errorHeader, errorHeader, {entityName: entityName});

                    } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                        for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                            var fieldError = httpResponse.data.fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = $translate.instant('jhipsterJwtApp.' + fieldError.objectName + '.' + convertedField);
                            addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                        }

                    } else if (httpResponse.data && httpResponse.data.message) {
                        if (httpResponse.data.errors) {
                            // TODO: Meter en un bucle.
                            // Estos errores nunca deberían llegar a mostrarse a no ser que se salten las restricciones del cliente
                            if (httpResponse.data.errors[0].code == 'NotNull') {
                                addErrorAlert("error.notnulls", null, null);
                            } else if (httpResponse.data.errors[0].code == 'Size') {
                                addErrorAlert("error.size", null, null);
                            }
                        } else {
                            addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                        }
                    }
                    break;

                case 401:
                    break;

                case 403:
                    addErrorAlert('Access is denied', 'error.accessdenied.title');
                    break;

                case 404:
                    addErrorAlert('Not found', 'error.notfound');
                    break;

                case 500:
                    // Internal Server Error
                    addErrorAlert('Internal server error', 'error.internalservererror');
                    break;

                default:
                    if (httpResponse.data && httpResponse.data.message) {
                        if (httpResponse.data.error === 'Internal Server Error') {
                            addErrorAlert('Internal server error', 'error.internalservererror');
                        } else {
                            addErrorAlert(httpResponse.data.message);
                        }
                    }
            }
        });

        $scope.$on('$destroy', function () {
            if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                cleanHttpErrorListener();
                vm.alerts = [];
            }
            vm.alerts = [];
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('contrasena', {
            parent: 'admin',
            url: '/admin/modificar-contrasena',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR'],
                pageTitle: 'admin.register.title'
            },
            views: {
                'content@': {
                    template: '<div class="row"><div class="col-md-8 col-md-offset-2">' +
                    '<h1 translate="admin.changepassword.title"></h1><change-password></change-password>' +
                    '</div></div>'
                }
            },
            ncyBreadcrumb: {
                skip: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'admin',
            url: '/login',
            data: {
                authorities: [],
                pageTitle: 'login.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'loginCtrl'
                }
            },
            ncyBreadcrumb: {
                skip: true
            }
        });
    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('LoginController', LoginController);

    /* @ngInject */
    function LoginController($state, $timeout, Auth, Principal, AlertService, ADMIN_PRINCIPAL) {
        var vm = this;

        vm.user = {};
        vm.rememberMe = false;

        Principal.identity().then(function () {
            $state.go(ADMIN_PRINCIPAL);
        });

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.login = function () {
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $state.go(ADMIN_PRINCIPAL);
            }).catch(function () {
                AlertService.error("login.form.error.authentication");
            });
        }
    }

})(angular);

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

        function stateConfig($stateProvider) {
                $stateProvider.state('admin/ejemplar/usuario', {
                    parent: 'admin',
                    url: '/admin/ejemplares/:creadorLogin',
                    redirectTo: 'admin/ejemplar/usuario/list',
                    data: {
                         pageTitle: 'admin.ejemplar.ejemplar',
                         authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']
                     },
                     ncyBreadcrumb: {
                         skip: true
                     },
                    views: {
                        'content@': {
                            templateUrl: 'app/admin/ejemplar/ejemplar.usuario.list.html',
                            controller: 'EjemplarUsuarioAdminController',
                            controllerAs: 'ctrl'
                        }
                    }
                }).state('admin/ejemplar/usuario/list', {
                    parent: 'admin/ejemplar/usuario',
                    url: '/listar/:page',
                    params: {
                        page: {value: '1', dynamic: true}
                    },
                    ncyBreadcrumb: {
                        label: 'admin.ejemplar.list.title'
                    }
                });
            }

})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EjemplarUsuarioAdminController', EjemplarUsuarioAdminController);

    /* @ngInject */
    function EjemplarUsuarioAdminController($stateParams, Ejemplar, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper) {

        var vm = this;

        vm.item = Ejemplar;
        vm.function = "findEjemplaresByCreador";
        vm.creador = $stateParams.creadorLogin;

        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            login: $stateParams.creadorLogin,
            key: undefined,
            id: $stateParams.edicionId,
            revisado: undefined,
            publicado: undefined
        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {'edicion.ultimaModificacion': 'desc'}
        }, NgTableHelper.settings(vm));

        vm.secondsToDate = function (seconds) {

            var date = new Date(seconds * 1000);

            return fixDate(date.getDate(), 2) + "-" + fixDate(date.getMonth() + 1, 2) + "-" + fixDate(date.getFullYear(), 4)
            + " " + fixDate(date.getHours(), 2) + ":" + fixDate(date.getMinutes(), 2) + ":" + fixDate(date.getSeconds(), 2);

        };

        function fixDate (number, expectedLength) {

            var result = new String(number);
            while (result.length < expectedLength) result = "0" + result;

            return result;

        }

    }

})(angular);

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EjemplarFormAdminController', EjemplarFormAdminController);

    /* @ngInject */
    function EjemplarFormAdminController($timeout, $state, itemData, previousParams, Principal, AlertService,
                                         Biblioteca, RutasService, encuadernaciones) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.item = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';
        vm.urlBaseTranscrito = RutasService.getEjemplarTranscritoUrl(vm.item.id);
        vm.urlBaseDigitalizado = RutasService.getEjemplarDigitalizadoUrl(vm.item.id);

        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole = Principal.identity().$$state.value.role;

        if (vm.mode === 'edit') {
            Principal.hasAuthority("ROLE_ADMIN").then(function (esAdmin) {
                if (!esAdmin && vm.item.nombreUsuario != vm.userName) {
                    AlertService.warning("admin.ejemplar.error.unauthorized", null, 0);
                }
            });
        }

        // Guardar formulario
        //El ejemplar tiene una pagina digitalizada en blanco (utilizada para situar el boton de "añadir" en el componente
        //Si dicha pagina se elimina, se produce un efecto visual no deseado al darle a "guardar"
        //Por eso, creo una copia del ejemplar, que será al que le hago las modificaciones, y que le envío al servidor
        vm.save = function () {
            vm.otroEjemplar = angular.copy(vm.item);


            //No se sabe por que, pero se crea automaticamente una pagina nula al final de la lista de paginas, con esto se elimina
            if (vm.otroEjemplar.paginas.length == 1) {
                vm.otroEjemplar.paginas = [];
            }

            else {
                //Se eliminaba el último elemento (en blanco) Esto ahora se hace en el servidor, ya que de la otra manera, probocaba un comportamiento
                if (vm.otroEjemplar.paginas[(vm.otroEjemplar.paginas.length - 1)].nombre == null) {
                    vm.otroEjemplar.paginas.splice((vm.otroEjemplar.paginas.length - 1));
                }
            }
            vm.otroEjemplar.$save().then(function () {
                $state.go('admin/ejemplar/list', previousParams);
            });
        };

        vm.bibliotecaService = Biblioteca;
        vm.encuadernaciones = encuadernaciones;

    }

})(angular);

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/ejemplar";
        var params = {
            base: base,
            baseUrl: "/:edicionId/ejemplar",
            templateUrlBase: "app/admin/ejemplar/ejemplar",
            controller: 'EjemplarAdminController',
            controllerForm: 'EjemplarFormAdminController',
            translateBase: "admin.ejemplar.",
            parent: "admin/edicion"
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']

            },
            resolve: {
                /* @ngInject */
                edicion: function ($stateParams, Edicion) {
                    console.log("!!!Cargando la edicion!!!");
                    return Edicion.getNombre({id: $stateParams.edicionId}).$promise;
                }
            },
            ncyBreadcrumb: {
                parent: "admin/edicion/list"
            }
        });

        // Listar
        angular.merge(state.list, {
            url: '/listar/:page',
            params: {
                page: '1'
            }
        });

        var resolve = {
            /* @ngInject */
            encuadernaciones: function (EnumService) {
                return EnumService.get("encuadernacion");
            }
        };

        // Crear
        angular.merge(state.create, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Ejemplar, $stateParams) {
                    var ejemplar = new Ejemplar();
                    ejemplar.edicion = {id: $stateParams.edicionId};
                    return ejemplar;
                }
            })
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Ejemplar, $stateParams) {
                    return Ejemplar.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EjemplarAdminController', EjemplarAdminController);

    /* @ngInject */
    function EjemplarAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                       ModalService, Ejemplar, Principal) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });


        vm.item = Ejemplar;

        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole =  Principal.identity().$$state.value.role;

        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            id: $stateParams.edicionId,
            revisado: undefined,
            publicado: undefined
        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {signatura: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Ejemplar.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.ejemplar.delete.name',
                                body: 'admin.ejemplar.delete.confirm',
                                property: 'signatura'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        }

    }

})(angular);

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
        function stateConfig($stateProvider) {
            $stateProvider.state('estadisticas', {
                parent: 'admin',
                url: '/admin/estadisticas',
                data: {
                    pageTitle: 'admin.estadisticas.title'
                },
                ncyBreadcrumb: {
                    label: "admin.estadisticas.title",
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/estadisticas/estadisticas.html',
                        controller: 'EstadisticasController',
                        controllerAs: 'ctrl'
                    }
                }
            })
            ;
        }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EstadisticasController', EstadisticasController);

    /* @ngInject */
    function EstadisticasController($timeout, $stateParams, Estadisticas, Principal) {

        var vm = this;

        // Estadisticas

        Estadisticas.getEstadisticas().$promise.then(function(result) {

            vm.ejemplaresRevisadosPublicados = addDots(result.ejemplaresRevisadosPublicados);
            vm.ejemplaresNoRevisadosNoPublicados = addDots(result.ejemplaresNoRevisadosNoPublicados);
            vm.obrasAutor = addDots(result.obrasAutor);
            vm.obrasNoAutor = addDots(result.obrasNoAutor);

        });

    }

    function addDots (number) {

        var numberStr = String(number);
        var numberNew = "";


        for (var i = numberStr.length - 1; i >= 0; i--) {

            numberNew = numberStr[i] + numberNew;
            if (i != numberStr.length - 1 && i != 0 && (numberStr.length - i) % 3 == 0) numberNew = "." + numberNew;

        }

        return numberNew;

    }

})(angular);

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EdicionFormAdminController', EdicionFormAdminController);

    /* @ngInject */
    function EdicionFormAdminController($timeout, $state, itemData, Principal, AlertService, Responsable, Lugar, Catalogo, Epiteto, Idioma,
                                        roles, tamanos, portadas, tipoletras, modalidaddiscursos, relacion, previousParams) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.item = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        if (!vm.item.titulo) {
            vm.item.titulo = relacion.titulo;
        }

        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole = Principal.identity().$$state.value.role;

        if (vm.mode === 'edit') {
            Principal.hasAuthority("ROLE_ADMIN").then(function (esAdmin) {
                if (!esAdmin && vm.item.nombreUsuario != vm.userName) {
                    AlertService.warning("admin.edicion.error.unauthorized", null, 0);
                }
            });
        }


        /**
         * Guardar formulario
         * Hay que comprobar los campos que representan a otras entidades del modelo (o enumerados) que tienen relacion
         * ManyToOne con esta entidad, porque si tenían un valor, se elimina y se guarda, hay que ponerlo a null desde aquí
         */
        vm.save = function () {

            //para cada ilustración es necesario borrar la última imagen adjunta (es nula)
            //Si dicha imagen se elimina, se produce un efecto visual no deseado al darle a "guardar"
            //Por eso, creo una copia de la edición, que será a la que le hago las modificaciones, y que le envío al servidor
            vm.copiaItem = angular.copy(vm.item);

            vm.copiaItem.ilustraciones.forEach(function (copiaItem) {

                if (copiaItem.imagenes.length == 1) {
                    copiaItem.imagenes = [];
                } else {
                    if (copiaItem.imagenes[(copiaItem.imagenes.length - 1)].nombre == null) {
                        copiaItem.imagenes.splice((copiaItem.imagenes.length - 1));
                    }
                }
            });
            if (vm.mode === 'edit') {
                vm.copiaItem.$save().then(function (data) {
                    $state.go('admin/edicion/list', previousParams);
                });
            }
            if (vm.mode === 'create') {
                vm.copiaItem.$save().then(function (data) {
                    $state.go('admin/ejemplar/list', {edicionId: data.id});
                });
            }
        };

        vm.responsableService = Responsable;
        vm.lugarService = Lugar;
        vm.roles = roles;
        vm.catalogoService = Catalogo;
        vm.epitetoService = Epiteto;
        vm.idiomaService = Idioma;
        vm.tamanos = tamanos;
        vm.portadas = portadas;
        vm.tipoletras = tipoletras;
        vm.modalidaddiscursos = modalidaddiscursos;

    }

})(angular);

/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/edicion";
        var params = {
            base: base,
            baseUrl: "/:relacionId/edicion",
            templateUrlBase: "app/admin/edicion/edicion",
            controller: 'EdicionAdminController',
            controllerForm: 'EdicionFormAdminController',
            translateBase: "admin.edicion.",
            parent: "admin/relacion"
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']

            },
            resolve: {
                /* @ngInject */
                relacion: function ($stateParams, Relacion) {
                    console.log("!!!Cargando la relación!!!");
                    return Relacion.getNombreAndBdrs({id: $stateParams.relacionId}).$promise;
                }
            },
            ncyBreadcrumb: {
                parent: "admin/relacion/list"
            }
        });

        // Listar
        angular.merge(state.list, {
            url: '/listar/:page',
            params: {
                page: '1'
            }
        });

        var resolve = {
            /* @ngInject */
            roles: function (EnumService) {
                return EnumService.get("rol-responsable");
            },
            /* @ngInject */
            tamanos: function (EnumService) {
                return EnumService.get("tamano");
            },
            /* @ngInject */
            portadas: function (EnumService) {
                return EnumService.get("portada");
            },
            /* @ngInject */
            tipoletras: function (EnumService) {
                return EnumService.get("tipoletra");
            },
            /* @ngInject */
            modalidaddiscursos: function (EnumService) {
                return EnumService.get("modalidaddiscurso");
            }
        };

        // Crear
        angular.merge(state.create, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Edicion, $stateParams) {
                    var edicion = new Edicion();
                    edicion.relacion = {id: $stateParams.relacionId};
                    return edicion;
                }
            })
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Edicion, $stateParams) {
                    return Edicion.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EdicionAdminController', EdicionAdminController);

    /* @ngInject */
    function EdicionAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                    ModalService, Edicion, JsonUtils, Principal) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });


        vm.item = Edicion;
        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole =  Principal.identity().$$state.value.role;


        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        if ($stateParams.relacionId == null) {
            vm.function = "adminSearch";
        }

        vm.filterTabla = {
            key: undefined,
            id: $stateParams.relacionId,
            revisado: undefined,
            publicado: undefined,
            traducido: undefined,
            idResponsable: $stateParams.idResponsable,
            nombreResponsable: $stateParams.nombreResponsable,
            rolResponsable: $stateParams.rolResponsable,
            idLugar: $stateParams.idLugar,
            nombreLugar: $stateParams.nombreLugar

        };

        vm.filter = angular.copy(vm.filterTabla);

        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filterTabla,
            sorting: {titulo: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Edicion.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.edicion.delete.name',
                                body: 'admin.edicion.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
        // Buscar
        vm.buscar = function (pageChange) {
            if (!pageChange) {
                $stateParams.page = 1;
            }
            vm.filterTabla.page = $stateParams.page - 1;
            angular.extend(vm.filterTabla, vm.filter);
        };

        // Limpiar formulario y hacer búsqueda
        vm.clear = function () {
            var filterCopy = angular.copy(vm.filter);
            JsonUtils.cleanJson(vm.filter);
            JsonUtils.cleanJson(vm.filterTabla);
            vm.buscar(false);
        };
    }
})(angular);

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:RutasService
     * @description
     * Operaciones relacionadas con las rutas de la aplicación.
     *
     */
    angular.module('app')
        .factory('RutasService', RutasService);

    /* @ngInject */
    function RutasService($location, $window, DEBUG_INFO_ENABLED) {
        var cacheUrl = "";

        return {
            /**
             * @ngdoc function
             * @name getBaseUrl
             * @methodOf app.service:RutasService
             * @param {Boolean} [cliente=false] Booleano para saber si queremos la ruta del lado cliente o del lado servidor.
             * @returns {String} Ruta base de la aplicación.
             */
            getBaseUrl: getBaseUrl,
            /**
             * @ngdoc function
             * @name getUrlParam
             * @methodOf app.service:RutasService
             * @param {String} paramName Nombre del parámetro.
             * @returns {String} Valor del parámetro de la URL.
             */
            getUrlParam: getUrlParam,

            /**
             * @ngdoc function
             * @name getContext
             * @methodOf app.service:RutasService
             * @returns {String} Contexto de la aplicación.
             */
            getContext: getContext,

            getEjemplarTranscritoUrl: getEjemplarTranscritoUrl,
            getEjemplarDigitalizadoUrl: getEjemplarDigitalizadoUrl
        };


        function getBaseUrl(cliente) {
            // En desarrollo utilizamos la de pre porque si no hay problemas al compartir con Facebook
            if (!cacheUrl) {
                if (DEBUG_INFO_ENABLED) {
                    if (cliente) {
                        cacheUrl = "http://localhost:9000/#";
                    } else {
                        cacheUrl = "http://localhost:8080";
                    }
                } else {
                    cacheUrl = $location.protocol() + "://" + $location.host();
                    if ($location.port() !== 80) {
                        cacheUrl = cacheUrl + ":" + $location.port();
                    }
                }
                cacheUrl = cacheUrl + getContext();
            }
            return cacheUrl;
        }

        function getContext() {
            if (DEBUG_INFO_ENABLED) {
                var context = location.pathname.replace($location.path(), "");
                if (context === "/") {
                    return "";
                } else {
                    return context;
                }
            } else {
                return "/CBDRS";
            }
        }


        //Metodos para ckeditor
        function getEjemplarTranscritoUrl(id) {
            return getContext() + '/upload/ejemplares/' + id + '/transcrito/';
        }

        function getEjemplarDigitalizadoUrl(id) {
            return getContext() + '/upload/ejemplares/' + id + '/digitalizado/';
        }

        function getUrlParam(paramName) {
            var reParam = new RegExp('(?:[\?&]|&)' + paramName + '=([^&]+)', 'i');
            var match = $window.location.href.match(reParam);

            return (match && match.length > 1) ? match[1] : null;
        }
    }

})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name app.service:JsonUtils
     * @description
     * Servicio con operaciones comunes para tratar con JSONs.
     *
     */
    angular
        .module('app')
        .factory('JsonUtils', Service);

    /* @ngInject */
    function Service() {

        return {
            /**
             * @ngdoc function
             * @name cleanJson
             * @methodOf app.service:JsonUtils
             * @param {Object} item Objeto cuyas propiedades se van a eliminar
             * @returns {Object} Elimina todas las propiedades de un objeto.
             * El objeto resultante está vacío (`{}`), pero mantiene la referencia.
             */
            cleanJson: cleanJson
        };

        function cleanJson(item) {
            // for enumerable properties
            var props = Object.keys(item);
            for (var i = 0; i < props.length; i++) {
                delete item[props[i]];
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('public', {
            abstract: true,
            parent: 'site',
            views: {
                'header@': {
                    templateUrl: 'app/layouts/header-bidiso/header-bidiso.html',
                    controller: "HeaderBidisoController",
                    controllerAs: 'ctrl'
                },
                'navbar@': {
                    template: '<mi-menu-bidiso menu="$ctrl.menu" nav-collapsed="$ctrl.navCollapsed" modal="$ctrl.modal(id)"></mi-menu-bidiso>',
                    controller: ['menuData', '$window', function (menuData, $window) {
                        this.menu = menuData;
                        this.navCollapsed = $window.innerWidth < 992;
                    }],
                    controllerAs: '$ctrl',
                    resolve: {
                        menuData: ['Menu',
                            function (Menu) {
                                return Menu.getMenu('menu-main');
                            }
                        ]
                    }
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.bidiso.html'
                }
            },
            resolve: {
                /* @ngInject */
                isAdmin: function ($rootScope) {
                    $rootScope.isAdmin = false;
                },
                bidisoUrl: function ($rootScope, $http) {
                    $http({
                        method: 'GET',
                        url: 'api/config-env/getBidisoUrl'
                    }).then(function successCallback(response) {
                        $rootScope.bidisoURL = response.data;
                    }, function errorCallback(error) {
                        console.log('Error al obtener la configuración de Bidiso', error);
                    });
                }

            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('app')
        .constant('ALFABETO', 'abcdefghijklmnñopqrstuvwxyz')
        .constant('ALFABETOingles', 'abcdefghijklmnopqrstuvwxyz')
        // Nº de elementos por página en las tablas
        .constant('NG_TABLE_DEFAULT_PARAMS_PUBLIC', {size: 50})
        // Nº de milisegundos para actualizar el contador de notificaciones
        .constant('NOTIFICACIONES_TIME', 30000)
        // Nº de últimas notificaciones que se muestran
        .constant('NOTIFICACIONES_COUNT', 10)
        // Tiempo mínimo de lectura de una página para actualizar el avance
        .constant('MIN_TIEMPO_PAGINA', 10000)
        .constant('TAMANO_FUENTES', ["14px", "18px", "22px", "28px", "40px"])
        .constant('COLORES_FONDO', ["white", "rgb(251, 240, 217)", "black"])
        .constant('TIPOS_FUENTE', ["Arial, sans-serif", "Times, serif", "Trebuchet MS", "Verdana, sans-serif"])
        .constant('INTERLINEADOS', ["1em", "1.25em", "1.8em"])
        .constant('NG_LIST_DEFAULT_PARAMS_PUBLIC', {size: 50})
        .constant('NG_LIST_DEFAULT_PARAMS_PUBLIC_MAP', {size: 20})
    ;
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('equipo', {
                parent: 'public',
                url: '/equipo',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.equipo'
                },
                views: {
                    'content@': {
                        template: '<estatica id="equipo" bd="true" clase="equipo"></estatica>'
                    }
                }
            })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('condiciones', {
                parent: 'public',
                url: '/condiciones',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.condiciones'
                },
                views: {
                    'content@': {
                        template: '<estatica id="condiciones" bd="true"></estatica>'
                    }
                }
            })
        ;
    }
})();

(function (angular) {
    'use strict';

    angular.module('app').factory('stateHandler', factory);

    /* @ngInject */
    function factory($state, $window, $timeout, $rootScope, $translate, Principal, Auth, AlertService) {
        var _states;

        return {
            stateExists: stateExists,
            initialize: initialize
        };

        function initialize() {
            $timeout(function () {
                _states = $state.get().map(function (item) {
                    return item.name;
                });
            }, 0);
            // in every HTML view we can check for a feature/state and prevent
            // showing a link if it's not enabled
            $rootScope.stateExists = stateExists;

            var deregistrationStateChangeStart = $rootScope.$on('$stateChangeStart',
                function (event, toState, toStateParams) {
                    AlertService.clearPermanent();

                    if (toState.redirectTo) {
                        event.preventDefault();
                        $state.go(toState.redirectTo, toStateParams, {location: 'replace'})
                    }

                    $rootScope.toState = toState;
                    $rootScope.toStateParams = toStateParams;

                    if (Principal.isIdentityResolved()) {
                        Auth.authorize();
                    }
                }
            );
            $rootScope.$on('$destroy', deregistrationStateChangeStart);

            var deregistrationStateChangeSuccess = $rootScope.$on('$stateChangeSuccess',
                function (event, toState, toParams, fromState, fromParams) {
                    if ($window.ga) {
                        console.log("GoogleAnalytics. Sending: " + $location.path());
                        $window.ga('set', 'page', $location.path());
                        $window.ga('send', 'pageview');
                    }

                    var titleKey = 'global.title';

                    if (!$rootScope.redirected && fromState.name !== 'logout' && fromState.name !== 'login') {
                        $rootScope.previousStateName = fromState.name;
                        $rootScope.previousStateParams = fromParams;
                    }

                    // Set the page title key to the one configured in state or use default one
                    if (toState.data.pageTitle) {
                        titleKey = toState.data.pageTitle;
                    }
                    $translate(titleKey).then(function (title) {
                        // Change window title with translated one
                        $window.document.title = $translate.instant('global.title') + " - " + title;
                    });
                    $("html, body").scrollTop(0);
                }
            );
            $rootScope.$on('$destroy', deregistrationStateChangeSuccess);

            function back() {
                // If previous state is 'activate' or do not exist go to 'home'
                if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                    $state.go('home');
                } else {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                }
            }

            $rootScope.back = back;
        }

        function stateExists(state) {
            return _states.indexOf(state) !== -1;
        }
    }
})(angular);

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name app.object:ieFix
     *
     * @description
     * Definición de las operaciones que no soporta Internet Explorer y que el resto de navegadores sí:
     *
     * - `String.prototype.startsWith`
     * - `String.prototype.endsWith`
     * - `String.prototype.inclues`
     * - `Array.prototype.startsWith`
     *
     */
    angular
        .module('app')
        .config(ieFix);

    /* @ngInject */
    function ieFix() {

        // *** Strings ***

        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (search, pos) {
                return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
            };
        }

        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
        if (!String.prototype.endsWith) {
            String.prototype.endsWith = function (search, this_len) {
                if (this_len === undefined || this_len > this.length) {
                    this_len = this.length;
                }
                return this.substring(this_len - search.length, this_len) === search;
            };
        }

        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
        if (!String.prototype.includes) {
            String.prototype.includes = function (search, start) {
                'use strict';
                if (typeof start !== 'number') {
                    start = 0;
                }

                if (start + search.length > this.length) {
                    return false;
                } else {
                    return this.indexOf(search, start) !== -1;
                }
            };
        }

        // *** Arrays ***

        // https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/Array/includes
        if (!Array.prototype.includes) {
            Array.prototype.includes = function (searchElement /*, fromIndex*/) {
                'use strict';
                var O = Object(this);
                var len = parseInt(O.length) || 0;
                if (len === 0) {
                    return false;
                }
                var n = parseInt(arguments[1]) || 0;
                var k;
                if (n >= 0) {
                    k = n;
                } else {
                    k = len + n;
                    if (k < 0) {
                        k = 0;
                    }
                }
                var currentElement;
                while (k < len) {
                    currentElement = O[k];
                    if (searchElement === currentElement ||
                        (searchElement !== searchElement && currentElement !== currentElement)) {
                        return true;
                    }
                    k++;
                }
                return false;
            };
        }

    }
})();

(function (angular) {
    'use strict';

    angular
        .module('app')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', '$locationProvider', 'DEBUG_INFO_ENABLED', 'httpRequestInterceptorCacheBusterProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, $locationProvider, DEBUG_INFO_ENABLED, httpRequestInterceptorCacheBusterProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');

        // Elimina el ! de las URLs
        $locationProvider.hashPrefix('');

        // Elimina el # de las URLs de producción.
        if (!DEBUG_INFO_ENABLED) {
            $locationProvider.html5Mode(true);
        }
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app')
        .config(appConfig);

    /* @ngInject */
    function appConfig($translateProvider, DEBUG_INFO_ENABLED, cfpLoadingBarProvider, $compileProvider, $breadcrumbProvider, $qProvider) {
        console.log("Configurando aplicación");

        $translateProvider.useSanitizeValueStrategy('escapeParameters');

        // Configuración del idioma
        $translateProvider.useStaticFilesLoader({
            files: [{
                prefix: 'i18n/',
                suffix: '/componentes.json'
            }, {
                prefix: 'i18n/',
                suffix: '/enum.json'
            }, {
                prefix: 'i18n/',
                suffix: '/error.json'
            }, {
                prefix: 'i18n/',
                suffix: '/admin.json'
            }, {
                prefix: 'i18n/',
                suffix: '/public.json'
            }]
        });
        // TODO: Almacenar en localstorage el último idioma seleccionado (app.module->changeLanguage) y leerlo de ahí
        $translateProvider.preferredLanguage('es');

        // Configuración de la barra de carga
        cfpLoadingBarProvider.latencyThreshold = 150;
        cfpLoadingBarProvider.includeSpinner = false;

        // Configuración Breadcrumb
        $breadcrumbProvider.setOptions({
            templateUrl: 'app/components/breadcrumb/breadcrumb.html'
        });

        // disable debug data on prod profile to improve performance. Por ahora siempre en modo debug
        console.log("Angular debug:" + DEBUG_INFO_ENABLED);
        $compileProvider.debugInfoEnabled(true);

        $compileProvider.preAssignBindingsEnabled(true);
        $qProvider.errorOnUnhandledRejections(false);
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('User', User);

    /* @ngInject */
    function User(ResourceHelper) {
        var urlAdmin = 'api/admin/user';
        return ResourceHelper.getResource('user', {}, {
            'get': {
                method: 'GET',
                url: urlAdmin + '/:id',
                isArray: false
            },
            'findAll': {
                method: 'GET',
                url: urlAdmin + '/findAll'
            },
            'getLoginById': {
                method: 'GET',
                url: urlAdmin + '/getLoginById/:id'
            }
        });
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Relacion', Relacion);

    /* @ngInject */
    function Relacion($resource) {
        return $resource('api/admin/relacion/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/relacion/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/relacion/:id'
            },
            'getNombreAndBdrs': {
                method: 'GET',
                url: 'api/public/relacion/getNombreAndBdrs'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/relacion/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/relacion/findUsedLetters'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Password', Password);

    /* @ngInject */
    function Password($resource) {
        return $resource('api/account/change_password', {}, {})
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Exportar', Exportar);

    /* @ngInject */
    function Exportar($http, ModalService) {
        return {
            exportar: exportar
        };

        //se exporta a pdf o se envia por email
        function exportar(filtro) {
            if(filtro.formatoExportacion=="PDF"){
                exportarAuxPdf(filtro, 'api/public/edicion/exportar');
            }else{
                exportarAuxMail(filtro, 'api/public/edicion/exportar');
            }
        }

        function exportarAuxPdf(filtro, url) {
            // TODO: Mover a un servicio que reciba la URL y los parámetros. Habría que recibirlos como atributos, sin utilizar un tag
            $http({
                method: 'POST',
                url: url,
                params: {edicionFilter: filtro},
                data: filtro,
                isArray: false,
                responseType: "arraybuffer"
            }).then(function (result) {
                console.log(result);
                var file = new Blob([result.data], {type: 'application/pdf'});
                var contentDisposition = result.headers("Content-Disposition");
                var filename = contentDisposition.split(";")[1].trim().split('=')[1].replace(/"/g, '');
                saveAs(file, filename);
            });
        }

        function exportarAuxMail(filtro, url) {
            $http({
                method: 'POST',
                url: url,
                params: {edicionFilter: filtro},
                data: filtro,
                isArray: false
            }).then(function () {
                ModalService.dismiss('cancel');

            });
        }
    }



})();

(function () {
    'use strict';

    angular.module('app')
        .factory('Estadisticas', Estadisticas);

    /* @ngInject */
    function Estadisticas($resource) {
        return $resource('api/admin/estadisticas', {}, {

            'getEstadisticas': {

                method: 'GET',
                url: 'api/admin/estadisticas/getEstadisticas'

            }

        });
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Ejemplar', Ejemplar);

    /* @ngInject */
    function Ejemplar($resource) {
        return $resource('api/admin/ejemplar/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/ejemplar/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/ejemplar/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/ejemplar/filterByEdicion'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/ejemplar/findUsedLetters'
            },
            'findEjemplaresDTOByEdicion': {
                method: 'GET',
                isArray: true,
                url: 'api/public/ejemplar/findEjemplaresDTOByEdicion'
            },
            'findEjemplaresByCreador': {
                method: 'GET',
                url: 'api/admin/ejemplar/findEjemplaresByCreador/:login'
            }
        });
    }
})();

/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Edicion', Edicion);

    /* @ngInject */
    function Edicion($resource) {
        return $resource('api/admin/edicion/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/edicion/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/edicion/:id'
            },
            'getNombre': {
                method: 'GET',
                url: 'api/public/edicion/getNombre'
            },
            'publicGet': {
                method: 'GET',
                url: 'api/public/edicion/publicGet/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/edicion/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/edicion/findUsedLetters'
            },
            'findAllEdiciones': {
                method: 'GET',
                isArray: false,
                url: 'api/public/edicion/findAllEdiciones'
            },
            'publicSearch': {
                method: 'POST',
                url: 'api/public/edicion/publicSearch'
            },
            'adminSearch': {
                method: 'POST',
                url: 'api/public/edicion/adminSearch'
            },
            'filterGis': {
                method: 'POST',
                isArray: false,
                data: 'data',
                url: 'api/public/edicion/filterGis'
            },
            'getRango': {
                method: 'GET',
                isArray: false,
                url: 'api/public/edicion/rango'
            },
            'findByRelacion': {
                method: 'GET',
                isArray: true,
                url: 'api/public/edicion/findByRelacion'
            },
            'exportar': {
                method: 'POST',
                url: 'api/public/edicion/exportar'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin', {
                abstract: true,
                parent: 'site',
                views: {
                    'navbar@': {
                        template: '<mi-menu menu="$ctrl.menu" nav-collapsed="$ctrl.navCollapsed" modal="$ctrl.modal(id)"></mi-menu>',
                        controller: ['menuData', '$window', function (menuData, $window) {
                            this.menu = menuData;
                            this.navCollapsed = $window.innerWidth < 992;
                        }],
                        controllerAs: '$ctrl',
                        resolve: {
                            menuData: ['Menu',
                                function (Menu) {
                                    return Menu.getMenu('menu-admin');
                                }
                            ]
                        }
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.admin.html'
                    }
                },
                resolve: {
                    /* @ngInject */
                    isAdmin: function ($rootScope) {
                        $rootScope.isAdmin = true;
                    }
                }
            })
            .state('adminLogin', {
                url: '/admin',
                parent: 'admin',
                redirectTo: 'login'
            });
    }
})();

(function () {
    'use strict';

    // Operaciones CRUD para la gestión de elementos en la administración.

    // PARÁMETROS DE CONFIGURACIÓN:

    // base: Estado base (Ej: 'admin/entity')
    // baseUrl: URL base que se va a mostrar en el navegador (Ej: '/admin/entity')
    // translateBase: Raíz de los ficheros de mensaje (Ej: 'admin.entity.')
    // parent: Indica si los nuevos estados van englobados dentro de otro. Útil para el breadcrumb.(Opcional)

    // v2: Formularios como componentes
    // templateList: Contiene un componente para los listados (Ej: '<entity-list></entity-list>')
    // templateForm: Contiene un componente para los formularios (Ej: '<entity-form></entity-form>')
    // Nota: A los componentes habrá que pasarle (con bindings) toda la información que se obtenga en el 'resolve' del estado.

    // v1: Formularios sin componentes (controladores y htmls)
    // controller: Controlador para el listado
    // controllerForm: Controlador para el formulario
    // templateUrlBase: Añade un prefijo a los archivos: .list.html o .form.html.

    // Ejemplo de uso: FILO1701. Organismos (/app/admin/organismo)

    angular.module('app')
        .constant('STATE_HELPER', function (params) {
            var states = {
                parent: {
                    name: params.base,
                    parent: params.parent ? params.parent : 'admin',
                    url: params.baseUrl,
                    redirectTo: params.base + '/list',
                    ncyBreadcrumb: {
                        skip: true
                    }
                    // Extend: data {authorities}
                },
                list: {
                    name: params.base + "/list",
                    parent: params.base,
                    url: '/listar/:page',
                    params: {
                        page: {value: '1', dynamic: true}
                    },
                    views: {},
                    data: {
                        pageTitle: params.translateBase + "list.title"
                    },
                    ncyBreadcrumb: {
                        label: params.translateBase + "list.title"
                    }
                },
                create: {
                    name: params.base + "/create",
                    parent: params.base,
                    url: '/crear',
                    data: {
                        pageTitle: params.translateBase + 'create.title',
                        mode: 'create'
                    },
                    views: {},
                    ncyBreadcrumb: {
                        label: params.translateBase + "create.title",
                        parent: params.base + "/list"
                    },
                    // Extend: resolve
                    resolve: {
                        /* @ngInject */
                        previousParams: function ($state) {
                            return $state.params;
                        }
                    }
                },
                edit: {
                    name: params.base + "/edit",
                    parent: params.base,
                    url: '/:id/editar',
                    data: {
                        pageTitle: params.translateBase + 'edit.title',
                        mode: 'edit'
                    },
                    views: {},
                    ncyBreadcrumb: {
                        label: params.translateBase + "edit.title",
                        parent: params.onlyEdit ? null : params.base + "/list"
                    },
                    // Extend: resolve
                    resolve: {
                        /* @ngInject */
                        previousParams: function ($state) {
                            return $state.params;
                        }
                    }
                }
            };

            if (!params.view) {
                params.view = 'content@';
            }

            // Listar
            states.list.views[params.view] = {
                templateUrl: params.templateUrlBase + '.list.html',
                controller: params.controller,
                template: params.templateList ? params.templateList : undefined,
                controllerAs: 'ctrl'
            };
            // Crear y editar
            states.create.views[params.view] = states.edit.views[params.view] = {
                templateUrl: params.templateUrlBase + '.form.html',
                controller: params.controllerForm,
                template: params.templateForm ? params.templateForm : undefined,
                controllerAs: 'ctrl'
            };

            return states;
        });
})();

(function () {
    'use strict';

    angular.module('app')
        .constant('ADMIN_PRINCIPAL', "admin/relacion")
        // Nº de elementos por página en las tablas
        .constant('NG_TABLE_DEFAULT_PARAMS', {size: 100})

    ;
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('site', {
            abstract: true,
            data: {
                authorities: []
            },
            resolve: {
                /* @ngInject */
                authorize: function (Auth) {
                    return Auth.authorize();
                },
                /* @ngInject */
                isFilemanager: function ($rootScope) {
                    $rootScope.isFilemanager = false;
                }
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('app')
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
(function(){angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/templates/tesauro.templates.html","<script type=\"text/ng-template\" id=\"responsables.tesauro.html\">\r\n    <a>\r\n        {{match.model.nombre}} {{match.model.apellidos}}\r\n    </a>\r\n</script>\r\n");
$templateCache.put("app/admin/ejemplar/ejemplar.form.html","<h1 class=\"titulo-contexto\">{{$resolve.edicion.titulo}}</h1>\r\n\r\n<form name=\"form\" role=\"form\" ng-submit=\"ctrl.save()\" show-validation=\"\">\r\n    <div class=\"form-body\">\r\n\r\n        <h4 translate=\"admin.ejemplar.create.title\" ng-if=\"ctrl.mode === \'create\'\"></h4>\r\n        <h4 translate=\"admin.ejemplar.edit.title\" ng-if=\"ctrl.mode === \'edit\'\"></h4>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-6\">\r\n                <label-form key=\"admin.ejemplar.form.signatura\" for=\"signatura\" required=\"true\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.signatura\" id=\"signatura\" required=\"true\">\r\n            </div>\r\n\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\" ng-form=\"biblioteca\" ng-class=\"biblioteca.$invalid && biblioteca.$dirty ? \'has-error\' : \'\'\">\r\n                    <tesauro id=\"biblioteca\" ng-model=\"ctrl.item.biblioteca\" resource=\"ctrl.bibliotecaService\" method=\"findAll\" restricted=\"true\" multiple=\"false\" min-length=\"0\" eliminable=\"true\" label=\"admin.ejemplar.form.biblioteca\" parameters=\"{sortProperty: \'nombre\', size: 20}\">\r\n                    </tesauro>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-4\">\r\n                <label-form key=\"admin.ejemplar.form.investigador\" for=\"investigador\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.investigador\" id=\"investigador\">\r\n            </div>\r\n\r\n            <div class=\"col-sm-2\">\r\n                <div class=\"form-group\">\r\n                    <enum-select id=\"encuadernacion\" label=\"admin.ejemplar.form.encuadernacion\" model=\"ctrl.item.encuadernacion\" options=\"ctrl.encuadernaciones\" base=\"enum.encuadernacion\"></enum-select>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tieneExLibris\" type=\"checkbox\" ng-model=\"ctrl.item.tieneExLibris\">\r\n                    <label-form key=\"admin.ejemplar.form.tieneExLibris\" for=\"tieneExLibris\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Si tiene portada-->\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tienePortada\" type=\"checkbox\" ng-model=\"ctrl.item.tienePortada\">\r\n                    <label-form key=\"admin.ejemplar.form.tienePortada\" for=\"tienePortada\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Visto-->\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"visto\" type=\"checkbox\" ng-model=\"ctrl.item.visto\">\r\n                    <label-form key=\"admin.ejemplar.form.visto\" for=\"visto\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--EX-LIBRIS-->\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-12\">\r\n                <div class=\"form-group\">\r\n                    <text-area id=\"exLibris\" height=\"100\" label=\"admin.ejemplar.form.exLibris\" model=\"ctrl.item.exLibris\"></text-area>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--COMENTARIOS-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-12\">\r\n                <label-form key=\"admin.ejemplar.form.comentarios\" for=\"comentarios\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.comentarios\" id=\"comentarios\">\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!--OBSERVACIONES-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-12\">\r\n                <label-form key=\"admin.ejemplar.form.observaciones\" for=\"observaciones\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.observaciones\" id=\"observaciones\">\r\n            </div>\r\n        </div>\r\n\r\n        <!--FUENTES-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-12\">\r\n                <label-form key=\"admin.ejemplar.form.fuente\" for=\"fuenteBibliografica\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.fuenteBibliografica\" id=\"fuenteBibliografica\">\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!--REFERENCIAS-->\r\n        <div class=\"row\">\r\n            <!--Contenido del componente ListForm-->\r\n            <script type=\"text/ng-template\" id=\"referencias.ejemplar.html\">\r\n                <!--TITULO-->\r\n                <div class=\"col-sm-4\">\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"admin.ejemplar.form.nombreRef\" for=\"titulo\"></label-form>\r\n                        <input type=\"text\" class=\"form-control\" id=\"titulo\" ng-model=\"element.titulo\" required/>\r\n                    </div>\r\n                </div>\r\n\r\n                <!--URL-->\r\n                <div class=\"col-sm-7\">\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"admin.ejemplar.form.url\" for=\"url_{{$index}}\"></label-form>\r\n                        <input type=\"text\" class=\"form-control\" id=\"url_{{$index}}\" ng-model=\"element.url\" required/>\r\n\r\n                    </div>\r\n                </div>\r\n            </script>\r\n\r\n\r\n            <div class=\"form-group col-sm-12\">\r\n                <list-form label=\"admin.ejemplar.form.referencias\" list=\"ctrl.item.referencias\" template-url=\"referencias.ejemplar.html\"></list-form>\r\n            </div>\r\n        </div>\r\n\r\n        <!--SUBIDA DE ARCHIVOS-->\r\n        <fieldset class=\"fieldset-border form-group\">\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"admin.ejemplar.form.transcrito\" for=\"transcrito\"></label-form>\r\n                    <file-upload archivo=\"ctrl.item.pdfTranscritoPath\" archivo-temporal=\"ctrl.item.pdfTranscritoPathTmp\" id=\"transcrito\" accept=\".pdf\" url=\"{{ctrl.urlBaseTranscrito}}\"></file-upload>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"admin.ejemplar.form.digitalizado\" for=\"digitalizado\"></label-form>\r\n                    <file-upload archivo=\"ctrl.item.pdfDigitalizadoPath\" archivo-temporal=\"ctrl.item.pdfDigitalizadoPathTmp\" id=\"digitalizado\" accept=\".pdf\" url=\"{{ctrl.urlBaseDigitalizado}}\"></file-upload>\r\n                </div>\r\n            </div>\r\n        </fieldset>\r\n\r\n        <!--PAGINAS DIGITALIZADAS-->\r\n        <fieldset class=\"fieldset-border form-group\">\r\n            <label-form key=\"admin.ejemplar.form.paginas\"></label-form>\r\n            <imagenes elements=\"ctrl.item.paginas\" mode=\"ctrl.mode\" ejemplar-id=\"ctrl.item.id\" mensaje=\"{{\'imagen.pagina\' | translate}}\"></imagenes>\r\n        </fieldset>\r\n\r\n        <!--REVISADO, PUBLICADO-->\r\n        <div class=\"row\">\r\n            <div has-any-authority=\"ROLE_ADMIN\">\r\n                <div class=\"col-sm-2\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"revisado\" type=\"checkbox\" ng-model=\"ctrl.item.revisado\">\r\n                        <label-form key=\"admin.ejemplar.form.revisado\" for=\"revisado\"></label-form>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-2\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"publicado\" type=\"checkbox\" ng-model=\"ctrl.item.publicado\">\r\n                        <label-form key=\"admin.ejemplar.form.publicado\" for=\"publicado\"></label-form>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Autor-->\r\n        <div class=\"row\">\r\n            <div ng-if=\"ctrl.item.nombreUsuario\">\r\n                <div class=\"col-sm-3\">\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"admin.ejemplar.form.autor\" for=\"creador\"></label-form>\r\n                        <span>{{ctrl.item.nombreUsuario}}</span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <div class=\"form-bottom-buttons\">\r\n            <a type=\"button\" ui-sref=\"admin/edicion/edit({id: ctrl.item.edicion.id})\" target=\"_blank\" class=\"btn btn-default\" ng-if=\"ctrl.mode === \'edit\'\">\r\n                <span translate=\"admin.ejemplar.form.edicion\"></span>\r\n            </a>\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$root.back()\">\r\n                <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.cancel\"></span>\r\n            </button>\r\n            <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"ctrl.userName!=ctrl.item.nombreUsuario && ctrl.userRole!=\'ROLE_ADMIN\'&& ctrl.mode === \'edit\'\">\r\n                <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.create\" ng-if=\"ctrl.mode === \'create\'\"></span>\r\n                <span translate=\"admin.form.button.save\" ng-if=\"ctrl.mode === \'edit\'\"></span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/admin/ejemplar/ejemplar.list.html","<h1 class=\"titulo-contexto\">{{$resolve.edicion.titulo}}</h1>\r\n\r\n<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/ejemplar/create({id: element.id})\">\r\n        <span translate=\"admin.ejemplar.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"form-group col-sm-3\">\r\n        <filter filter=\"ctrl.filter.key\"></filter>\r\n    </div>\r\n\r\n    <div class=\"form-group col-sm-3\">\r\n        <div class=\"form-group col-sm-4\">\r\n            <label>{{\'admin.ejemplar.filtrado.revisados\' | translate}}:</label>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-6\">\r\n            <enum-select id=\"ejemplarrevisado\" model=\"ctrl.filter.revisado\" options=\"[true, false]\" base=\"enum.boolean\"></enum-select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group col-sm-3\">\r\n        <div class=\"form-group col-sm-4\">\r\n            <label>{{\'admin.ejemplar.filtrado.publicados\' | translate}}:</label>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-6\">\r\n            <enum-select id=\"ejemplarpublicado\" model=\"ctrl.filter.publicado\" options=\"[true, false]\" base=\"enum.boolean\"></enum-select>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total()|number}}</label>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n\r\n    <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n        <td data-title=\"\'admin.ejemplar.signatura\' | translate\" sortable=\"\'signatura\'\">\r\n            <a ui-sref=\"admin/ejemplar/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                {{element.signatura}}\r\n            </a>\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.ejemplar.form.revisado\' | translate\" sortable=\"\'revisado\'\">\r\n            {{\'enum.boolean.\' + (element.revisado == null ? \'\' : element.revisado) | translate}}\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.ejemplar.form.publicado\' | translate\" sortable=\"\'publicado\'\">\r\n            {{\'enum.boolean.\' + (element.publicado == null ? \'\' : element.publicado) | translate}}\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <a ui-sref=\"admin/ejemplar/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n\r\n            <!--Eliminar elemento-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!element.isEditing\" ng-class=\"{\'disabled\':ctrl.userName!=element.nombreUsuario && ctrl.userRole!=\'ROLE_ADMIN\' }\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n\r\n");
$templateCache.put("app/admin/ejemplar/ejemplar.usuario.list.html","<div>\r\n    <label>{{\'admin.ejemplar.list.creador\' | translate}}: {{ctrl.creador}}</label>\r\n</div>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total()|number}}</label>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n    <tr ng-repeat=\"ejemplar in $data track by ejemplar.id\" class=\"animate\">\r\n\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.ejemplar.list.cbdrs\' | translate\" sortable=\"\'edicion.relacion.bdrs\'\">\r\n            <a ui-sref=\"admin/relacion/edit({id: ejemplar.edicion.relacion.id})\">CBDRS{{ejemplar.edicion.relacion.bdrs}}</a>\r\n        </td>\r\n\r\n        <td class=\"col-md-3 text-center\" data-title=\"\'admin.ejemplar.list.edicion\' | translate\" sortable=\"\'edicion.titulo\'\">\r\n            <a ui-sref=\"admin/edicion/edit({id: ejemplar.edicion.id})\">{{ejemplar.edicion.titulo}}</a>\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.ejemplar.list.signatura\' | translate\" sortable=\"\'signatura\'\">\r\n            <a ui-sref=\"admin/ejemplar/edit({id: ejemplar.id})\">{{ejemplar.signatura}}</a>\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.ejemplar.list.ultimaModificacion\' | translate\" sortable=\"\'edicion.ultimaModificacion\'\">\r\n            {{ctrl.secondsToDate(ejemplar.edicion.ultimaModificacion)}}\r\n        </td>\r\n\r\n    </tr>\r\n\r\n</table>\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/admin/estadisticas/estadisticas.html","<div class=\"estadisticas\">\r\n    <div>\r\n        <label translate=\"admin.estadisticas.ejemplaresRevisadosPublicados\"></label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.ejemplaresRevisadosPublicados\" readonly=\"readonly\">\r\n    </div>\r\n\r\n    <div>\r\n        <label translate=\"admin.estadisticas.ejemplaresNoRevisadosNoPublicados\"></label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.ejemplaresNoRevisadosNoPublicados\" readonly=\"readonly\">\r\n    </div>\r\n\r\n    <div>\r\n        <label translate=\"admin.estadisticas.obrasAutor\"></label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.obrasAutor\" readonly=\"readonly\">\r\n    </div>\r\n\r\n    <div>\r\n        <label translate=\"admin.estadisticas.obrasNoAutor\"></label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.obrasNoAutor\" readonly=\"readonly\">\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/admin/edicion/edicion.form.html","<h1 class=\"titulo-contexto\">{{$resolve.relacion.titulo}}</h1>\r\n\r\n<form name=\"form\" role=\"form\" ng-submit=\"ctrl.save()\" show-validation=\"\">\r\n    <div class=\"form-body\">\r\n\r\n        <h4 translate=\"admin.edicion.create.title\" ng-if=\"ctrl.mode === \'create\'\"></h4>\r\n        <h4 translate=\"admin.edicion.edit.title\" ng-if=\"ctrl.mode === \'edit\'\"></h4>\r\n\r\n        <!--TITULO-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-12\">\r\n                <label-form key=\"admin.edicion.form.titulo\" for=\"titulo\" required=\"true\"></label-form>\r\n                <textarea rows=\"3\" type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.titulo\" id=\"titulo\" required=\"true\"> </textarea>\r\n\r\n            </div>\r\n        </div>\r\n\r\n        <!--EPITETOS-->\r\n        <div class=\"row\">\r\n            <script type=\"text/ng-template\" id=\"epitetos.edicion.html\">\r\n                <div class=\"col-sm-10\">\r\n                    <div class=\"form-group\">\r\n                        <tesauro id=\"epiteto_{{$index}}\" ng-model=\"element\"\r\n                                 resource=\"ctrl.resolve.epitetoService\" method=\"findAll\"\r\n                                 restricted=\"true\" multiple=\"false\" min-length=\"0\" simple-list-form=\"true\"\r\n                                 eliminable=\"true\"\r\n                                 parameters=\"{sortProperty: \'nombre\', size: 20}\" required=\"true\"></tesauro>\r\n                    </div>\r\n                </div>\r\n            </script>\r\n            <div class=\"form-group col-sm-12 in-line\">\r\n                <list-form label=\"admin.edicion.form.epitetos\" list=\"ctrl.item.epitetos\" resolve=\"{epitetoService: ctrl.epitetoService}\" template-url=\"epitetos.edicion.html\"></list-form>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Letra y LUGAR-->\r\n        <div class=\"row\">\r\n            <!--Letra-->\r\n            <div class=\"form-group col-sm-2\">\r\n                <label-form key=\"admin.edicion.form.letra\" for=\"letra\" required=\"true\"></label-form>\r\n                <input type=\"text\" maxlength=\"1\" class=\"form-control\" ng-model=\"ctrl.item.letra\" id=\"letra\" required=\"true\">\r\n            </div>\r\n\r\n            <div class=\"col-sm-4\">\r\n                <div class=\"form-group\" ng-form=\"lugar\" ng-class=\"lugar.$invalid && lugar.$dirty ? \'has-error\' : \'\'\">\r\n                    <tesauro id=\"lugar\" ng-model=\"ctrl.item.lugar\" resource=\"ctrl.lugarService\" method=\"simpleFilter\" restricted=\"true\" multiple=\"false\" min-length=\"0\" eliminable=\"true\" label=\"admin.edicion.form.lugar\" parameters=\"{sortProperty: \'nombre\', size: 20}\">\r\n                    </tesauro>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Lugar deducido-->\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"esLugarDeducido\" type=\"checkbox\" ng-model=\"ctrl.item.esLugarDeducido\">\r\n                    <label-form key=\"admin.edicion.form.esLugarDeducido\" for=\"esLugarDeducido\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Lugar probable-->\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"esLugarProbable\" type=\"checkbox\" ng-model=\"ctrl.item.esLugarProbable\">\r\n                    <label-form key=\"admin.edicion.form.esLugarProbable\" for=\"esLugarProbable\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!--Años-->\r\n        <div class=\"row\">\r\n            <!--Año inicial-->\r\n            <div class=\"form-group col-sm-3\">\r\n                <label-form key=\"admin.edicion.form.anoInicio\" for=\"anoInicio\"></label-form>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.item.anoInicio\" id=\"anoInicio\">\r\n            </div>\r\n\r\n            <!--Año final-->\r\n            <div class=\"form-group col-sm-3\">\r\n                <label-form key=\"admin.edicion.form.anoFin\" for=\"anoFin\"></label-form>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.item.anoFin\" id=\"anoFin\">\r\n            </div>\r\n\r\n            <!--Año aproximado-->\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"esAnoDeducido\" type=\"checkbox\" ng-model=\"ctrl.item.esAnoDeducido\">\r\n                    <label-form key=\"admin.edicion.form.esDeducido\" for=\"esAnoDeducido\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Año deducido-->\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"esAnoAproximado\" type=\"checkbox\" ng-model=\"ctrl.item.esAnoAproximado\">\r\n                    <label-form key=\"admin.edicion.form.esAproximado\" for=\"esAnoAproximado\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--RESPONSABLES-->\r\n        <div class=\"row\">\r\n            <!--RESPONSABLES-->\r\n            <script type=\"text/ng-template\" id=\"responsables.edicion.html\">\r\n                <!--Responsables-->\r\n                <div class=\"col-sm-4\">\r\n                    <div class=\"form-group\">\r\n                        <tesauro id=\"responsable_{{$index}}\" ng-model=\"element.responsable\"\r\n                                 resource=\"ctrl.resolve.responsableService\" method=\"simpleFilter\"\r\n                                 restricted=\"true\" multiple=\"false\" min-length=\"0\"\r\n                                 label=\"admin.edicion.form.responsable\" eliminable=\"true\"\r\n                                 parameters=\"{sort: \'nombreCompleto\', size: 20}\" required=\"true\"\r\n                                 display=\"nombreCompleto\">\r\n                        </tesauro>\r\n                    </div>\r\n                </div>\r\n                <!--Rol-->\r\n                <div class=\"col-sm-3\">\r\n                    <div class=\"form-group\">\r\n                        <enum-select id=\"rol_{{$index}}\" label=\"admin.edicion.form.responsablerol\" model=\"element.rol\"\r\n                                     options=\"ctrl.resolve.roles\" base=\"enum.rol-responsable\"\r\n                                     required=\"true\" disabled=\"!element.responsable\"></enum-select>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-2 form-center-vertical\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"esDeducido_{{$index}}\" type=\"checkbox\" ng-model=\"element.esDeducido\">\r\n                        <label-form key=\"admin.edicion.form.deducido\" for=\"esDeducido_{{$index}}\"></label-form>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-2 form-center-vertical\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"esProbable_{{$index}}\" type=\"checkbox\" ng-model=\"element.esProbable\">\r\n                        <label-form key=\"admin.edicion.form.probable\" for=\"esProbable_{{$index}}\"></label-form>\r\n                    </div>\r\n                </div>\r\n            </script>\r\n            <div class=\"form-group col-sm-12\">\r\n                <list-form label=\"admin.edicion.form.responsables\" list=\"ctrl.item.responsables\" resolve=\"{responsableService: ctrl.responsableService, roles: ctrl.roles}\" template-url=\"responsables.edicion.html\"></list-form>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!--TAMAÑO, PAGINAS, IDIOMA Y SIGNATURA-->\r\n        <div class=\"row\">\r\n            <!--TAMAÑO-->\r\n            <div class=\"col-sm-2\">\r\n                <div class=\"form-group\">\r\n                    <enum-select id=\"tamano\" label=\"admin.edicion.form.tamano\" model=\"ctrl.item.tamano\" options=\"ctrl.tamanos\" base=\"enum.tamano\"></enum-select>\r\n                </div>\r\n            </div>\r\n            <!--<NUMERO PAGINAS-->\r\n            <div class=\"form-group col-sm-2\">\r\n                <label-form key=\"admin.edicion.form.numpaginas\" for=\"numpaginas\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.numPaginas\" id=\"numpaginas\">\r\n            </div>\r\n\r\n            <!--IDIOMA-->\r\n            <div class=\"col-sm-2\">\r\n                <div class=\"form-group\" ng-form=\"idioma\" ng-class=\"idioma.$invalid && idioma.$dirty ? \'has-error\' : \'\'\">\r\n                    <tesauro id=\"idioma\" ng-model=\"ctrl.item.idioma\" resource=\"ctrl.idiomaService\" method=\"findAll\" restricted=\"true\" multiple=\"false\" min-length=\"0\" eliminable=\"true\" label=\"admin.edicion.form.idioma\" parameters=\"{sortProperty: \'nombre\'}\">\r\n                    </tesauro>\r\n                </div>\r\n            </div>\r\n            <!--Signatura-->\r\n            <div class=\"form-group col-sm-6\">\r\n                <label-form key=\"admin.edicion.form.sigtipografica\" for=\"sigtipografica\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.sigTipografica\" id=\"sigtipografica\">\r\n            </div>\r\n        </div>\r\n\r\n        <!--TIPOS DE LETRAS, Inicial, Reclamos, Ilustracion-->\r\n        <div class=\"row\">\r\n            <!--TIPOS DE LETRAS-->\r\n            <div class=\"col-sm-2\">\r\n                <div class=\"form-group\">\r\n                    <enum-select id=\"tipoletra1\" label=\"admin.edicion.form.tipoletra1\" model=\"ctrl.item.tipoLetra1\" options=\"ctrl.tipoletras\" base=\"enum.tipoletra\"></enum-select>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-sm-2\">\r\n                <div class=\"form-group\">\r\n                    <enum-select id=\"tipoletra2\" label=\"admin.edicion.form.tipoletra2\" model=\"ctrl.item.tipoLetra2\" options=\"ctrl.tipoletras\" base=\"enum.tipoletra\"></enum-select>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-sm-2\">\r\n                <div class=\"form-group\">\r\n                    <enum-select id=\"tipoletra3\" label=\"admin.edicion.form.tipoletra3\" model=\"ctrl.item.tipoLetra3\" options=\"ctrl.tipoletras\" base=\"enum.tipoletra\"></enum-select>\r\n                </div>\r\n            </div>\r\n\r\n            <!--TIENE INICIAL-->\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tieneInicial\" type=\"checkbox\" ng-model=\"ctrl.item.tieneInicial\">\r\n                    <label-form key=\"admin.edicion.form.tieneInicial\" for=\"tieneInicial\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--TIENE RECLAMOS-->\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tieneReclamos\" type=\"checkbox\" ng-model=\"ctrl.item.tieneReclamos\">\r\n                    <label-form key=\"admin.edicion.form.tieneReclamos\" for=\"tieneReclamos\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--TIENE ILUSTRACION-->\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tieneIlustracion\" type=\"checkbox\" ng-model=\"ctrl.item.tieneIlustracion\">\r\n                    <label-form key=\"admin.edicion.form.tieneIlustracion\" for=\"tieneIlustracion\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--PORTADA-->\r\n            <div class=\"col-sm-2\">\r\n                <div class=\"form-group\">\r\n                    <enum-select id=\"portada\" label=\"admin.edicion.form.portada\" model=\"ctrl.item.portada\" options=\"ctrl.portadas\" base=\"enum.portada\"></enum-select>\r\n                </div>\r\n            </div>\r\n            <!--MODALIDAD DISCURSO-->\r\n            <div class=\"col-sm-2\">\r\n                <div class=\"form-group\">\r\n                    <enum-select id=\"modalidaddiscurso\" label=\"admin.edicion.form.modalidaddiscurso\" model=\"ctrl.item.modalidadDiscurso\" options=\"ctrl.modalidaddiscursos\" base=\"enum.modalidaddiscurso\"></enum-select>\r\n                </div>\r\n            </div>\r\n\r\n            <!--SI ES MANUSCRITA-->\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"esManuscrito\" type=\"checkbox\" ng-model=\"ctrl.item.esManuscrito\">\r\n                    <label-form key=\"admin.edicion.form.esManuscrito\" for=\"esManuscrito\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--LICENCIA-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-10\">\r\n                <label-form key=\"admin.edicion.form.descripLicencia\" for=\"descripLicencia\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.descripLicencia\" id=\"descripLicencia\">\r\n            </div>\r\n\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tieneLicencia\" type=\"checkbox\" ng-model=\"ctrl.item.tieneLicencia\">\r\n                    <label-form key=\"admin.edicion.form.tieneLicencia\" for=\"tieneLicencia\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--COLOFON-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-10\">\r\n                <label-form key=\"admin.edicion.form.descripColofon\" for=\"descripColofon\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.descripColofon\" id=\"descripColofon\">\r\n            </div>\r\n\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tieneColofon\" type=\"checkbox\" ng-model=\"ctrl.item.tieneColofon\">\r\n                    <label-form key=\"admin.edicion.form.tieneColofon\" for=\"tieneColofon\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--DEDICATORIA-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-10\">\r\n                <label-form key=\"admin.edicion.form.descripDedicatoria\" for=\"descripDedicatoria\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.descripDedicatoria\" id=\"descripDedicatoria\">\r\n            </div>\r\n\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tieneDedicatoria\" type=\"checkbox\" ng-model=\"ctrl.item.tieneDedicatoria\">\r\n                    <label-form key=\"admin.edicion.form.tieneDedicatoria\" for=\"tieneDedicatoria\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--APROBACION-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-10\">\r\n                <label-form key=\"admin.edicion.form.descripAprobacion\" for=\"descripAprobacion\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.descripAprobacion\" id=\"descripAprobacion\">\r\n            </div>\r\n\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tieneAprobacion\" type=\"checkbox\" ng-model=\"ctrl.item.tieneAprobacion\">\r\n                    <label-form key=\"admin.edicion.form.tieneAprobacion\" for=\"tieneAprobacion\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--PRIVILEGIO-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-10\">\r\n                <label-form key=\"admin.edicion.form.descripPrivilegio\" for=\"descripPrivilegio\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.descripPrivilegio\" id=\"descripPrivilegio\">\r\n            </div>\r\n\r\n            <div class=\"col-sm-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tienePrivilegio\" type=\"checkbox\" ng-model=\"ctrl.item.tienePrivilegio\">\r\n                    <label-form key=\"admin.edicion.form.tienePrivilegio\" for=\"tienePrivilegio\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--NOTAS-->\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-12\">\r\n                <label-form key=\"admin.edicion.form.notas\" for=\"notas\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.notas\" id=\"notas\">\r\n            </div>\r\n        </div>\r\n\r\n        <!--ILUSTRACIONES-->\r\n        <div class=\"row\">\r\n\r\n            <!--Contenido del componente ListForm-->\r\n            <script type=\"text/ng-template\" id=\"ilustraciones.edicion.html\">\r\n                <!--TITULO-->\r\n                <div class=\"col-sm-11\">\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"admin.edicion.form.ilustracion.descripcion\"\r\n                                    for=\"descripcion_{{$index}}\"></label-form>\r\n                        <input type=\"text\" class=\"form-control\" id=\"descripcion_{{$index}}\"\r\n                               ng-model=\"element.descripcion\" required/>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-11\">\r\n\r\n                    <fieldset class=\"fieldset-border form-group\">\r\n                        <label-form key=\"admin.edicion.form.ilustracion.imagen\"></label-form>\r\n                        <imagenes id-bloque=\"bloque_{{$index}}\" elements=\"element.imagenes\" mode=\"ctrl.mode\"\r\n                                  edicion-id=\"ctrl.resolve.idEdicion\" ilustracion-id=\"element.id\" mensaje=\"{{\'imagen.estandar\' | translate}}\"></imagenes>\r\n                    </fieldset>\r\n                </div>\r\n            </script>\r\n\r\n            <div class=\"form-group col-sm-12\">\r\n                <list-form label=\"admin.edicion.form.ilustraciones\" list=\"ctrl.item.ilustraciones\" template-url=\"ilustraciones.edicion.html\" resolve=\"{idEdicion: ctrl.item.id}\"></list-form>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!--CATÁLOGOS-->\r\n        <div class=\"row\">\r\n            <!--Contenido del componente ListForm-->\r\n            <script type=\"text/ng-template\" id=\"catalogos.edicion.html\">\r\n                <!--Catalogos-->\r\n                <div class=\"col-sm-8\">\r\n                    <div class=\"form-group\">\r\n                        <tesauro id=\"catalogo_{{$index}}\" ng-model=\"element.catalogo\"\r\n                                 resource=\"ctrl.resolve.catalogoService\" method=\"findAll\"\r\n                                 restricted=\"true\" multiple=\"false\" min-length=\"0\"\r\n                                 label=\"admin.edicion.form.catalogo.nombre\" eliminable=\"true\"\r\n                                 parameters=\"{sortProperty: \'nombre\', size: 20}\" required=\"true\"></tesauro>\r\n                    </div>\r\n                </div>\r\n\r\n                <!--Numero-->\r\n                <div class=\"col-sm-3\">\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"admin.edicion.form.catalogo.numero\" for=\"numero   \"></label-form>\r\n                        <input type=\"text\" class=\"form-control\" id=\"numero\" ng-model=\"element.numero\" required/>\r\n                    </div>\r\n                </div>\r\n            </script>\r\n            <div class=\"form-group col-sm-12\">\r\n                <list-form label=\"admin.edicion.form.catalogos\" list=\"ctrl.item.catalogos\" resolve=\"{catalogoService: ctrl.catalogoService}\" template-url=\"catalogos.edicion.html\"></list-form>\r\n            </div>\r\n        </div>\r\n\r\n        <!--REVISADO, PUBLICADO, TRADUCIDO-->\r\n        <div class=\"row\">\r\n            <div has-any-authority=\"ROLE_ADMIN\">\r\n                <div class=\"col-sm-2\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"revisado\" type=\"checkbox\" ng-model=\"ctrl.item.revisado\">\r\n                        <label-form key=\"admin.edicion.form.revisado\" for=\"revisado\"></label-form>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-2\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"publicado\" type=\"checkbox\" ng-model=\"ctrl.item.publicado\">\r\n                        <label-form key=\"admin.edicion.form.publicado\" for=\"publicado\"></label-form>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-2\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"traducido\" type=\"checkbox\" ng-model=\"ctrl.item.traducido\">\r\n                        <label-form key=\"admin.edicion.form.traducido\" for=\"traducido\"></label-form>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n\r\n        <!--Autor-->\r\n        <div class=\"row\">\r\n            <div ng-if=\"ctrl.item.nombreUsuario\">\r\n                <div class=\"col-sm-3\">\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"admin.edicion.form.autor\" for=\"creador\"></label-form>\r\n                        <span>{{ctrl.item.nombreUsuario}}</span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!-- FECHA CREACION -->\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-4\" ng-if=\"ctrl.item.fechaCreacion\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"admin.edicion.form.fechaCreacion\" for=\"fechaCreacion\"></label-form>\r\n                    <span><date model=\"ctrl.item.fechaCreacion\"></date></span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!-- ULTIMA MODIFICACION -->\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-4\" ng-if=\"ctrl.item.ultimaModificacion\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"admin.edicion.form.ultimaMod\" for=\"ultimaMod\"></label-form>\r\n                    <span><date model=\"ctrl.item.ultimaModificacion\"></date></span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botones-->\r\n        <div class=\"form-bottom-buttons\">\r\n            <a type=\"button\" ui-sref=\"admin/relacion/edit({id: ctrl.item.relacion.id})\" target=\"_blank\" class=\"btn btn-default\" ng-if=\"ctrl.mode === \'edit\'\">\r\n                <span translate=\"admin.edicion.form.relacion\"></span>\r\n            </a>\r\n            <a type=\"button\" ui-sref=\"admin/ejemplar/list({relacionId: ctrl.item.relacion.id, edicionId: ctrl.item.id})\" target=\"_blank\" class=\"btn btn-default\" ng-if=\"ctrl.mode === \'edit\'\">\r\n                <span translate=\"admin.edicion.form.ejemplares\"></span>\r\n            </a>\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$root.back()\">\r\n                <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.cancel\"></span>\r\n            </button>\r\n            <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"ctrl.userName!=ctrl.item.nombreUsuario && ctrl.userRole!=\'ROLE_ADMIN\'&& ctrl.mode === \'edit\'\">\r\n                <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.create\" ng-if=\"ctrl.mode === \'create\'\"></span>\r\n                <span translate=\"admin.form.button.save\" ng-if=\"ctrl.mode === \'edit\'\"></span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n</form>\r\n");
$templateCache.put("app/admin/edicion/edicion.list.html","<h1 class=\"titulo-contexto\">{{$resolve.relacion.titulo}}</h1>\r\n<h1 class=\"titulo-contexto\">BDRS{{$resolve.relacion.bdrs}}</h1>\r\n\r\n<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/edicion/create({id: element.id})\">\r\n        <span translate=\"admin.edicion.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n\r\n<div class=\"row\">\r\n    <div class=\"form-group col-sm-3\">\r\n        <filter filter=\"ctrl.filter.key\"></filter>\r\n    </div>\r\n\r\n    <div class=\"form-group col-sm-3\">\r\n        <div class=\"form-group col-sm-4\">\r\n            <label>{{\'admin.edicion.filtrado.revisadas\' | translate}}:</label>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-6\">\r\n            <enum-select id=\"relacionrevisado\" model=\"ctrl.filter.revisado\" options=\"[true, false]\" base=\"enum.boolean\"></enum-select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group col-sm-3\">\r\n        <div class=\"form-group col-sm-4\">\r\n            <label>{{\'admin.edicion.filtrado.publicadas\' | translate}}:</label>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-6\">\r\n            <enum-select id=\"relacionrepasada\" model=\"ctrl.filter.publicado\" options=\"[true, false]\" base=\"enum.boolean\"></enum-select>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total() |number }}</label>\r\n</div>\r\n\r\n<div ng-include=\"\'app/admin/edicion/edicion.tabla.html\'\"></div>\r\n\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n\r\n");
$templateCache.put("app/admin/edicion/edicion.tabla.html","<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n    <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n\r\n\r\n        <td data-title=\"\'admin.edicion.titulo\' | translate\" sortable=\"\'titulo\'\">\r\n            <a ui-sref=\"admin/edicion/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                {{element.titulo}}\r\n            </a>\r\n        </td>\r\n\r\n        <!--Dependiendo de si estamos en el buscador de admin o en el listado de edición, el atributo estará estructurado de una forma y otra-->\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.edicion.letra\' | translate\" sortable=\"\'relacion.bdrs, letra\'\" ng-if=\"!element.codigoEdicion \">\r\n            CBDRS{{$resolve.relacion.bdrs}}{{element.letra}}\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.edicion.letra\' | translate\" sortable=\"\'relacion.bdrs, letra\'\" ng-if=\"element.codigoEdicion\">\r\n            CBDRS{{element.codigoEdicion | translate}}\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.edicion.ano\' | translate\" sortable=\"\'anoInicio\'\">\r\n            {{element.anoInicio | translate}}\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.edicion.revisada\' | translate\" sortable=\"\'revisado\'\">\r\n            {{\'enum.boolean.\' + (element.revisado == null ? \'\' : element.revisado) | translate}}\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.edicion.publicada\' | translate\" sortable=\"\'publicado\'\">\r\n            {{\'enum.boolean.\' + (element.publicado == null ? \'\' : element.publicado) | translate}}\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <!--Ver ediciones de la Relacion-->\r\n            <a ui-sref=\"admin/ejemplar/list({edicionId: element.id})\" class=\"button fa fa-list-ul\" title=\"{{\'admin.form.button.showCopy\' | translate}}\" ng-if=\"element.idRelacion ==null\"></a>\r\n\r\n            <a ui-sref=\"admin/ejemplar/list({edicionId: element.id, relacionId: element.idRelacion})\" class=\"button fa fa-list-ul\" title=\"{{\'admin.form.button.showCopy\' | translate}}\" ng-if=\"element.idRelacion !=null\"></a>\r\n\r\n            <a ui-sref=\"admin/edicion/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-if=\"element.idRelacion ==null\"></a>\r\n\r\n            <a ui-sref=\"admin/edicion/edit({id: element.id, relacionId: element.idRelacion})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-if=\"element.idRelacion !=null\"></a>\r\n\r\n            <!--Eliminar elemento-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!element.isEditing\" ng-class=\"{\'disabled\':ctrl.userName!=element.nombreUsuario && ctrl.userRole!=\'ROLE_ADMIN\' }\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n");
$templateCache.put("app/admin/login/login.html","<div class=\"row\">\r\n    <div class=\"col-md-4 col-md-offset-4\">\r\n        <h1 translate=\"login.title\"></h1>\r\n        <form class=\"form\" role=\"form\">\r\n            <div class=\"form-group\">\r\n                <label for=\"username\" translate=\"login.form.username.label\"></label>\r\n                <input class=\"form-control\" id=\"username\" ng-model=\"loginCtrl.username\" type=\"text\">\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label for=\"password\" translate=\"login.form.password.label\"></label>\r\n                <input class=\"form-control\" id=\"password\" ng-model=\"loginCtrl.password\" type=\"password\">\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label for=\"rememberMe\">\r\n                    <input checked=\"true\" id=\"rememberMe\" ng-model=\"loginCtrl.rememberMe\" type=\"checkbox\">\r\n                    {{\'login.form.rememberme\' | translate}}</label>\r\n            </div>\r\n            <button class=\"btn btn-primary\" ng-click=\"loginCtrl.login()\" translate=\"login.form.button\" type=\"submit\"></button>\r\n        </form>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/admin/relacion/relacion.form.html","<form name=\"form\" role=\"form\" ng-submit=\"ctrl.save()\" show-validation=\"\">\r\n    <div class=\"form-body\">\r\n\r\n        <h4 translate=\"admin.relacion.create.title\" ng-if=\"ctrl.mode === \'create\'\"></h4>\r\n        <h4 translate=\"admin.relacion.edit.title\" ng-if=\"ctrl.mode === \'edit\'\"></h4>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-sm-12\">\r\n                <label-form key=\"admin.relacion.form.titulo\" for=\"titulo\" required=\"true\"></label-form>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.titulo\" id=\"titulo\" required=\"true\">\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!--Tipologías y subgeneros-->\r\n        <div class=\"row\">\r\n\r\n            <!--Tipología principal-->\r\n            <div class=\"form-group col-sm-3\">\r\n\r\n                <label-form key=\"admin.relacion.form.tipoPrincipal\"></label-form>\r\n                <select-form model=\"ctrl.item.tipologiaPrincipal \" options=\"ctrl.tipologias\">\r\n                </select-form>\r\n            </div>\r\n\r\n            <!--Subgénero principal-->\r\n            <div class=\"form-group col-sm-3\">\r\n\r\n                <label-form key=\"admin.relacion.form.subgenPrincipal\"></label-form>\r\n                <select class=\"form-control\" ng-model=\"ctrl.item.subgeneroPrincipal\" ng-options=\"subgenero as subgenero.nombre for subgenero in ctrl.subgeneros  |filter: {tipologia: {id:ctrl.item.tipologiaPrincipal.id }} track by subgenero.id     \" ng-disabled=\"!ctrl.item.tipologiaPrincipal\">\r\n                    <option value=\"\"></option>\r\n                </select>\r\n            </div>\r\n\r\n            <!--Tipología alternativa-->\r\n            <div class=\"form-group col-sm-3\">\r\n\r\n                <label-form key=\"admin.relacion.form.tipoAlternativa\"></label-form>\r\n                <select-form model=\"ctrl.item.tipologiaAlternativa\" options=\"ctrl.tipologias\" ng-disabled=\"!ctrl.item.tipologiaPrincipal\">\r\n                </select-form>\r\n            </div>\r\n\r\n            <!--Subgénero alternativo-->\r\n            <div class=\"form-group col-sm-3\">\r\n\r\n                <label-form key=\"admin.relacion.form.subgenAlternativo\"></label-form>\r\n                <select class=\"form-control\" ng-model=\"ctrl.item.subgeneroAlternativo\" ng-options=\"subgenero as subgenero.nombre for subgenero in ctrl.subgeneros  |filter: {tipologia: {id:ctrl.item.tipologiaAlternativa.id }} track by subgenero.id     \" ng-disabled=\"!ctrl.item.tipologiaAlternativa\">\r\n                    <option value=\"\"></option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class=\"row\">\r\n\r\n\r\n            <!--Contenido del componente ListForm-->\r\n            <script type=\"text/ng-template\" id=\"responsables.relacion.html\">\r\n                <!--Responsables-->\r\n                <div class=\"col-sm-10\">\r\n                    <div class=\"form-group\">\r\n                        <tesauro id=\"responsable_{{$index}}\" ng-model=\"element\"\r\n                                 resource=\"ctrl.resolve.responsableService\" method=\"simpleFilter\"\r\n                                 restricted=\"true\" multiple=\"false\" min-length=\"0\" simple-list-form=\"true\"\r\n                                 eliminable=\"true\"\r\n                                 parameters=\"{sortProperty: \'nombre\', size: 20}\" required=\"true\"\r\n                                 display=\"nombreCompleto\"\">\r\n                        </tesauro>\r\n                    </div>\r\n                </div>\r\n            </script>\r\n            <div class=\"form-group col-sm-6 in-line\">\r\n                <list-form label=\"admin.relacion.form.autores\" list=\"ctrl.item.responsables\" resolve=\"{responsableService: ctrl.responsableService}\" template-url=\"responsables.relacion.html\"></list-form>\r\n            </div>\r\n\r\n\r\n            <!--Contenido del componente ListForm-->\r\n            <script type=\"text/ng-template\" id=\"lugares.relacion.html\">\r\n                <!--Responsables-->\r\n                <div class=\"col-sm-10\">\r\n                    <div class=\"form-group\">\r\n                        <tesauro id=\"lugar_{{$index}}\" ng-model=\"element\"\r\n                                 resource=\"ctrl.resolve.lugarService\" method=\"simpleFilter\"\r\n                                 restricted=\"true\" multiple=\"false\" min-length=\"0\" simple-list-form=\"true\"\r\n                                 eliminable=\"true\"\r\n                                 parameters=\"{sortProperty: \'nombre\', size: 20}\" required=\"true\"></tesauro>\r\n                    </div>\r\n                </div>\r\n            </script>\r\n            <div class=\"form-group col-sm-6 in-line\">\r\n                <list-form label=\"admin.relacion.form.lugares\" list=\"ctrl.item.lugares\" resolve=\"{lugarService: ctrl.lugarService}\" template-url=\"lugares.relacion.html\"></list-form>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Años-->\r\n        <div class=\"row\">\r\n            <!--Año inicial-->\r\n            <div class=\"form-group col-sm-3\">\r\n                <label-form key=\"admin.relacion.form.anoInicio\" for=\"anoInicio\"></label-form>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.item.anoInicio\" id=\"anoInicio\">\r\n            </div>\r\n\r\n            <!--Año final-->\r\n            <div class=\"form-group col-sm-3\">\r\n                <label-form key=\"admin.relacion.form.anoFin\" for=\"anoFin\"></label-form>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.item.anoFin\" id=\"anoFin\">\r\n            </div>\r\n\r\n            <!--Año aproximado-->\r\n            <div class=\"col-sm-3 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"esAnoDeducido\" type=\"checkbox\" ng-model=\"ctrl.item.esAnoDeducido\">\r\n                    <label-form key=\"admin.relacion.form.esDeducido\" for=\"esAnoDeducido\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Año deducido-->\r\n            <div class=\"col-sm-3 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"esAnoAproximado\" type=\"checkbox\" ng-model=\"ctrl.item.esAnoAproximado\">\r\n                    <label-form key=\"admin.relacion.form.esAproximado\" for=\"esAnoAproximado\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Revisado y repasado-->\r\n        <div class=\"row\">\r\n            <div has-any-authority=\"ROLE_ADMIN\">\r\n                <div class=\"col-sm-3\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"revisado\" type=\"checkbox\" ng-model=\"ctrl.item.revisado\">\r\n                        <label-form key=\"admin.relacion.revisado\" for=\"revisado\"></label-form>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-sm-3\">\r\n                    <div class=\"form-group\">\r\n                        <input id=\"repasado\" type=\"checkbox\" ng-model=\"ctrl.item.repasado\">\r\n                        <label-form key=\"admin.relacion.repasado\" for=\"repasado\"></label-form>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Autor-->\r\n        <div class=\"row\">\r\n            <div ng-if=\"ctrl.item.nombreUsuario\">\r\n                <div class=\"col-sm-3\">\r\n                    <div class=\"form-group\">\r\n                        <label-form key=\"admin.relacion.creador\" for=\"creador\"></label-form>\r\n                        <span>{{ctrl.item.nombreUsuario}}</span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!--Botones-->\r\n        <div class=\"form-bottom-buttons\">\r\n            <a type=\"button\" ui-sref=\"admin/edicion/list({relacionId: ctrl.item.id})\" target=\"_blank\" class=\"btn btn-default\" ng-if=\"ctrl.mode === \'edit\'\">\r\n                <span translate=\"admin.relacion.form.ediciones\"></span>\r\n            </a>\r\n\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$root.back()\">\r\n                <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.cancel\"></span>\r\n            </button>\r\n\r\n            <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"ctrl.userName!=ctrl.item.nombreUsuario && ctrl.userRole!=\'ROLE_ADMIN\'&& ctrl.mode === \'edit\'\">\r\n                <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.create\" ng-if=\"ctrl.mode === \'create\'\"></span>\r\n                <span translate=\"admin.form.button.save\" ng-if=\"ctrl.mode === \'edit\'\"></span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/admin/relacion/relacion.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/relacion/create\">\r\n        <span translate=\"admin.relacion.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"form-group col-sm-3\">\r\n        <filter filter=\"ctrl.filter.key\"></filter>\r\n    </div>\r\n\r\n    <div class=\"form-group col-sm-3\">\r\n        <div class=\"form-group col-sm-4\">\r\n            <label>{{\'admin.relacion.filtrado.revisadas\' | translate}}:</label>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-6\">\r\n            <enum-select id=\"relacionrevisado\" model=\"ctrl.filter.revisado\" options=\"[true, false]\" base=\"enum.boolean\"></enum-select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group col-sm-3\">\r\n        <div class=\"form-group col-sm-4\">\r\n            <label>{{\'admin.relacion.filtrado.repasadas\' | translate}}:</label>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-6\">\r\n            <enum-select id=\"relacionrepasada\" model=\"ctrl.filter.repasado\" options=\"[true, false]\" base=\"enum.boolean\"></enum-select>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"total-elementos\" ng-if=\"ctrl.filter.idLugar\">\r\n    <label>{{\'admin.relacion.list.lugar\' | translate}} <b> {{ctrl.filter.nombreLugar}} </b></label>\r\n</div>\r\n\r\n<div class=\"total-elementos\" ng-if=\"ctrl.filter.idAutor\">\r\n    <label>{{\'admin.relacion.list.autor\' | translate}} <b> {{ctrl.filter.nombreAutor}} </b></label>\r\n</div>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total() |number}}</label>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n    <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n        <td data-title=\"\'admin.relacion.titulo\' | translate\" sortable=\"\'titulo\'\">\r\n            <a ui-sref=\"admin/relacion/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                {{element.titulo}}\r\n            </a>\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center\" data-title=\"\'admin.relacion.cbdrs\' | translate\" sortable=\"\'bdrs\'\">\r\n            {{\'CBDRS\'+ element.bdrs | translate}}\r\n\r\n\r\n        </td><td class=\"col-md-1 text-center\" data-title=\"\'admin.relacion.revisado\' | translate\" sortable=\"\'revisado\'\">\r\n            {{\'enum.boolean.\' + (element.revisado == null ? \'\' : element.revisado) | translate}}\r\n\r\n\r\n        </td><td class=\"col-md-1 text-center\" data-title=\"\'admin.relacion.repasado\' | translate\" sortable=\"\'repasado\'\">\r\n            {{\'enum.boolean.\' + (element.repasado == null ? \'\' : element.repasado) | translate}}\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n\r\n            <!--Ver ediciones de la Relacion-->\r\n            <a ui-sref=\"admin/edicion/list({relacionId: element.id})\" class=\"button fa fa-list-ul\" title=\"{{\'admin.form.button.showEdition\' | translate}}\"></a>\r\n\r\n            <!--Modificar relacion-->\r\n            <a ui-sref=\"admin/relacion/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n\r\n            <!--Eliminar elemento-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!element.isEditing\" ng-class=\"{ \'disabled\':ctrl.userName!=element.nombreUsuario && ctrl.userRole!=\'ROLE_ADMIN\' }\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n\r\n");
$templateCache.put("app/components/breadcrumb/breadcrumb.html","<ol class=\"breadcrumb\" ng-show=\"steps.length\">\r\n    <li ng-repeat=\"step in steps\" ng-class=\"{active: $last}\" ng-switch=\"$last || !!step.abstract\">\r\n        <a ng-switch-when=\"false\" href=\"{{step.ncyBreadcrumbLink}}\">{{step.ncyBreadcrumbLabel | translate}}</a>\r\n        <span ng-switch-when=\"true\">{{step.ncyBreadcrumbLabel | translate}}</span>\r\n    </li>\r\n</ol>\r\n");
$templateCache.put("app/components/descargar/descargar.html","<a ng-click=\"ctrl.descargarArchivo()\" title=\"{{ctrl.titulo | translate}}\" ng-class=\"{\'btn btn-default\': ctrl.mostrarBoton}\" class=\"btn-descarga\">\r\n    <span ng-if=\"ctrl.archivo && ctrl.url\" class=\"icon {{ctrl.getClase()}}\"></span><span translate=\"{{ctrl.texto}}\"></span>\r\n</a>\r\n");
$templateCache.put("app/components/estaticas/estatica.html","<div class=\"estatica {{ctrl.clase}}\">\r\n    <h1 ng-if=\"!ctrl.sinTitulo\">{{ctrl.estaticai18n.titulo}}</h1>\r\n\r\n    <div ng-bind-html=\"ctrl.estaticai18n.contenido | unsafe\"></div>\r\n</div>\r\n");
$templateCache.put("app/components/letras/letras.html","<div class=\"letras\">\r\n\r\n    <span ng-repeat=\"letra in ctrl.alfabeto\">\r\n        <a class=\"letra btn-primary\" ng-class=\"{\'oculta\': !ctrl.letraContenidaElementos(letra), \'btn-activo\': ctrl.letraSeleccionada==letra}\" ng-click=\"ctrl.showByLetter(letra)\">{{letra}}</a>\r\n    </span>\r\n\r\n    <span ng-if=\"ctrl.sinvalor\">\r\n        <a class=\"letra btn-primary\" ng-class=\"{\'sinvalor\': true, \'oculta\': !ctrl.letraContenidaElementos(\'-\'), \'btn-activo\': ctrl.letraSeleccionada==\'SINVALOR\'}\" ng-click=\"ctrl.showByLetter(\'SINVALOR\')\">{{\'admin.tesauro.sinvalor\' | translate}}</a>\r\n    </span>\r\n\r\n    <span ng-if=\"ctrl.todos\">\r\n        <a class=\"letra btn-primary\" ng-class=\"{\'todos\': true, \'oculta\': !ctrl.letraContenidaElementos(\'TODO\'), \'btn-activo\': ctrl.letraSeleccionada==\'TODO\'}\" ng-click=\"ctrl.showByLetter(\'TODO\')\">{{\'admin.tesauro.todos\' | translate}}</a>\r\n    </span>\r\n</div>\r\n");
$templateCache.put("app/components/menu/menu-bidiso.html","<div class=\"container\">\r\n\r\n    <div class=\"bidiso-title\">\r\n        <h1 class=\"main-title\">CBDRS</h1>\r\n        <h2 class=\"secondary-title\">CATÁLOGO Y BIBLIOTECA DIGITAL DE RELACIONES DE SUCESOS</h2>\r\n    </div>\r\n\r\n    <nav class=\"navbar\" ng-class=\"$root.isAdmin ? \'navbar-default\' : \'navbar-inverse\'\" ng-if=\"!$ctrl.lateral\" role=\"navigation\">\r\n        <div class=\"container mainNavbar\">\r\n            <div class=\"navbar-header desplegable-header\" ng-click=\"$ctrl.navCollapsed = !$ctrl.navCollapsed\">\r\n                <div class=\"menu-title-movil\">\r\n                    <h1>CBDRS</h1>\r\n                </div>\r\n                <button type=\"button\" class=\"navbar-toggle\">\r\n                    <span aria-hidden=\"true\" class=\"fa fa-sort-desc toggler-button\"></span>\r\n                </button>\r\n\r\n            </div>\r\n            <div class=\"collapse navbar-collapse\" id=\"navbar-collapse\" uib-collapse=\"$ctrl.navCollapsed\">\r\n                <ul class=\"menu menu-bidiso menu-mobil-bidiso\" ng-class=\"!$ctrl.lateral ? \'nav navbar-nav navbar-right\' : \'list-group lateral\'\">\r\n                    <li>\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/cbdrs/proyecto\">Proyecto</a>\r\n                    </li>\r\n                    <li class=\"active\">\r\n                        <a ui-sref=\"buscador\">Buscador</a>\r\n                    </li>\r\n                    <li>\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/cbdrs/equipo\">Equipo</a>\r\n                    </li>\r\n                    <li>\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/cbdrs/condiciones\">Condiciones de uso</a>\r\n                    </li>\r\n                    <li>\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/cbdrs/ayuda\">Ayuda</a>\r\n                    </li>\r\n                    <li>\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/cbdrs/info\">+Info</a>\r\n                    </li>\r\n                    <li>\r\n                        <a ng-href=\"{{$root.bidisoURL}}/biblioteca/cbdrs/resultados\">Resultados</a>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </nav>\r\n</div>\r\n\r\n");
$templateCache.put("app/components/menu/menu-item.html","<li ng-class=\"{divider: leaf.label == \'divider\'}\" ui-sref-active=\"active\">\r\n\r\n    <a ng-if=\"leaf.label !== \'divider\' &amp;&amp; !leaf.state &amp;&amp; !leaf.link\">\r\n        <ng-include src=\"\'menuItemContent.html\'\"></ng-include>\r\n    </a>\r\n\r\n    <a ui-sref=\"{{leaf.state}}\" ng-if=\"leaf.state &amp;&amp; leaf.label !== \'divider\'\">\r\n        <ng-include src=\"\'menuItemContent.html\'\"></ng-include>\r\n    </a>\r\n\r\n    <a href=\"{{leaf.link}}\" ng-if=\"leaf.link &amp;&amp; leaf.label !== \'divider\'\">\r\n        <ng-include src=\"\'menuItemContent.html\'\"></ng-include>\r\n    </a>\r\n</li>\r\n");
$templateCache.put("app/components/menu/menu.html","<script type=\"text/ng-template\" id=\"menuContent.html\">\r\n    <span class=\"{{leaf.icon}}\"></span>\r\n    <span>\r\n        <span translate>\r\n            {{leaf.label}}\r\n        </span>\r\n        <b ng-if=\"leaf.subtree\" class=\"caret\"></b>\r\n    </span>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"menuItemContent.html\">\r\n    <span class=\"{{leaf.icon}}\"></span>\r\n    <span translate>\r\n            {{leaf.label}}\r\n    </span>\r\n</script>\r\n\r\n<script type=\"text/ng-template\" id=\"menuElementsContent.html\">\r\n    <ul ng-class=\"!$ctrl.lateral ? \'nav navbar-nav navbar-right\' : \'list-group lateral\'\" class=\"menu\">\r\n        <li\r\n            uib-dropdown\r\n            ui-sref-active=\"active\"\r\n            ng-repeat=\"leaf in $ctrl.menu\"\r\n            ng-class=\"{\'divider-vertical\': leaf.label == \'divider\',\r\n                \'active\': leaf.actives && $ctrl.checkActiveStates(leaf.actives),\r\n                \'list-group-item\' : $ctrl.lateral,\r\n                \'{{leaf.class}}\' : true}\"\r\n            has-any-authority-or-state\r\n            authorities=\"leaf.authorities\"\r\n            states=\"leaf.states\">\r\n\r\n            <a ng-if=\"leaf.componente\" compile=\"leaf.componente\" class=\"component\"></a>\r\n\r\n            <!--Ventana modal-->\r\n            <a ng-if=\"leaf.modal\" ng-click=\"$ctrl.modal(leaf.modal)\">\r\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\r\n            </a>\r\n\r\n            <!--Dropdown-->\r\n            <a ng-if=\"leaf.label !== \'divider\' && leaf.subtree && !leaf.link && !leaf.modal\"\r\n               uib-dropdown-toggle>\r\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\r\n            </a>\r\n\r\n            <!--Estado-->\r\n            <a ng-if=\"leaf.label !== \'divider\' && leaf.state && !leaf.subtree\"\r\n               ui-sref=\"{{leaf.state}}\"\r\n               ng-click=\"$ctrl.itemClick()\">\r\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\r\n            </a>\r\n\r\n            <!--Enlace-->\r\n            <a ng-if=\"leaf.label !== \'divider\' && leaf.link && !leaf.subtree\"\r\n               href=\"{{leaf.link}}\">\r\n                <ng-include src=\"\'menuContent.html\'\"></ng-include>\r\n            </a>\r\n\r\n            <submenu ng-if=\"leaf.subtree\" menu=\"leaf.subtree\"></submenu>\r\n        </li>\r\n    </ul>\r\n</script>\r\n\r\n<div class=\"menu-opener\" ng-if=\"$ctrl.lateral\">\r\n    <span ng-click=\"$ctrl.openSidemenu()\" class=\"fa fa-bars\"></span>\r\n</div>\r\n<div id=\"menu-overlay\" class=\"menu-overlay\" ng-click=\"$ctrl.closeSidemenu()\" ng-if=\"$ctrl.lateral\"></div>\r\n\r\n<nav class=\"navbar\" role=\"navigation\" ng-class=\"$root.isAdmin ? \'navbar-default\' : \'navbar-inverse\'\" ng-if=\"!$ctrl.lateral\">\r\n    <div class=\"container mainNavbar\">\r\n        <div class=\"navbar-header\">\r\n            <button type=\"button\" class=\"navbar-toggle\" ng-click=\"$ctrl.navCollapsed = !$ctrl.navCollapsed\">\r\n\r\n                <span class=\"sr-only\">Toggle navigation</span>\r\n                <span class=\"icon-bar\"></span>\r\n                <span class=\"icon-bar\"></span>\r\n                <span class=\"icon-bar\"></span>\r\n            </button>\r\n\r\n            <a ng-if=\"$root.isAdmin\" class=\"navbar-brand\">\r\n                <span translate=\"admin.title\"></span>\r\n            </a>\r\n        </div>\r\n        <div class=\"collapse navbar-collapse\" id=\"navbar-collapse\" uib-collapse=\"$ctrl.navCollapsed\">\r\n\r\n            <ng-include src=\"\'menuElementsContent.html\'\"></ng-include>\r\n        </div>\r\n    </div>\r\n\r\n</nav>\r\n\r\n\r\n<div ng-if=\"$ctrl.lateral\">\r\n    <ng-include src=\"\'menuElementsContent.html\'\"></ng-include>\r\n</div>\r\n\r\n\r\n");
$templateCache.put("app/components/menu/submenu.html","<ul class=\"dropdown-menu\">\r\n    <menu-item ng-repeat=\"leaf in menu\" leaf=\"leaf\">\r\n    </menu-item>\r\n</ul>\r\n");
$templateCache.put("app/layouts/footer/footer.admin.html","<div class=\"container\">\r\n    <!--Empty footer-->\r\n</div>\r\n");
$templateCache.put("app/layouts/footer/footer.bidiso.html","<div class=\"container\" style=\"padding: 0\">\r\n    <div class=\"images-footer\">\r\n\r\n        <a href=\"https://www.bidiso.es/sielae\" target=\"_blank\">\r\n            <img alt=\"\" class=\"mr-4 mt-2 mb-2 ml-md-0 ml-4\" id=\"sielae-icon\" src=\"assets/images/sielae.png\">\r\n        </a>\r\n\r\n        <a href=\"https://www.udc.es/\" target=\"_blank\">\r\n            <img alt=\"\" class=\"mr-4 mt-2 mb-2 ml-4\" id=\"udc-icon\" src=\"assets/images/udc.png\">\r\n        </a>\r\n\r\n        <a href=\"https://www.xunta.gal/portada\" target=\"_blank\">\r\n            <img alt=\"\" class=\"mr-4 ml-4 mt-2 mb-2\" id=\"xunta-icon\" src=\"assets/images/xunta_galicia.png\">\r\n        </a>\r\n        <a href=\"https://www.red-aracne.es/presentacion\" target=\"_blank\">\r\n            <img alt=\"\" class=\"mr-4 mt-2 mb-2 ml-4\" id=\"aracne-icon\" src=\"assets/images/aracne.png\">\r\n        </a>\r\n\r\n    </div>\r\n</div>\r\n<div class=\"info-footer\">\r\n    <div class=\"info-footer-content container-fluid\">\r\n        <div class=\"custom-container\">\r\n            <div class=\"info-footer-links\">\r\n                <span class=\"footer-link\">© 1996-2023 - SIELAE-BIDISO</span>\r\n                <span class=\"footer-link\">\r\n                    <i class=\"fa fa-envelope-o\"></i> &nbsp;\r\n                    <a href=\"mailto:info@bidiso.com\">bidiso@udc.es</a>\r\n                </span>\r\n                <span class=\"footer-link\">\r\n                    <a class=\"\" ng-href=\"{{$root.bidisoURL}}/estatica/legal\">INFORMACIÓN LEGAL</a>\r\n                </span>\r\n                <!--            <span class=\"pl-4 pr-md-0 pr-4 mt-2 mb-2\">Última actualización:</span>-->\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/layouts/footer/footer.html","<div class=\"container\">\r\n    <div id=\"logosColaboracion\" align=\"center\">\r\n        <a href=\"http://www.bidiso.es/index.htm\" target=\"_blank\"><img ng-src=\"assets/images/logo_bidiso.png\"></a>\r\n        <a href=\"http://www.bidiso.es/sielae/\" target=\"_blank\"><img ng-src=\"assets/images/sielae.png\"></a>\r\n        <a href=\"http://www.micinn.es/\" target=\"_blank\"><img ng-src=\"assets/images/feder.jpg\"></a>\r\n        <a href=\"http://www.udc.es/\" target=\"_blank\"><img ng-src=\"assets/images/udc.png\"></a>\r\n        <a href=\"http://www.xunta.es/\" target=\"_blank\"><img ng-src=\"assets/images/xunta_galicia.png\"></a>\r\n        <a href=\"http://ucor1301.cli.lbd.org.es/\" target=\"_blank\"><img ng-src=\"assets/images/aracne.png\"></a>\r\n    </div>\r\n\r\n    <div class=\"copyright\" translate=\"footer.copyright\"></div>\r\n\r\n</div>\r\n");
$templateCache.put("app/layouts/header/header.html","<div class=\"container\">\r\n    <div>\r\n        <a ui-sref=\"home\">\r\n            <div class=\"logo\"><img ng-src=\"assets/images/LOGO-CBDRS.png\"></div>\r\n        </a>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak>\r\n    <div class=\"row\">\r\n\r\n        <div class=\"col-md-12\">\r\n            <h4 class=\"text-center\" translate=\"error.accessdenied.content\">Acceso denegado</h4>\r\n\r\n            <div ng-show=\"errorMessage\">\r\n                <div class=\"alert alert-danger\">{{errorMessage}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak>\r\n    <div class=\"row\">\r\n\r\n        <div class=\"col-md-12\">\r\n            <h4 class=\"text-center\" translate=\"error.error.content\">Se ha producido un error</h4>\r\n\r\n            <div ng-show=\"errorMessage\">\r\n                <div class=\"alert alert-danger\">{{errorMessage}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/layouts/header-bidiso/header-bidiso.html","<nav class=\"navbar navbar-default\">\r\n    <div class=\"bidiso-nav\">\r\n        <div class=\"navbar-header menu-header\">\r\n            <div class=\"brand-ministerio\">\r\n                <a class=\"\" style=\"padding: 0; display: flex; flex-direction: column\" href=\"https://www.ciencia.gob.es/\" target=\"_blank\">\r\n                    <span class=\"mcin-message\">Ayuda PID2019-105673GB-I00 financiada por:</span>\r\n                    <div class=\"mcin-image\">\r\n                        <img src=\"assets/images/micin-aei.png\" class=\"d-block\" alt=\"\">\r\n                    </div>\r\n                </a>\r\n            </div>\r\n            <a class=\"bidiso-brand principal-brand\" ng-href=\"{{$root.bidisoURL}}\">\r\n                <div class=\"brand-image\"></div>\r\n            </a>\r\n            <div class=\"submenu collapsed\">\r\n                <button aria-expanded=\"false\" class=\"navbar-toggle\" ng-click=\"ctrl.openNav()\" data-toggle=\"collapse\" id=\"hamburguer\" type=\"button\">\r\n                    <span class=\"sr-only\">Toggle navigation</span>\r\n                    <i class=\"fa fa-bars\" aria-hidden=\"true\"></i>\r\n                </button>\r\n            </div>\r\n\r\n            <div class=\"collapse navbar-collapse collapse bidiso-menu\" id=\"bidiso-nav-collapse\">\r\n                <ul class=\"nav navbar-nav\">\r\n                    <li>\r\n                        <a class=\"nav-link\" ng-href=\"{{$root.bidisoURL}}/recursos\">RECURSOS</a>\r\n                    </li>\r\n                    <li>\r\n                        <a class=\"nav-link\" ng-href=\"{{$root.bidisoURL}}/estatica/proyecto\">PROYECTO</a>\r\n                    </li>\r\n                    <li>\r\n                        <a class=\"nav-link menu\" ng-href=\"{{$root.bidisoURL}}/equipo\">EQUIPO</a>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"second-line-header\">\r\n        <a class=\"bidiso-brand\" ng-href=\"{{$root.bidisoURL}}\">\r\n            <div class=\"brand-image\"></div>\r\n        </a>\r\n    </div>\r\n</nav>\r\n\r\n<div class=\"sidenav\" id=\"mySidenav\">\r\n    <div class=\"close-button\">\r\n        <span class=\"cross\" ng-click=\"ctrl.closeNav()\">✕</span>\r\n    </div>\r\n\r\n    <div class=\"sidenav-menu\">\r\n        <ul>\r\n            <li>\r\n                <a ng-href=\"{{$root.bidisoURL}}/estatica/recursos\">RECURSOS</a>\r\n            </li>\r\n            <li>\r\n                <a ng-href=\"{{$root.bidisoURL}}/estatica/proyecto\">PROYECTO</a>\r\n            </li>\r\n            <li>\r\n                <a ng-href=\"{{$root.bidisoURL}}/equipo\">EQUIPO</a>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/public/biblioteca/biblioteca.details.html","<div class=\"biblioteca-details\">\r\n\r\n    <!--Titulo pagina-->\r\n    <div>\r\n        <div class=\"titulo-bloque\">\r\n            <span>{{ \'biblioteca.titulo\' | translate}}</span>\r\n            <span class=\"titulobarras\"></span>\r\n        </div>\r\n    </div>\r\n\r\n    <!--Nombre-->\r\n    <div class=\"row\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'biblioteca.nombre\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n            <span>{{$resolve.biblioteca.nombre}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.biblioteca.calle\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'biblioteca.calle\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.biblioteca.calle}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--Número-->\r\n    <div class=\"row\" ng-if=\"$resolve.biblioteca.numero\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'biblioteca.numero\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.biblioteca.numero}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.biblioteca.codigoPostal\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'biblioteca.codigoPostal\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.biblioteca.codigoPostal}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.biblioteca.ciudad\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'biblioteca.ciudad\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.biblioteca.ciudad}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.biblioteca.pais\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'biblioteca.pais\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.biblioteca.pais}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.biblioteca.telefono\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'biblioteca.telefono\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.biblioteca.telefono}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.biblioteca.fax\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'biblioteca.fax\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.biblioteca.fax}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.biblioteca.email\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'biblioteca.email\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.biblioteca.email}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.biblioteca.web\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'biblioteca.web\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.biblioteca.web}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/public/home/home.html","<estatica id=\"principal\" bd=\"true\"></estatica>\r\n");
$templateCache.put("app/public/ejemplar/ejemplar.details.html","<div class=\"ejemplar-details\">\r\n    <!--Titulo pagina-->\r\n    <div class=\"row\">\r\n        <div class=\"titulo-edicion col-sm-12\">\r\n            <span>{{$resolve.ejemplar.edicion.titulo}}</span>\r\n        </div>\r\n    </div>\r\n\r\n    <!--Titulo pagina-->\r\n    <div>\r\n        <div class=\"titulo-bloque\">\r\n            <span>{{ \'ejemplar.titulo\' | translate}}</span>\r\n        </div>\r\n    </div>\r\n\r\n    <!--------------------------------------------------------->\r\n    <!--Signatura-->\r\n    <div class=\"row\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'ejemplar.signatura\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.ejemplar.signatura}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--biblioteca-->\r\n    <div class=\"row\" ng-if=\"$resolve.ejemplar.biblioteca.nombre\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'ejemplar.biblioteca\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <a ui-sref=\"bibliotecaDetails({idBiblioteca: $resolve.ejemplar.biblioteca.id})\">\r\n                <span>{{$resolve.ejemplar.biblioteca.nombre}}</span>\r\n            </a>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--ex-libris-->\r\n    <div class=\"row\" ng-if=\"$resolve.ejemplar.exLibris || $resolve.ejemplar.tieneExLibris\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'ejemplar.exLibris\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span><booleano value=\"{{$resolve.ejemplar.tieneExLibris}}\"></booleano>.</span>\r\n            <span ng-if=\"!$resolve.ejemplar.exLibris\">{{\'ejemplar.noConsta\' | translate}}</span>\r\n            <span ng-bind-html=\"$resolve.ejemplar.exLibris\"></span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--comentarios-->\r\n    <div class=\"row\" ng-if=\"$resolve.ejemplar.comentarios\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'ejemplar.comentarios\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.ejemplar.comentarios}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--observaciones-->\r\n    <div class=\"row\" ng-if=\"$resolve.ejemplar.observaciones\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'ejemplar.observaciones\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.ejemplar.observaciones}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--investigador-->\r\n    <div class=\"row\" ng-if=\"$resolve.ejemplar.investigador\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'ejemplar.investigador\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.ejemplar.investigador}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--fuente bibliográfica-->\r\n    <div class=\"row\" ng-if=\"$resolve.ejemplar.fuenteBibliografica\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'ejemplar.fuenteBibliografica\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.ejemplar.fuenteBibliografica}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--encuadernacion-->\r\n    <div class=\"row\" ng-if=\"$resolve.ejemplar.encuadernacion\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'ejemplar.encuadernacion\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-2\">\r\n            <enumerado base=\"enum.encuadernacion\" value=\"{{$resolve.ejemplar.encuadernacion}}\"></enumerado>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!-- booleanos-->\r\n    <div class=\"row\" ng-if=\"$resolve.ejemplar.tienePortada\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'ejemplar.tienePortada\'| translate}}</span>\r\n        </div>\r\n\r\n        <div class=\"col-sm-4\">\r\n            <booleano value=\"{{$resolve.ejemplar.tienePortada}}\"></booleano>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.ejemplar.visto\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'ejemplar.visto\'| translate}}</span>\r\n        </div>\r\n\r\n        <div class=\"col-sm-4\">\r\n            <booleano value=\"{{$resolve.ejemplar.visto}}\"></booleano>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--Referencias ejemplar-->\r\n    <div class=\"titulo-bloque\" ng-if=\"!$resolve.ejemplar.referencias.length ==0\">\r\n        <span>{{ \'ejemplar.referencias\' | translate}}</span>\r\n    </div>\r\n\r\n    <!--Se mete el link en el nombre de la referencia, sino las url muy grandes no quedaban bien-->\r\n    <div class=\"row\" ng-repeat=\"referencia in $resolve.ejemplar.referencias\">\r\n        <div class=\"col-sm-12\">\r\n            <a ng-href=\"{{referencia.url}}\" target=\"_blank\">{{referencia.titulo}} <span class=\"glyphicon glyphicon-link\"></span></a>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--Paginas transcritas-->\r\n    <div>\r\n        <div class=\"titulo-bloque\" ng-if=\" $resolve.ejemplar.pdfTranscritoPath !=null\">\r\n            <span>{{ \'ejemplar.ejemplarTranscrito\' | translate}}</span>\r\n            <descargar archivo=\"$resolve.ejemplar.pdfTranscritoPath\" url=\"{{ctrlDetails.urlBaseTranscrito}}\" mostrarboton=\"false\" texto=\"\" titulo=\"{{\'ejemplar.ejemplarCompleto\' | translate}}\">\r\n            </descargar>\r\n        </div>\r\n    </div>\r\n\r\n    <!--Paginas digitalizadas-->\r\n    <div ng-if=\" ctrlDetails.paginas.length !=0 || $resolve.ejemplar.pdfDigitalizadoPath != null\">\r\n        <div class=\"titulo-bloque\">\r\n            <span>{{ \'ejemplar.paginas\' | translate}}</span>\r\n            <descargar archivo=\"$resolve.ejemplar.pdfDigitalizadoPath\" url=\"{{ctrlDetails.urlBaseDigitalizado}}\" mostrarboton=\"false\" texto=\"\" titulo=\"{{\'ejemplar.ejemplarCompleto\' | translate}}\"></descargar>\r\n        </div>\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-12\">\r\n                <ng-image-gallery images=\"ctrlDetails.paginas\" methods=\"methods\" thumbnails=\"true\" thumb-size=\"150\"></ng-image-gallery>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/public/edicion/buscador.avanzado.edicion.html","<div class=\"buscador-avanzado-edicion\">\r\n\r\n    <div class=\"row row-stilo\">\r\n        <div class=\"col-sm-9\">\r\n            <!--Título del buscador-->\r\n            <h4 class=\"titulo-buscador\">\r\n                {{\'buscador.avanzado.nombre\' | translate}}\r\n            </h4>\r\n        </div>\r\n        <div class=\"col-sm-3\" style=\"display: flex; justify-content: flex-end\">\r\n            <!--Botón de cambiar buscador-->\r\n            <div class=\"text-right button-left\">\r\n                <button type=\"button\" class=\"btn btn-primary-public\" ng-click=\"ctrl.cambiarBuscador(false)\">\r\n                    {{\'buscador.avanzado.buscadorBasico\' | translate}}\r\n                </button>\r\n            </div>\r\n            <div>\r\n                <div class=\"text-right button-left\" style=\"margin-left: 5px !important\">\r\n                    <button type=\"button\" class=\"btn btn-primary-public btn-buscador\" ui-sref=\"lugares/list\">\r\n                        Mapa\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-12 public-link\">\r\n            <a ng-click=\"ctrl.openInstructions()\"> {{\'instrucciones.title\' | translate}}</a>\r\n        </div>\r\n    </div>\r\n\r\n    <buscador-avanzado ediciones=\"$resolve.ediciones\" tipologias=\"$resolve.tipologias\" subgeneros=\"$resolve.subgeneros\" idiomas=\"$resolve.idiomas\" bibliotecas=\"$resolve.bibliotecas\" modalidades=\"$resolve.modalidades\" tamanos=\"$resolve.tamanos\" on-buscar=\"ctrl.buscar\" on-clear=\"ctrl.clear\" filter=\"ctrl.filter\"></buscador-avanzado>\r\n\r\n    <!--Listado de ediciones-->\r\n    <div ng-include=\"\'app/public/edicion/buscador.edicion.resultados.html\'\"></div>\r\n\r\n</div>\r\n");
$templateCache.put("app/public/edicion/buscador.basico.edicion.html","<div class=\"buscador-basico-edicion\">\r\n\r\n    <div class=\"row row-stilo\">\r\n        <div class=\"col-sm-9\">\r\n            <!--Título del buscador-->\r\n            <h4 class=\"titulo-buscador\">\r\n                {{\'buscador.basico.nombre\' | translate}}\r\n            </h4>\r\n        </div>\r\n        <div class=\"col-sm-3\" style=\"display: flex; justify-content: flex-end\">\r\n            <!--Botón de cambiar buscador-->\r\n            <div class=\"text-right button-left\">\r\n                <button type=\"button\" class=\"btn btn-primary-public btn-buscador\" ng-click=\"ctrl.cambiarBuscador(true)\">\r\n                    {{\'buscador.basico.buscadorAvanzado\' | translate}}\r\n                </button>\r\n            </div>\r\n\r\n            <div>\r\n                <div class=\"text-right button-left\" style=\"margin-left: 5px !important\">\r\n                    <button type=\"button\" class=\"btn btn-primary-public btn-buscador\" ui-sref=\"lugares/list\">\r\n                        Mapa\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-12 public-link\">\r\n            <a ng-click=\"ctrl.openInstructions()\"> {{\'instrucciones.title\' | translate}}</a>\r\n        </div>\r\n    </div>\r\n\r\n    <buscador-basico ediciones=\"$resolve.ediciones\" on-buscar=\"ctrl.buscar\" on-clear=\"ctrl.clear\" filter=\"ctrl.filter\"></buscador-basico>\r\n\r\n    <!--Listado de ediciones-->\r\n    <div ng-include=\"\'app/public/edicion/buscador.edicion.resultados.html\'\"></div>\r\n</div>\r\n");
$templateCache.put("app/public/edicion/buscador.edicion.resultados.html","<!--Paginacion-->\r\n<div class=\"paginacion\">\r\n    <pagination current-page=\"ctrl.pagina\" total-elements=\"$resolve.ediciones.totalElements\" sort-property=\"ctrl.filter.sortProperty\"></pagination>\r\n</div>\r\n\r\n<!--Elementos recuperados-->\r\n<div class=\"titulo-bloque more-margins\">\r\n    <input id=\"check_ediciones\" type=\"checkbox\" ng-if=\"$resolve.ediciones.content.length !=0\" ng-click=\"ctrl.seleccionarTodas()\">\r\n\r\n    <div class=\"botones-exportar\">\r\n        <a class=\"fa fa-file-pdf-o\" ng-click=\"ctrl.exportarAPDF(ctrl.filter)\" ng-if=\"$resolve.ediciones.content.length !=0\" title=\"{{\'buscador.basico.exportar\' | translate}}\"></a>\r\n\r\n        <a class=\"fa fa-envelope-o\" ng-click=\"ctrl.enviarEmail(ctrl.filter)\" ng-if=\"$resolve.ediciones.content.length !=0\" title=\"{{\'buscador.basico.email\' | translate}}\"></a>\r\n\r\n    </div>\r\n\r\n    <label>{{\'global.total-ediciones\' | translate}}: {{$resolve.ediciones.totalElements |number}}</label>\r\n\r\n    <div class=\"text-right\">\r\n        <a class=\"color-green\" ng-click=\"ctrl.cambiarCriterioOrdenacion(\'autor\')\" ng-class=\"{\'enlace-seleccionado\': ctrl.filter.sortProperty == \'autor\'}\">\r\n            {{\'listado.alfabetica\' | translate}}\r\n        </a>\r\n\r\n        <span> / </span>\r\n\r\n        <a class=\"color-green\" ng-click=\"ctrl.cambiarCriterioOrdenacion(\'anoInicio\')\" ng-class=\"{\'enlace-seleccionado\': ctrl.filter.sortProperty == \'anoInicio\'}\">\r\n            {{\'listado.cronologica\' | translate}}\r\n        </a>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\"></div>\r\n\r\n<!--Listado de ediciones -->\r\n<edicion-list ediciones=\"$resolve.ediciones.content\" check=\"true\"></edicion-list>\r\n\r\n<!--Paginación-->\r\n<div class=\"center\">\r\n    <pagination current-page=\"ctrl.pagina\" total-elements=\"$resolve.ediciones.totalElements\"></pagination>\r\n</div>\r\n");
$templateCache.put("app/public/edicion/edicion.details.html","<div class=\"edicion-details\">\r\n\r\n    <!--Titulo pagina-->\r\n    <div class=\"row\">\r\n        <div class=\"titulo-edicion col-sm-12\">\r\n            <span>{{$resolve.edicion.titulo}}</span>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.creadaRecientemente\">\r\n        <div class=\"col-sm-4\">\r\n            <span>\r\n                <i class=\"nombre-campos fa fa-forward\"></i>\r\n                <span class=\"nombre-campos\">{{ \'edicion.creadaRecientemente\' | translate}}</span>\r\n            </span>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.modificadaRecientemente && !$resolve.edicion.creadaRecientemente\">\r\n        <div class=\"col-sm-6\">\r\n                <span>\r\n                <i class=\"nombre-campos fa fa-forward\"></i>\r\n                <span class=\"nombre-campos\">{{ \'edicion.modificadaRecientemente\' | translate}}</span>\r\n            </span>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--Detalles relacion--------------------------------------------------------------------------------------------->\r\n    <div>\r\n        <div class=\"titulo-bloque\">\r\n            <label>{{ \'relacion.seccion.titulo\' | translate}}</label>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--Tipologia y subgenero principal-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.relacion.tipologiaPrincipal\">\r\n        <div ng-if=\"$resolve.edicion.relacion.tipologiaPrincipal\">\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'relacion.tipologiaP\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n                <span>{{$resolve.edicion.relacion.tipologiaPrincipal.nombre}}</span>\r\n            </div>\r\n        </div>\r\n        <div ng-if=\"$resolve.edicion.relacion.subgeneroPrincipal\">\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'relacion.subgeneroP\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n                <span>{{$resolve.edicion.relacion.subgeneroPrincipal.nombre}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--Tipologia y subgenero alternativo-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.relacion.tipologiaAlternativa\">\r\n        <div ng-if=\"$resolve.edicion.relacion.tipologiaAlternativa\">\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'relacion.tipologiaA\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n                <span>{{$resolve.edicion.relacion.tipologiaAlternativa.nombre}}</span>\r\n            </div>\r\n        </div>\r\n        <div ng-if=\"$resolve.edicion.relacion.subgeneroAlternativo\">\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'relacion.subgeneroA\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-3\">\r\n                <span>{{$resolve.edicion.relacion.subgeneroAlternativo.nombre}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--años acontecimiento -->\r\n    <div class=\"row\">\r\n        <div>\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'relacion.ano\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n                <span ng-if=\"$resolve.edicion.relacion.esAnoDeducido || $resolve.edicion.relacion.anoInicio ==null\">[</span><span ng-if=\"$resolve.edicion.relacion.anoInicio !=null\">{{$resolve.edicion.relacion.anoInicio}}</span><span ng-if=\"$resolve.edicion.relacion.anoFin !=null\"> - {{$resolve.edicion.relacion.anoFin}}</span><span ng-if=\"$resolve.edicion.relacion.anoInicio ==null\">S.A.</span><span ng-if=\"$resolve.edicion.relacion.esAnoAproximado\">?</span><span ng-if=\"$resolve.edicion.relacion.esAnoDeducido || $resolve.edicion.relacion.anoInicio ==null\">]</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--autores-->\r\n    <div class=\"row\" ng-if=\"!$resolve.edicion.relacion.responsables.length ==0 \">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'relacion.autor\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span ng-repeat=\"autor in $resolve.edicion.relacion.responsables\"> {{autor.apellidos}}  <span ng-if=\" autor.nombre != null\"> , </span>\r\n                {{autor.nombre}} {{$last ? \'\' : \' - \'}}\r\n            </span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--BDRS, lugar de acontecimiento-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.relacion.bdrs || $resolve.edicion.relacion.lugares\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'relacion.bdrs\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n            <span>{{$resolve.edicion.relacion.bdrs}}</span>\r\n        </div>\r\n\r\n        <div ng-if=\"$resolve.edicion.relacion.lugares.length!=0\">\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'relacion.lugar\' | translate}}</span>\r\n            </div>\r\n\r\n            <div class=\"col-sm-4\">\r\n                <span ng-repeat=\"lugar in $resolve.edicion.relacion.lugares\"> {{lugar.nombre}}{{$last ? \'\' : \' - \'}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--Detalles edicion--------------------------------------------------------------------------------------------->\r\n    <div>\r\n        <div class=\"titulo-bloque\">\r\n            <span>{{ \'edicion.seccion.titulo\' | translate}}</span>\r\n        </div>\r\n    </div>\r\n\r\n    <!--codigo de edicion-->\r\n    <div class=\"row\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'edicion.letra\' | translate}}</span>\r\n        </div>\r\n\r\n        <div class=\"col-sm-4\">\r\n            <span>{{$resolve.edicion.relacion.bdrs}}{{$resolve.edicion.letra}}</span>\r\n        </div>\r\n\r\n        <!--lugar de edicion -->\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'edicion.lugar\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n                <span ng-if=\"$resolve.edicion.esLugarDeducido\">[</span><span ng-if=\"$resolve.edicion.lugar !=null\">{{$resolve.edicion.lugar.nombre}}</span><span ng-if=\"$resolve.edicion.lugar ==null\">S.L</span><span ng-if=\"$resolve.edicion.esLugarProbable\">?</span><span ng-if=\"$resolve.edicion.esLugarDeducido\">]</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--Impresores-->\r\n    <div class=\"row\" ng-if=\"!ctrlDetails.impresores.length ==0\">\r\n        <div>\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'edicion.impresores\' | translate}}</span>\r\n            </div>\r\n            <!--mostramos espacio y coma entre cada elemento, menos en el final-->\r\n            <div class=\"col-sm-4\">\r\n            <span ng-repeat=\"impresor in ctrlDetails.impresores\"> {{impresor.nombreFormateado}}{{$last ? \'\' : \' - \'}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--años -->\r\n    <div class=\"row\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'edicion.ano\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n                <span ng-if=\"$resolve.edicion.esAnoDeducido || $resolve.edicion.anoInicio ==null \">[</span><span ng-if=\"$resolve.edicion.anoInicio !=null\">{{$resolve.edicion.anoInicio}}</span><span ng-if=\"$resolve.edicion.anoFin !=null\"> - {{$resolve.edicion.anoFin}}</span><span ng-if=\"$resolve.edicion.anoInicio ==null\">S.A.</span><span ng-if=\"$resolve.edicion.esAnoAproximado\">?</span><span ng-if=\"$resolve.edicion.esAnoDeducido || $resolve.edicion.anoInicio ==null\">]</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--Editores-->\r\n    <div class=\"row\" ng-if=\"!ctrlDetails.editores.length ==0\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'edicion.editores\' | translate}}</span>\r\n        </div>\r\n        <!--mostramos espacio y coma entre cada elemento, menos en el final-->\r\n        <div class=\"col-sm-10\">\r\n            <span ng-repeat=\"editor in ctrlDetails.editores\"> {{editor.nombreFormateado}}{{$last ? \'\' : \' - \'}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--Traductores-->\r\n    <div class=\"row\" ng-if=\"!ctrlDetails.traductores.length ==0\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'edicion.traductores\' | translate}}</span>\r\n        </div>\r\n        <!--mostramos espacio y coma entre cada elemento, menos en el final-->\r\n        <div class=\"col-sm-10\">\r\n            <span ng-repeat=\"traductor in ctrlDetails.traductores\"> {{traductor.nombreFormateado}}{{$last ? \'\' : \' - \'}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--Otros-->\r\n    <div class=\"row\" ng-if=\"!ctrlDetails.otros.length ==0\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'edicion.otros\' | translate}}</span>\r\n        </div>\r\n        <!--mostramos espacio y coma entre cada elemento, menos en el final-->\r\n        <div class=\"col-sm-10\">\r\n            <span ng-repeat=\"otro in ctrlDetails.otros\"> {{otro.nombreFormateado}}{{$last ? \'\' : \' - \'}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--tamaño y numero de paginas-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.tamano || $resolve.edicion.numPaginas\">\r\n        <div ng-if=\"$resolve.edicion.tamano\">\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'edicion.tamano\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n                <enumerado base=\"enum.tamano\" value=\"{{$resolve.edicion.tamano}}\"></enumerado>\r\n            </div>\r\n        </div>\r\n\r\n        <div ng-if=\"$resolve.edicion.numPaginas\">\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'edicion.numPaginas\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n                <span>{{$resolve.edicion.numPaginas}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--signatura tipografica-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.sigTipografica\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'edicion.signatura\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n            <span>{{$resolve.edicion.sigTipografica}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--tipo de letra-->\r\n    <div ng-if=\"$resolve.edicion.tipoLetra1 || $resolve.edicion.tipoLetra2 || $resolve.edicion.tipoLetra3\" class=\"row\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'edicion.tipoLetra\' | translate}}</span>\r\n        </div>\r\n        <!--mostramos espacio y coma entre cada elemento, menos en el final-->\r\n        <div class=\"col-sm-10\">\r\n            <span ng-if=\"$resolve.edicion.tipoLetra1\">\r\n                <enumerado base=\"enum.tipoletra\" value=\"{{$resolve.edicion.tipoLetra1}}\"></enumerado><span ng-if=\"$resolve.edicion.tipoLetra2 || $resolve.edicion.tipoLetra3\">,</span>\r\n            </span>\r\n\r\n            <span ng-if=\"$resolve.edicion.tipoLetra2\">\r\n                <enumerado base=\"enum.tipoletra\" value=\"{{$resolve.edicion.tipoLetra2}}\"></enumerado><span ng-if=\"$resolve.edicion.tipoLetra3\">,</span>\r\n            </span>\r\n\r\n            <span ng-if=\"$resolve.edicion.tipoLetra3\">\r\n                <enumerado base=\"enum.tipoletra\" value=\"{{$resolve.edicion.tipoLetra3}}\"></enumerado>\r\n            </span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--tiene reclamos e inicial-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.tieneReclamos || $resolve.edicion.tieneInicial\">\r\n        <div class=\"nombre-campos col-sm-2\" ng-if=\"$resolve.edicion.tieneReclamos\">\r\n            <span>{{\'edicion.tieneReclamos\'| translate}}</span>\r\n        </div>\r\n\r\n        <div class=\"col-sm-4\" ng-if=\"$resolve.edicion.tieneReclamos\">\r\n            <booleano value=\"{{$resolve.edicion.tieneReclamos}}\"></booleano>\r\n        </div>\r\n\r\n        <div class=\"nombre-campos col-sm-2\" ng-if=\"$resolve.edicion.tieneInicial\">\r\n            <span>{{\'edicion.tieneInicial\'| translate}}</span>\r\n        </div>\r\n\r\n        <div class=\"col-sm-4\" ng-if=\"$resolve.edicion.tieneInicial\">\r\n            <booleano value=\"{{$resolve.edicion.tieneInicial}}\"></booleano>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--tiene ilustración-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.tieneIlustracion\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'edicion.tieneIlustracion\'| translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n            <booleano value=\"{{$resolve.edicion.tieneIlustracion}}\"></booleano>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!-- licencia-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.tieneLicencia || $resolve.edicion.descripLicencia\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'edicion.licencia\'| translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <div>\r\n                <span ng-if=\"!$resolve.edicion.descripLicencia\"><booleano value=\"{{$resolve.edicion.tieneLicencia}}\"></booleano>.</span>\r\n                <span>{{$resolve.edicion.descripLicencia}}</span>\r\n                <span ng-if=\"!$resolve.edicion.descripLicencia\">{{\'edicion.noConsta\' | translate}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--colofon-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.tieneColofon || $resolve.edicion.descripColofon\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'edicion.colofon\'| translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <div>\r\n                <span ng-if=\"!$resolve.edicion.descripColofon\"> <booleano value=\"{{$resolve.edicion.tieneColofon}}\"></booleano>.</span>\r\n                <span>{{$resolve.edicion.descripColofon}}</span>\r\n                <span ng-if=\"!$resolve.edicion.descripColofon\">{{\'edicion.noConsta\' | translate}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--dedicatoria-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.tieneDedicatoria || $resolve.edicion.descripDedicatoria\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'edicion.dedicatoria\'| translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <div>\r\n                <span ng-if=\"!$resolve.edicion.descripDedicatoria\"><booleano value=\"{{$resolve.edicion.tieneDedicatoria}}\"></booleano>.</span>\r\n                <span>{{$resolve.edicion.descripDedicatoria}}</span>\r\n                <span ng-if=\"!$resolve.edicion.descripDedicatoria\">{{\'edicion.noConsta\' | translate}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!-- aprobacion-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.tieneAprobacion || $resolve.edicion.descripAprobacion\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'edicion.aprobacion\'| translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <div>\r\n                <span ng-if=\"!$resolve.edicion.descripAprobacion\"><booleano value=\"{{$resolve.edicion.tieneAprobacion}}\"></booleano>.</span>\r\n                <span>{{$resolve.edicion.descripAprobacion}}</span>\r\n                <span ng-if=\"!$resolve.edicion.descripAprobacion\">{{\'edicion.noConsta\' | translate}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--privilegio-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.tienePrivilegio || $resolve.edicion.descripPrivilegio\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{\'edicion.privilegio\'| translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <div>\r\n                <span ng-if=\"!$resolve.edicion.descripPrivilegio\"><booleano value=\"{{$resolve.edicion.tienePrivilegio}}\"></booleano>.</span>\r\n                <span>{{$resolve.edicion.descripPrivilegio}}</span>\r\n                <span ng-if=\"!$resolve.edicion.descripPrivilegio\">{{\'edicion.noConsta\' | translate}}</span>\r\n\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--epitetos-->\r\n    <div class=\"row\" ng-if=\"!$resolve.edicion.epitetos.length ==0\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'edicion.epitetos\' | translate}}</span>\r\n        </div>\r\n        <!--mostramos espacio y coma entre cada elemento, menos en el final-->\r\n        <div class=\"col-sm-10\">\r\n            <span ng-repeat=\"epiteto in $resolve.edicion.epitetos\"> {{epiteto.nombre}}{{$last ? \'\' : \', \'}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"row\" ng-if=\" $resolve.edicion.portada || $resolve.edicion.idioma\">\r\n        <div ng-if=\"$resolve.edicion.portada\">\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'edicion.portada\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n                <enumerado base=\"enum.portada\" value=\"{{$resolve.edicion.portada}}\"></enumerado>\r\n            </div>\r\n        </div>\r\n\r\n        <div ng-if=\"$resolve.edicion.idioma\">\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'edicion.idioma\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n                <span>{{$resolve.edicion.idioma.nombre}}</span>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n    <!--modalidad del discurso-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.modalidadDiscurso\">\r\n        <div>\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'edicion.discurso\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\">\r\n                <enumerado base=\"enum.modalidaddiscurso\" value=\"{{$resolve.edicion.modalidadDiscurso}}\"></enumerado>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--si es manuscrita o impresa (en bend tenemos un boolean-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.numPaginas || $resolve.edicion.esManuscrito\">\r\n        <div>\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'edicion.manuscritaOImpresa\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\" ng-if=\"$resolve.edicion.esManuscrito\">\r\n                <span>{{ \'edicion.esManuscrita\' | translate}}</span>\r\n            </div>\r\n            <div class=\"col-sm-4\" ng-if=\"!$resolve.edicion.esManuscrito\">\r\n                <span>{{ \'edicion.esImpresa\' | translate}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--Notas-->\r\n    <div class=\"row\" ng-if=\"$resolve.edicion.notas\">\r\n        <div class=\"nombre-campos col-sm-2\">\r\n            <span>{{ \'edicion.notas\' | translate}}</span>\r\n        </div>\r\n        <div class=\"col-sm-10\">\r\n            <span>{{$resolve.edicion.notas}}</span>\r\n        </div>\r\n        <div class=\"listado-barras\">\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--catalogos-->\r\n    <div ng-if=\"!$resolve.edicion.catalogos.length ==0\">\r\n        <div class=\"titulo-bloque\">\r\n            <span>{{ \'edicion.referencias\' | translate}}</span>\r\n        </div>\r\n\r\n        <!--mostramos espacio y coma entre cada elemento, menos en el final-->\r\n        <div class=\"\">\r\n            <div ng-repeat=\"catalogo in $resolve.edicion.catalogos\">{{catalogo.catalogo.nombre}}:\r\n                {{catalogo.numero}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--Seccion de ilustraciones-->\r\n    <div class=\"row\" ng-if=\"!$resolve.edicion.ilustraciones.length ==0\">\r\n        <div class=\"col-sm-12\">\r\n            <div class=\"titulo-bloque\">\r\n                <span>{{ \'edicion.ilustraciones\' | translate}}</span>\r\n            </div>\r\n            <!--ilustraciones-->\r\n            <div>\r\n                <div ng-repeat=\"ilustracion in $resolve.edicion.ilustraciones\">{{ilustracion.descripcion}}\r\n                    <div class=\"col-sm-12\">\r\n                        <ng-image-gallery images=\"ilustracion.imagenesMostrar\" methods=\"methods\" thumbnails=\"true\" thumb-size=\"150\"></ng-image-gallery>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n    </div>\r\n\r\n\r\n    <!--Detalles EJEMPLAR--------------------------------------------------------------------------------------------->\r\n    <div ng-if=\"!$resolve.ejemplares.length ==0\">\r\n        <div class=\"titulo-bloque\">\r\n            <span>{{ \'ejemplar.titulo\' | translate}}</span>\r\n        </div>\r\n\r\n        <div class=\"row\" ng-repeat=\"ejemplar in $resolve.ejemplares\">\r\n            <!--signatura-->\r\n            <div class=\"nombre-campos col-sm-2\">\r\n                <span>{{ \'ejemplar.signatura\' | translate}}</span>\r\n            </div>\r\n            <div class=\"titulo col-sm-10\">\r\n                <a ui-sref=\"ejemplarDetails({ejemplarId: ejemplar.id})\">\r\n                    <i class=\"fa fa-picture-o\" ng-if=\"ejemplar.estaDigitalizado\" title=\"{{\'edicion.ejemplar.digitalizado\' | translate}}\"></i>\r\n                    <i class=\"fa fa-check\" ng-if=\"ejemplar.visto\" title=\"{{\'edicion.ejemplar.visto\' | translate}}\"></i>\r\n                    <span>{{ejemplar.signatura}}</span>\r\n                </a>\r\n            </div>\r\n\r\n            <!--biblioteca-->\r\n            <div class=\"bloque\" ng-if=\"ejemplar.nombreBiblioteca\">\r\n                <div class=\"nombre-campos col-sm-2\">\r\n                    <span>{{ \'ejemplar.biblioteca\' | translate}}</span>\r\n                </div>\r\n                <div class=\"col-sm-10\">\r\n                    <a ui-sref=\"bibliotecaDetails({ejemplarId: ejemplar.id, idBiblioteca: ejemplar.bibliotecaId})\" target=\"_blank\">\r\n                        <span ng-if=\"ejemplar.nombreCiudad\"> {{ejemplar.nombreCiudad}}.  </span>\r\n                        <span>{{ejemplar.nombreBiblioteca}}</span>\r\n                    </a>\r\n                </div>\r\n            </div>\r\n            <div class=\"listado-barras\">\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!--Ediciones asociadas--------------------------------------------------------------------------------------------->\r\n    <div ng-if=\"!$resolve.edicionesHermanas.length ==0\">\r\n        <div class=\"titulo-bloque\">\r\n            <span>{{ \'edicion.edicionesHermanas\' | translate}}</span>\r\n        </div>\r\n\r\n        <!--Listado de ediciones -->\r\n        <edicion-list ediciones=\"$resolve.edicionesHermanas\" check=\"false\"></edicion-list>\r\n    </div>\r\n</div>\r\n\r\n\r\n\r\n	\r\n");
$templateCache.put("app/public/lugar/entidades.html","<div class=\"entidad\" ng-repeat=\"entidad in ctrl.items track by entidad.id\">\r\n    <a class=\"nombre\" target=\"_blank\" ui-sref=\"edicionDetails({edicionId: entidad.id})\">\r\n        {{entidad.titulo}}\r\n    </a>\r\n\r\n    <div class=\"descripcion\">\r\n\r\n        <span ng-if=\"entidad.lugar.nombre\"> {{entidad.lugar.nombre}} {{\', \'}}</span>\r\n        <span ng-repeat=\"responsableDTO in entidad.responsables\"> {{responsableDTO.responsable.nombre}}{{\', \'}}</span>\r\n        <span ng-if=\"entidad.anoInicio\"> {{entidad.anoInicio}}{{\', \'}}</span>\r\n        <span ng-if=\"entidad.relacion.bdrs\"> {{entidad.relacion.bdrs}} {{\'.\'}}</span>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/public/lugar/lugares.html","<form ng-submit=\"ctrl.filtrar()\" show-validation=\"\">\r\n    <div class=\"row\" style=\"padding-bottom: 15px\">\r\n        <div class=\"col-sm-9 col-lg-10\">\r\n            <h4 class=\"titulo-buscador\">\r\n                {{\'lugares.nombre\' | translate}}\r\n            </h4>\r\n        </div>\r\n        <div class=\"col-sm-3 col-lg-2\">\r\n            <button type=\"submit\" class=\"btn btn-primary-public btn-block btn-filtrar\" ui-sref=\"buscador\">{{\'lugares.volverBuscador\' | translate}}</button>\r\n        </div>\r\n    </div>\r\n    <div class=\"row filtros\">\r\n        <!--Tipo de las Entidades para buscar por año-->\r\n        <div class=\"form-group col-sm-3\">\r\n            <label class=\"nombre-campos\" translate=\"tipos.tiposentidad.select.fecha.title\" for=\"tipoEntidadFecha\"></label>\r\n            <select class=\"form-control\" id=\"tipoEntidadFecha\" ng-model=\"ctrl.tipoEntidadFecha\" ng-change=\"ctrl.loadRango(false)\">\r\n                <option ng-repeat=\"tipoEntidad in ctrl.tiposEntidad\" value=\"{{tipoEntidad}}\">\r\n                    {{\'tipos.tiposentidad.select.fecha.\' + tipoEntidad | translate}}\r\n                </option>\r\n            </select>\r\n        </div>\r\n\r\n        <!--Rango de años-->\r\n        <div class=\"form-group col-sm-6\">\r\n            <div class=\"row\">\r\n                <div class=\"form-group col-md-4\">\r\n                    <label class=\"nombre-campos\" translate=\"buscador.basico.anoInicioEdicion\" for=\"anoInicioEdicion\"></label>\r\n                    <input type=\"number\" min=\"0\" max=\"2000\" class=\"form-control\" ng-model=\"ctrl.filtro.anoInicioEdicion\" id=\"anoInicioEdicion\" ng-disabled=\"ctrl.filtro.sinAnoEdicion || ctrl.filtro.anoEdicion\">\r\n                </div>\r\n                <!--Año maximo -->\r\n                <div class=\"form-group col-md-4\">\r\n                    <label class=\"nombre-campos\" translate=\"buscador.basico.anoFinEdicion\" for=\"anoFinEdicion\"></label>\r\n                    <input type=\"number\" min=\"0\" max=\"2000\" class=\"form-control\" ng-model=\"ctrl.filtro.anoFinEdicion\" id=\"anoFinEdicion\" ng-disabled=\"ctrl.filtro.sinAnoEdicion || ctrl.filtro.anoEdicion\">\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                    <label class=\"nombre-campos\" translate=\"buscador.basico.nombreLugar\" for=\"nombreLugar\"></label>\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.filtro.nombreLugar\" id=\"nombreLugar\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-1\">\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-2\">\r\n            <button type=\"submit\" class=\"btn btn-primary-public btn-block btn-filtrar\" translate=\"lugares.filter\"></button>\r\n        </div>\r\n    </div>\r\n\r\n    <!--Mapa-->\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <div class=\"form-group\">\r\n                <div id=\"mymap\"></div>\r\n            </div>\r\n        </div>\r\n        <div id=\"listado\" class=\"col-md-12\">\r\n            <div class=\"panel panel-primary entidades\">\r\n                <div class=\"panel-heading\">\r\n                    <h3 class=\"panel-title\" translate=\"tipos.tiposentidad.title\"></h3>\r\n                </div>\r\n                <div class=\"panel-body\">\r\n\r\n                    <div infinite-scroll=\"ctrl.loadMore()\" infinite-scroll-container=\'\".panel-body\"\'>\r\n                        <!--Listado de ediciones -->\r\n                        <edicion-list ediciones=\"ctrl.entidades\" check=\"false\"></edicion-list>\r\n\r\n                        <div class=\"text-center\">\r\n                            <div class=\"empty\" ng-show=\"!ctrl.loadingEntidades && (!ctrl.entidades || !ctrl.entidades.length)\" translate=\"lugares.empty\"></div>\r\n                            <loading is-loading=\"ctrl.loadingEntidades\"></loading>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/admin/edicion/edicion.total/edicion.total.list.html","<buscador-avanzado ediciones=\"$resolve.ediciones\" tipologias=\"$resolve.tipologias\" subgeneros=\"$resolve.subgeneros\" idiomas=\"$resolve.idiomas\" bibliotecas=\"$resolve.bibliotecas\" modalidades=\"$resolve.modalidades\" tamanos=\"$resolve.tamanos\" on-buscar=\"ctrl.buscar\" on-clear=\"ctrl.clear\" filter=\"ctrl.filter\" ng-if=\"ctrl.filter.idLugar == null && ctrl.filter.idResponsable== null\"></buscador-avanzado>\r\n\r\n<div class=\"total-elementos\" ng-if=\"ctrl.filter.idLugar\">\r\n    <label>{{\'admin.edicion.list.lugar\' | translate}} <b> {{ctrl.filter.nombreLugar}} </b></label>\r\n</div>\r\n\r\n<div class=\"total-elementos\" ng-if=\"ctrl.filter.idResponsable\">\r\n    <label>\r\n        <enumerado base=\"enum.rol-responsable\" value=\"{{ctrl.filter.rolResponsable}}\"></enumerado>:\r\n        <b> {{ctrl.filter.nombreResponsable}} </b>\r\n    </label>\r\n</div>\r\n\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total() |number }}</label>\r\n</div>\r\n\r\n<div ng-include=\"\'app/admin/edicion/edicion.tabla.html\'\"></div>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n\r\n");
$templateCache.put("app/admin/user/admin/admin.form.html","<div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-8 col-md-offset-2\">\r\n            <h1 translate=\"admin.register.title\" ng-if=\"ctrl.mode === \'create\'\">Registration </h1>\r\n            <h1 translate=\"admin.edit.title\" ng-if=\"ctrl.mode === \'edit\'\">Registration </h1>\r\n            <form name=\"form\" ng-submit=\"ctrl.register()\" role=\"form\" autocomplete=\"off\" show-validation=\"\">\r\n                <div class=\"form-group\">\r\n                    <label-form key=\"admin.form.username\" for=\"login\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" id=\"login\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.registerAccount.login\" ng-pattern=\"/^[a-z0-9]*$/\" required=\"required\" type=\"text\" ng-disabled=\"ctrl.mode === \'edit\'\">\r\n                    <div ng-show=\"form.login.$dirty &amp;&amp; form.login.$invalid\">\r\n                        <p class=\"help-block\" ng-show=\"form.login.$error.required\" translate=\"admin.form.error.required\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.login.$error.minlength\" translate=\"admin.form.error.minlength\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.login.$error.maxlength\" translate=\"admin.form.error.maxlength\"></p>\r\n                        <p class=\"help-block\" ng-show=\"form.login.$error.pattern\" translate=\"admin.form.error.loginpattern\"></p>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\" ng-if=\"ctrl.mode === \'create\'\">\r\n                    <label-form key=\"admin.form.password\" for=\"password\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" id=\"password\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.registerAccount.password\" required=\"required\" type=\"password\">\r\n                    <div ng-show=\"form.password.$dirty &amp;&amp; form.password.$invalid\">\r\n                        <p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"admin.form.error.required\">Your password is required.\r\n                        </p>\r\n                        <p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"admin.form.error.minlength\">Your password is required to be at\r\n                            least 5 characters\r\n                        </p>\r\n                        <p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"admin.form.error.maxlength\">Your password cannot be longer\r\n                            than 50 characters\r\n                        </p>\r\n                    </div>\r\n                    <password-strength-bar password-to-check=\"ctrl.registerAccount.password\"></password-strength-bar>\r\n                </div>\r\n\r\n                <div class=\"form-group\" ng-if=\"ctrl.mode === \'create\'\">\r\n                    <label-form key=\"admin.form.confirmpassword\" for=\"confirmPassword\" required=\"true\"></label-form>\r\n                    <input class=\"form-control\" id=\"confirmPassword\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.confirmPassword\" required=\"required\" type=\"password\">\r\n                    <div ng-show=\"form.confirmPassword.$dirty &amp;&amp; form.confirmPassword.$invalid\">\r\n                        <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"admin.form.error.required\">Your password confirmation is\r\n                            required.\r\n                        </p>\r\n                        <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"admin.form.error.minlength\">Your password confirmation is\r\n                            required to be at least 5 characters\r\n                        </p>\r\n                        <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"admin.form.error.maxlength\">Your password confirmation\r\n                            cannot be longer than 50 characters\r\n                        </p>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <enum-select id=\"rol\" model=\"ctrl.registerAccount.role\" label=\"admin.admin.form.rol\" base=\"enum.rol\" options=\"ctrl.roles\" required=\"true\"></enum-select>\r\n                </div>\r\n\r\n                <!--Botones-->\r\n                <div class=\"form-bottom-buttons\">\r\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"back()\">\r\n                        <span class=\"glyphicon glyphicon-ban-circle\"></span>\r\n                        <span translate=\"admin.form.button.cancel\"></span>\r\n                    </button>\r\n                    <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"form.$invalid\">\r\n                        <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                        <span ng-if=\"ctrl.mode === \'create\'\" translate=\"admin.form.button.create\"></span>\r\n                        <span ng-if=\"ctrl.mode === \'edit\'\" translate=\"admin.form.button.save\"></span>\r\n\r\n                    </button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/admin/user/admin/admin.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/admin/create\">\r\n        <span translate=\"global.menu.register\"></span>\r\n    </a>\r\n</div>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total() |number}}</label>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped\">\r\n\r\n    <tr ng-repeat=\"usuarioEjemplares in $data track by usuarioEjemplares.login\">\r\n\r\n        <td data-title=\"\'admin.admin.form.login\' | translate\" sortable=\"\'login\'\">\r\n            {{usuarioEjemplares.login}}\r\n        </td>\r\n\r\n        <td data-title=\"\'admin.admin.form.rol\' | translate\" sortable=\"\'role\'\" class=\"col-md-2 text-center\">\r\n            <enumerado base=\"enum.rol\" value=\"{{usuarioEjemplares.role}}\"></enumerado>\r\n        </td>\r\n\r\n        <td data-title=\"\'admin.admin.form.ejemplares\' | translate\" class=\"col-md-1 text-center\">\r\n            <a ng-if=\"usuarioEjemplares.ejemplares > 0\" ui-sref=\"admin/ejemplar/usuario/list({creadorLogin: usuarioEjemplares.login})\">{{usuarioEjemplares.ejemplares}}</a>\r\n            <span ng-if=\"usuarioEjemplares.ejemplares == 0\">{{usuarioEjemplares.ejemplares}}</span>\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n\r\n            <a ui-sref=\"admin/admin/edit({id:usuarioEjemplares.login})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(usuarioEjemplares.login)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n\r\n        </td>\r\n\r\n    </tr>\r\n</table>\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n\r\n");
$templateCache.put("app/admin/tesauro/catalogo/catalogo.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ng-click=\"ctrl.addElementTable()\">\r\n        <span translate=\"admin.catalogo.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter filter=\"ctrl.filter.key\"></filter>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total()|number}}</label>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n    <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\" ng-form=\"rowForm\">\r\n\r\n\r\n        <td class=\"col-md-11\" data-title=\"\'admin.catalogo.form.nombre\'  | translate\" sortable=\"\'nombre\'\" ng-switch=\"element.isEditing\" ng-form=\"nombreForm\">\r\n\r\n            <div class=\"btn-ctrl form-inline\">\r\n\r\n                <span ng-switch-default class=\"editable-text\">{{element.nombre}}</span>\r\n\r\n                <form ng-submit=\"ctrl.save(element, rowForm)\" name=\"form_{{element.id}}\">\r\n                    <!--Edición-->\r\n                    <div class=\"form-group controls\" ng-class=\"nombreForm.$invalid && nombreForm.$dirty ? \'has-error\' : \'\'\" ng-switch-when=\"true\">\r\n                        <input type=\"text\" name=\"name\" size=\"135\" ng-model=\"element.nombre\" class=\"editable-input form-control input\" required autofocus>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n\r\n        </td>\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <!--Guardar datos-->\r\n            <a class=\"button glyphicon glyphicon-ok\" ng-click=\"ctrl.save(element, rowForm)\" ng-show=\"element.isEditing\" ng-class=\"{\'disabled\': rowForm.$pristine || rowForm.$invalid}\" title=\"{{\'admin.form.button.save\' | translate}}\"></a>\r\n\r\n            <!--Cancelar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-remove\" ng-click=\"ctrl.cancel(element, rowForm);\" title=\"{{\'admin.form.button.cancel\' | translate}}\" ng-show=\"element.isEditing\"></a>\r\n\r\n            <!--Iniciar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-pencil\" ng-click=\"element.isEditing = true; ctrl.saveState(element, rowForm)\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n\r\n            <!--Eliminar elemento-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/admin/tesauro/epiteto/epiteto.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ng-click=\"ctrl.addElementTable()\">\r\n        <span translate=\"admin.epiteto.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter filter=\"ctrl.filter.key\"></filter>\r\n\r\n<!-- Enlaces a letras -->\r\n<letras elementos=\"ctrl.letras\" todos=\"true\" estado=\"epiteto/list\"></letras>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total()|number}}</label>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover ng-cloak\">\r\n    <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\" ng-form=\"rowForm\">\r\n\r\n        <td class=\"col-md-11\" data-title=\"\'admin.epiteto.form.nombre\'  | translate\" sortable=\"\'nombre\'\" ng-switch=\"element.isEditing\" ng-form=\"nombreForm\">\r\n\r\n            <div class=\"btn-ctrl form-inline\">\r\n                <span ng-switch-default class=\"editable-text\">{{element.nombre}}</span>\r\n\r\n                <form ng-submit=\"ctrl.save(element, rowForm)\" name=\"form_{{element.id}}\">\r\n                    <!--Edición-->\r\n                    <div class=\"form-group controls\" ng-class=\"nombreForm.$invalid && nombreForm.$dirty ? \'has-error\' : \'\'\" ng-switch-when=\"true\">\r\n                        <input type=\"text\" name=\"name\" size=\"135\" ng-model=\"element.nombre\" class=\"editable-input form-control input\" required autofocus>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <!--Guardar datos-->\r\n            <a class=\"button glyphicon glyphicon-ok\" ng-click=\"ctrl.save(element, rowForm)\" ng-show=\"element.isEditing\" ng-class=\"{\'disabled\': rowForm.$pristine || rowForm.$invalid}\" title=\"{{\'admin.form.button.save\' | translate}}\"></a>\r\n\r\n            <!--Cancelar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-remove\" ng-click=\"ctrl.cancel(element, rowForm);\" title=\"{{\'admin.form.button.cancel\' | translate}}\" ng-show=\"element.isEditing\"></a>\r\n\r\n            <!--Iniciar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-pencil\" ng-click=\"element.isEditing = true; ctrl.saveState(element, rowForm)\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n\r\n            <!--Eliminar elemento-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/admin/tesauro/biblioteca/biblioteca.form.html","<form name=\"form\" role=\"form\" ng-submit=\"ctrl.save()\" show-validation=\"\">\r\n\r\n    <h4 translate=\"admin.biblioteca.create.title\" ng-if=\"ctrl.mode === \'create\'\"></h4>\r\n    <h4 translate=\"admin.biblioteca.edit.title\" ng-if=\"ctrl.mode === \'edit\'\"></h4>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"form-group col-sm-12\">\r\n            <label-form key=\"admin.biblioteca.form.nombre\" for=\"nombre\" required=\"true\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.nombre\" id=\"nombre\" required=\"true\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"form-group col-sm-10\">\r\n            <label-form key=\"admin.biblioteca.form.calle\" for=\"calle\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.calle\" id=\"calle\">\r\n        </div>\r\n        <div class=\"form-group col-sm-2\">\r\n            <label-form key=\"admin.biblioteca.form.numero\" for=\"numero\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.numero\" id=\"numero\">\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"form-group col-sm-4\">\r\n            <label-form key=\"admin.biblioteca.form.codigoPostal\" for=\"codigoPostal\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.codigoPostal\" id=\"codigoPostal\">\r\n        </div>\r\n        <div class=\"form-group col-sm-4\">\r\n            <label-form key=\"admin.biblioteca.form.ciudad\" for=\"ciudad\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.ciudad\" id=\"ciudad\">\r\n        </div>\r\n        <div class=\"form-group col-sm-4\">\r\n            <label-form key=\"admin.biblioteca.form.pais\" for=\"pais\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.pais\" id=\"pais\">\r\n        </div>\r\n\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"form-group col-sm-4\">\r\n            <label-form key=\"admin.biblioteca.form.telefono\" for=\"telefono\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.telefono\" id=\"telefono\">\r\n        </div>\r\n        <div class=\"form-group col-sm-4\">\r\n            <label-form key=\"admin.biblioteca.form.fax\" for=\"fax\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.fax\" id=\"fax\">\r\n        </div>\r\n        <div class=\"form-group col-sm-4\">\r\n            <label-form key=\"admin.biblioteca.form.email\" for=\"email\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.email\" id=\"email\">\r\n        </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"form-group col-sm-12\">\r\n            <label-form key=\"admin.biblioteca.form.web\" for=\"web\"></label-form>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.item.web\" id=\"web\">\r\n        </div>\r\n    </div>\r\n    <!--Botones-->\r\n    <div class=\"form-bottom-buttons\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$root.back()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.cancel\"></span>\r\n        </button>\r\n        <button type=\"submit\" class=\"btn btn-primary\">\r\n            <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.create\" ng-if=\"ctrl.mode === \'create\'\"></span>\r\n            <span translate=\"admin.form.button.save\" ng-if=\"ctrl.mode === \'edit\'\"></span>\r\n        </button>\r\n    </div>\r\n\r\n</form>\r\n");
$templateCache.put("app/admin/tesauro/biblioteca/biblioteca.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ui-sref=\"admin/biblioteca/create\">\r\n        <span translate=\"admin.biblioteca.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n\r\n<filter filter=\"ctrl.filter.key\"></filter>\r\n\r\n\r\n<!-- Enlaces a letras -->\r\n<letras elementos=\"ctrl.letras\" todos=\"true\" sinvalor=\"true\" estado=\"biblioteca/list\"></letras>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total()|number}}</label>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n    <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\">\r\n\r\n        <td class=\"col-md-2\" data-title=\"\'admin.biblioteca.form.ciudad\' | translate\" sortable=\"\'ciudad\'\">\r\n            <p1 ui-sref=\"admin/biblioteca/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                {{element.ciudad}}\r\n            </p1>\r\n        </td>\r\n\r\n        <td class=\"col-md-9\" data-title=\"\'admin.biblioteca.biblioteca\' | translate\" sortable=\"\'nombre\'\">\r\n            <a ui-sref=\"admin/biblioteca/edit({id: element.id})\" title=\"{{\'admin.form.button.edit\' | translate}}\">\r\n                {{element.nombre}}\r\n            </a>\r\n        </td>\r\n\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <a ui-sref=\"admin/biblioteca/edit({id: element.id})\" class=\"button glyphicon glyphicon-pencil\" title=\"{{\'admin.form.button.edit\' | translate}}\"></a>\r\n            <!--Eliminar elemento-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n\r\n");
$templateCache.put("app/admin/tesauro/idioma/idioma.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ng-click=\"ctrl.addElementTable()\">\r\n        <span translate=\"admin.idioma.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter filter=\"ctrl.filter.key\"></filter>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total()|number}}</label>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n    <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\" ng-form=\"rowForm\">\r\n\r\n\r\n        <td class=\"col-md-11\" data-title=\"\'admin.idioma.form.nombre\'  | translate\" sortable=\"\'nombre\'\" ng-switch=\"element.isEditing\" ng-form=\"nombreForm\">\r\n\r\n            <div class=\"btn-ctrl form-inline\">\r\n\r\n                <span ng-switch-default class=\"editable-text\">{{element.nombre}}</span>\r\n\r\n                <form ng-submit=\"ctrl.save(element, rowForm)\" name=\"form{{element.id}}\">\r\n                    <!--Edición-->\r\n                    <div class=\"form-group controls\" ng-class=\"nombreForm.$invalid && nombreForm.$dirty ? \'has-error\' : \'\'\" ng-switch-when=\"true\">\r\n                        <input type=\"text\" name=\"name\" size=\"135\" ng-model=\"element.nombre\" class=\"editable-input form-control input\" autofocus required>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n\r\n        </td>\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <!--Guardar datos-->\r\n            <a class=\"button glyphicon glyphicon-ok\" ng-click=\"ctrl.save(element, rowForm)\" ng-show=\"element.isEditing\" ng-class=\"{\'disabled\': rowForm.$pristine || rowForm.$invalid}\" title=\"{{\'admin.form.button.save\' | translate}}\"></a>\r\n\r\n            <!--Cancelar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-remove\" ng-click=\"ctrl.cancel(element, rowForm);\" title=\"{{\'admin.form.button.cancel\' | translate}}\" ng-show=\"element.isEditing\"></a>\r\n\r\n            <!--Iniciar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-pencil\" ng-click=\"element.isEditing = true; ctrl.saveState(element, rowForm)\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n\r\n            <!--Eliminar elemento-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/admin/tesauro/lugar/lugar.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ng-click=\"ctrl.addElementTable()\">\r\n        <span translate=\"admin.lugar.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"form-group col-sm-3\">\r\n        <filter filter=\"ctrl.filter.key\"></filter>\r\n    </div>\r\n\r\n    <div class=\"form-group col-sm-3\">\r\n        <div class=\"form-group col-sm-4\">\r\n            <label>{{\'admin.lugar.revisados\' | translate}}:</label>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-6\">\r\n            <enum-select id=\"lugarrevisado\" model=\"ctrl.filter.revisado\" options=\"[true, false]\" base=\"enum.boolean\"></enum-select>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n<!-- Enlaces a letras -->\r\n<letras elementos=\"ctrl.letras\" todos=\"true\" estado=\"lugar/list\"></letras>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-sm-3 total-elementos\">\r\n        <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total()|number}}</label>\r\n    </div>\r\n\r\n    <div class=\"col-sm-offset-5 col-sm-4\">\r\n        <form>\r\n            <div class=\"pull-right\">\r\n                <span class=\"label label-primary\">{{\'admin.lugar.relaciones\' | translate}}</span>\r\n                <span class=\"label label-success\">{{\'admin.lugar.ediciones\' | translate}}</span>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n\r\n    <!--CODIGO DE LOS CANONICOS-->\r\n\r\n    <tr ng-repeat-start=\"canonico in $data track by canonico.id\" class=\"animate\" ng-form=\"canonicoRowForm\">\r\n\r\n\r\n        <td class=\"col-md-7\" data-title=\"\'admin.lugar.lugar\'  | translate\" ng-switch=\"canonico.isEditing\" ng-form=\"nombreForm\">\r\n\r\n            <div class=\"btn-ctrl form-inline\">\r\n\r\n                <span class=\"canonico-style\" ng-click=\"canonico.$hideRows = !canonico.$hideRows\">\r\n                    <span ng-switch-default class=\"editable-text\">{{canonico.nombre}}</span>\r\n                    <span ng-switch-default class=\"glyphicon\" ng-if=\"canonico.variantes.length > 0\" ng-class=\"{ \'glyphicon-chevron-right\': canonico.$hideRows, \'glyphicon-chevron-down\': !canonico.$hideRows }\"></span>\r\n                    <label ng-if=\"!canonico.isEditing && canonico.variantes.length > 0\">\r\n                        {{\'admin.lugar.variantes\' | translate}}:\r\n                        {{canonico.variantes.length}}</label>\r\n                </span>\r\n\r\n                <form ng-submit=\"ctrl.save(canonico, canonicoRowForm)\" name=\"form{{canonico.id}}\">\r\n                    <!--Datos editables del canónico -->\r\n                    <div class=\"form-group controls\" ng-class=\"nombre.$invalid && nombre.$dirty ? \'has-error\' : \'\'\" ng-switch-when=\"true\">\r\n\r\n                        <!--nombre lugar, editable-->\r\n                        <label>\r\n                            {{\'admin.lugar.edit.nombre\' | translate}}</label>\r\n\r\n                        <div class=\"form-group\" ng-class=\"nombreCanonicoForm.$invalid && nombreCanonicoForm.$dirty ? \'has-error\' : \'\'\" ng-form=\"nombreCanonicoForm\">\r\n\r\n                            <input type=\"text\" name=\"name\" ng-model=\"canonico.nombre\" class=\"editable-input form-control\" autofocus required>\r\n                        </div>\r\n\r\n                        <!--Checkbox si es canónico-->\r\n                        <label>\r\n                            {{\'admin.lugar.edit.esCanonico\' | translate}}\r\n                            <input type=\"checkbox\" ng-model=\"canonico.es_canonico\" ng-init=\"canonico.es_canonico = (canonico.lugarcanonico == null)\" ng-disabled=\"canonico.lugarcanonico.id\"></label>\r\n\r\n                        <div class=\"form-group\" ng-form=\"nombreCanonicoCanonicoForm\" ng-class=\"nombreCanonicoCanonicoForm.$invalid && nombreCanonicoCanonicoForm.$dirty ? \'has-error\' : \'\'\">\r\n                            <tesauro id=\"itemcanonico\" ng-model=\"canonico.lugarcanonico\" resource=\"ctrl.lugarService\" method=\"canonicoFilter\" restricted=\"true\" multiple=\"false\" min-length=\"0\" eliminable=\"true\" parameters=\"{sortProperty: \'nombre\' , size: 20}\" ng-if=\"!canonico.es_canonico\" required=\"true\" placeholder=\"{{\'admin.lugar.edit.nombreCanonico\'| translate}}\"></tesauro>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n\r\n            </div>\r\n        </td>\r\n\r\n        <!--Cifras de obras-->\r\n        <td class=\"col-md-2 text-center button-icons-numbers\" data-title=\"\'admin.lugar.form.obras\'  | translate\">\r\n            <a ui-sref=\"admin/relacion/list({idLugar: canonico.id,  nombreLugar: canonico.nombre})\" class=\"label label-primary\" ng-if=\"canonico.numRelaciones!=null\" title=\"{{\'admin.lugar.relaciones\' | translate}}\" ng-class=\"{\'disabled\': canonico.numRelaciones == 0}\">{{canonico.numRelaciones}}</a>\r\n            <a ui-sref=\"admin/buscador/list({idLugar: canonico.id,  nombreLugar: canonico.nombre})\" class=\"label label-success\" ng-if=\"canonico.numEdiciones!=null\" title=\"{{\'admin.lugar.ediciones\' | translate}}\" ng-class=\"{\'disabled\': canonico.numEdiciones == 0}\"> {{canonico.numEdiciones}}</a>\r\n        </td>\r\n\r\n        <!--Revisado-->\r\n        <td class=\"col-md-1 text-center button-icons\" data-title=\"\'admin.lugar.revisado\'  | translate\">\r\n            <input type=\"checkbox\" ng-model=\"canonico.revisado\" title=\"{{\'admin.lugar.revisado\' | translate}}\" ng-click=\"ctrl.setRevisado(canonico)\">\r\n        </td>\r\n\r\n        <!--Botones-->\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n\r\n            <!--Poner coordenadas-->\r\n            <a ng-class=\"{\'glyphicon glyphicon-map-marker sincoordenadas\' : canonico.lat == null && canonico.lng == null, \'glyphicon glyphicon-map-marker\' : canonico.lat != null && canonico.lng != null }\" ng-click=\"ctrl.openLocationModal(canonico)\" title=\"{{\'admin.lugar.geonames.ubicar\' | translate}}\"></a>\r\n\r\n            <!--Guardar datos-->\r\n            <a class=\"button glyphicon glyphicon-ok\" ng-click=\"ctrl.save(canonico, canonicoRowForm)\" ng-show=\"canonico.isEditing\" ng-class=\"{\'disabled\': canonicoRowForm.$pristine || canonicoRowForm.$invalid}\" title=\"{{\'admin.form.button.save\' | translate}}\"></a>\r\n\r\n            <!--Cancelar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-remove\" ng-click=\"ctrl.cancel(canonico, canonicoRowForm);\" title=\"{{\'admin.form.button.cancel\' | translate}}\" ng-show=\"canonico.isEditing\"></a>\r\n\r\n            <!--Iniciar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-pencil\" ng-click=\"canonico.isEditing = true; ctrl.saveState(canonico, canonicoRowForm)\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-show=\"!canonico.isEditing\"></a>\r\n\r\n            <!--Eliminar canonicoo-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(canonico)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!canonico.isEditing\"></a>\r\n        </td>\r\n    </tr>\r\n\r\n\r\n    <!--TODO hay que intentar no replicar el código-->\r\n    <!--CODIGO DE LAS VARIANTES------------------------------------------------------------------------------------------>\r\n\r\n    <tr ng-hide=\"canonico.$hideRows\" ng-repeat=\"variante in canonico.variantes track by variante.id\" ng-repeat-end ng-form=\"varianteRowForm\">\r\n\r\n        <td class=\"col-md-8\" data-title=\"\'admin.lugar.nombre\'  | translate\" ng-switch=\"variante.isEditing\">\r\n\r\n            <div class=\"btn-ctrl form-inline\">\r\n                <span ng-switch-default class=\"editable-text\" style=\"margin-left:10px\">{{variante.nombre}}</span>\r\n\r\n                <form ng-submit=\"ctrl.save(variante, varianteRowForm)\" name=\"form{{variante.id}}\">\r\n                    <!--Edición-->\r\n                    <div class=\"form-group controls\" ng-switch-when=\"true\">\r\n\r\n                        <!--nombre lugar, editable-->\r\n                        <label>\r\n                            {{\'admin.lugar.edit.nombre\' | translate}}</label>\r\n\r\n                        <div class=\"form-group\" ng-class=\"nombreVarianteForm.$invalid && nombreVarianteForm.$dirty ? \'has-error\' : \'\'\" ng-form=\"nombreVarianteForm\">\r\n                            <input type=\"text\" name=\"name\" ng-model=\"variante.nombre\" id=\"\" class=\"editable-input form-control\" autofocus required>\r\n                        </div>\r\n                        <!--Checkbox si es canónico-->\r\n                        <label>\r\n                            {{\'admin.lugar.edit.esCanonico\' | translate}}\r\n                            <input type=\"checkbox\" ng-model=\"variante.es_canonico\" ng-init=\"variante.es_canonico = !variante.lugarcanonico\" ng-disabled=\"variante.lugarcanonico.id\"></label>\r\n\r\n                        <div class=\"form-group\" ng-form=\"nombreCanonicoVarianteForm\" ng-class=\"nombreCanonicoVarianteForm.$invalid && nombreCanonicoVarianteForm.$dirty ? \'has-error\' : \'\'\">\r\n                            <tesauro id=\"itemvariante\" ng-model=\"variante.lugarcanonico\" resource=\"ctrl.lugarService\" method=\"canonicoFilter\" restricted=\"true\" multiple=\"false\" min-length=\"0\" eliminable=\"true\" parameters=\"{sortProperty: \'nombre\', size: 20}\" ng-if=\"!variante.es_canonico\" ng-init=\"variante.lugarcanonico = {id:variante.lugarcanonico.id, nombre: variante.lugarcanonico.nombre}\" required=\"true\">\r\n                            </tesauro>\r\n                        </div>\r\n\r\n                        <!--Para poder hacer submit pulsando ENTER-->\r\n                        <input type=\"submit\" hidden>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </td>\r\n\r\n        <!--Cifras de obras-->\r\n        <td class=\"col-md-1 text-center button-icons-numbers\">\r\n            <a ui-sref=\"admin/relacion/list({idLugar: variante.id, nombreLugar: variante.nombre})\" class=\"label label-primary\" ng-if=\"variante.numRelaciones!=null\" title=\"{{\'admin.lugar.relaciones\' | translate}}\" ng-class=\"{\'disabled\': variante.numRelaciones == 0}\">{{variante.numRelaciones}}</a>\r\n            <a ui-sref=\"admin/buscador/list({idLugar: variante.id, nombreLugar: variante.nombre})\" class=\"label label-success\" ng-if=\"variante.numEdiciones!=null\" title=\"{{\'admin.lugar.ediciones\' | translate}}\" ng-class=\"{\'disabled\': variante.numEdiciones == 0}\"> {{variante.numEdiciones}}\r\n            </a>\r\n        </td>\r\n\r\n        <!--Revisado-->\r\n        <td class=\"col-md-1 text-center button-icons\" data-title=\"\'admin.lugar.revisado\'  | translate\">\r\n            <input type=\"checkbox\" ng-model=\"variante.revisado\" title=\"{{\'admin.lugar.revisado\' | translate}}\" ng-click=\"ctrl.setRevisado(variante)\">\r\n        </td>\r\n\r\n\r\n        <!--Botones-->\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <!--Guardar datos-->\r\n            <a class=\"button glyphicon glyphicon-ok\" ng-click=\"ctrl.save(variante, varianteRowForm)\" ng-show=\"variante.isEditing\" ng-class=\"{\'disabled\': varianteRowForm.$pristine || varianteRowForm.$invalid}\" title=\"{{\'admin.form.button.save\' | translate}}\"></a>\r\n\r\n            <!--Cancelar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-remove\" ng-click=\"ctrl.cancel(variante, varianteRowForm);\" title=\"{{\'admin.form.button.cancel\' | translate}}\" ng-show=\"variante.isEditing\"></a>\r\n\r\n            <!--Iniciar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-pencil\" ng-click=\"variante.isEditing = true; ctrl.saveState(variante, varianteRowForm)\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-show=\"!variante.isEditing\"></a>\r\n\r\n            <!--Eliminar variante-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(variante)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!variante.isEditing\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/admin/tesauro/subgenero/subgenero.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ng-click=\"ctrl.addElementTable()\">\r\n        <span translate=\"admin.subgenero.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter filter=\"ctrl.filter.key\"></filter>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total() |number}}</label>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n    <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\" ng-form=\"rowForm\">\r\n\r\n\r\n        <td class=\"col-md-7\" data-title=\"\'admin.subgenero.form.nombre\'  | translate\" sortable=\"\'nombre\'\" ng-switch=\"element.isEditing\" ng-form=\"nombreForm\">\r\n\r\n            <div class=\"btn-ctrl form-inline\">\r\n\r\n                <span ng-switch-default class=\"editable-text\">{{element.nombre}}</span>\r\n\r\n                <form ng-submit=\"ctrl.save(element, rowForm)\" name=\"form{{element.id}}\">\r\n                    <!--Edición-->\r\n                    <div class=\"form-group controls\" ng-class=\"nombreForm.$invalid && nombreForm.$dirty ? \'has-error\' : \'\'\" ng-switch-when=\"true\">\r\n                        <input type=\"text\" name=\"name\" size=\"85\" ng-model=\"element.nombre\" class=\"editable-input form-control input-md\" autofocus required>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n\r\n        </td>\r\n\r\n        <td class=\"col-md-4\" data-title=\"\'admin.subgenero.tipologia\'  | translate\" sortable=\"\'tipologia\'\" ng-switch=\"element.isEditing\">\r\n\r\n            <!--Sin editar: texto normal-->\r\n\r\n            <span ng-switch-default class=\"editable-text\">{{element.tipologia.nombre}}</span>\r\n\r\n            <!--Editando : desplegable-->\r\n\r\n            <div ng-switch-when=\"true\">\r\n                <select-form id=\"tipologia_{{element.id}}\" model=\"element.tipologia\" options=\"ctrl.tipologias\" required=\"true\">\r\n                </select-form>\r\n            </div>\r\n        </td>\r\n\r\n\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <!--Guardar datos-->\r\n            <a class=\"button glyphicon glyphicon-ok\" ng-click=\"ctrl.save(element, rowForm)\" ng-show=\"element.isEditing\" ng-class=\"{\'disabled\': rowForm.$pristine || rowForm.$invalid}\" title=\"{{\'admin.form.button.save\' | translate}}\"></a>\r\n\r\n            <!--Cancelar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-remove\" ng-click=\"ctrl.cancel(element, rowForm);\" title=\"{{\'admin.form.button.cancel\' | translate}}\" ng-show=\"element.isEditing\"></a>\r\n\r\n            <!--Iniciar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-pencil\" ng-click=\"element.isEditing = true; ctrl.saveState(element, rowForm)\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n\r\n            <!--Eliminar elemento-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/admin/tesauro/responsable/responsable.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ng-click=\"ctrl.addElementTable()\">\r\n        <span translate=\"admin.responsable.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"form-group col-sm-3\">\r\n        <filter filter=\"ctrl.filter.key\"></filter>\r\n    </div>\r\n    <div class=\"form-group col-sm-3\">\r\n        <div class=\"form-group col-sm-5\">\r\n            <label>{{\'admin.responsable.revisados\' | translate}}:</label>\r\n        </div>\r\n\r\n        <div class=\"form-group col-sm-7\">\r\n            <enum-select id=\"responsableRevisado\" model=\"ctrl.filter.revisado\" options=\"[true, false]\" base=\"enum.boolean\"></enum-select>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"form-group col-sm-3\">\r\n        <div class=\"form-group col-sm-2\">\r\n            <label>{{\'admin.responsable.rol\' | translate}}:</label>\r\n        </div>\r\n        <div class=\"form-group col-sm-7\">\r\n            <select class=\"form-control\" id=\"rolResponsable\" ng-model=\"ctrl.filter.rol\">\r\n                <option value=\"\">{{}}</option>\r\n                <option value=\"AUT\">{{\'admin.responsable.autor\' | translate}}</option>\r\n                <option value=\"EDIT\">{{\'admin.responsable.editor\' | translate}}</option>\r\n                <option value=\"IMPR\">{{\'admin.responsable.impresor\' | translate}}</option>\r\n                <option value=\"TRAD\">{{\'admin.responsable.traductor\' | translate}}</option>\r\n                <option value=\"OTRO\">{{\'admin.responsable.otros\' | translate}}</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<!-- Enlaces a letras -->\r\n<letras elementos=\"ctrl.letras\" todos=\"true\" estado=\"responsable/list\"></letras>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-sm-3 total-elementos\">\r\n        <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total() |number}}</label>\r\n    </div>\r\n\r\n    <div class=\"col-sm-offset-5 col-sm-4\">\r\n        <form>\r\n            <div class=\"pull-right\">\r\n                <span class=\"label label-default\">{{\'admin.responsable.autor\' | translate}}</span>\r\n                <span class=\"label label-primary\">{{\'admin.responsable.editor\' | translate}}</span>\r\n                <span class=\"label label-success\">{{\'admin.responsable.impresor\' | translate}}</span>\r\n                <span class=\"label label-info\">{{\'admin.responsable.traductor\' | translate}}</span>\r\n                <span class=\"label label-warning\">{{\'admin.responsable.otros\' | translate}}</span>\r\n\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n\r\n\r\n    <!--CODIGO DE LOS CANONICOS-->\r\n    <tr ng-repeat-start=\"canonico in $data track by canonico.id\" class=\"animate\" ng-form=\"canonicoRowForm\">\r\n\r\n\r\n        <td data-title=\"\'admin.responsable.responsable\'  | translate\" ng-switch=\"canonico.isEditing\">\r\n\r\n            <div class=\"btn-ctrl form-inline\">\r\n\r\n                <span class=\"canonico-style\" href=\"\" ng-click=\"canonico.$hideRows = !canonico.$hideRows\">\r\n                    <span ng-switch-default class=\"editable-text\">{{canonico.nombre}} {{canonico.apellidos}}</span>\r\n                    <span ng-switch-default class=\"glyphicon\" ng-if=\"canonico.variantes.length > 0\" ng-class=\"{ \'glyphicon-chevron-right\': canonico.$hideRows, \'glyphicon-chevron-down\': !canonico.$hideRows }\"></span>\r\n                    <label ng-if=\"!canonico.isEditing && canonico.variantes.length > 0\">\r\n                        {{\'admin.responsable.variantes\' | translate}}:\r\n                        {{canonico.variantes.length}}</label>\r\n                </span>\r\n\r\n                <form ng-submit=\"ctrl.save(canonico, canonicoRowForm)\" name=\"form{{canonico.id}}\">\r\n                    <div class=\"form-group controls\" ng-class=\"nombre.$invalid && nombre.$dirty ? \'has-error\' : \'\'\" ng-switch-when=\"true\">\r\n\r\n                        <!--nombre responsable canonico-->\r\n                        <div class=\"form-group\" ng-class=\"nombreCanonicoForm.$invalid && nombreCanonicoForm.$dirty ? \'has-error\' : \'\'\" ng-form=\"nombreCanonicoForm\">\r\n\r\n                            <input type=\"text\" name=\"name\" ng-model=\"canonico.nombre\" class=\"editable-input form-control\" placeholder=\"{{\'admin.responsable.edit.nombre\'| translate}}\" autofocus>\r\n                        </div>\r\n\r\n                        <!--apellido responsable canonico-->\r\n                        <div class=\"form-group\" ng-class=\"apellidosCanonicoForm.$invalid && apellidosCanonicoForm.$dirty ? \'has-error\' : \'\'\" ng-form=\"apellidosCanonicoForm\">\r\n\r\n                            <input type=\"text\" name=\"name\" ng-model=\"canonico.apellidos\" class=\"editable-input form-control\" placeholder=\"{{\'admin.responsable.edit.apellidos\'| translate}}\">\r\n                        </div>\r\n\r\n                        <!--Checkbox si es canónico-->\r\n                        <label>\r\n                            {{\'admin.responsable.edit.esCanonico\' | translate}}\r\n                            <input type=\"checkbox\" ng-model=\"canonico.es_canonico\" ng-init=\"canonico.es_canonico = (canonico.canonico == null)\" ng-disabled=\"canonico.responsablecanonico.id\"></label>\r\n\r\n                        <div class=\"form-group\" ng-form=\"nombreCanonicoCanonicoForm\" ng-class=\"nombreCanonicoCanonicoForm.$invalid && nombreCanonicoCanonicoForm.$dirty ? \'has-error\' : \'\'\">\r\n                            <tesauro id=\"itemcanonico\" ng-model=\"canonico.responsablecanonico\" resource=\"ctrl.responsableService\" method=\"canonicoFilter\" restricted=\"true\" multiple=\"false\" min-length=\"0\" eliminable=\"true\" parameters=\"{size: 20, id: canonico.id}\" ng-if=\"!canonico.es_canonico\" required=\"true\" display=\"nombreCompleto\" placeholder=\"{{\'admin.responsable.edit.nombreCanonico\'| translate}}\">\r\n                            </tesauro>\r\n                        </div>\r\n                        <!--Para poder hacer submit pulsando ENTER-->\r\n                        <input type=\"submit\" hidden>\r\n                    </div>\r\n                </form>\r\n\r\n            </div>\r\n        </td>\r\n\r\n        <!--Cifras de obras del canonico-->\r\n        <td class=\"text-center button-icons-numbers tablaresponsable\" data-title=\"\'admin.responsable.form.obras\'  | translate\">\r\n            <a type=\"button\" ng-click=\"ctrl.verRelaciones( canonico.id, canonico.nombre, canonico.apellidos)\" class=\"label label-default\" ng-if=\"canonico.numAutor!=null\" title=\"{{\'admin.responsable.autor\' | translate}}\" ng-class=\"{\'disabled\': canonico.numAutor == 0}\"> {{canonico.numAutor}}</a>\r\n            <a type=\"button\" ng-click=\"ctrl.verEdiciones(canonico.id, canonico.nombre, canonico.apellidos, \'EDIT\')\" class=\"label label-primary\" ng-if=\"canonico.numEditor!=null\" title=\"{{\'admin.responsable.editor\' | translate}}\" ng-class=\"{\'disabled\': canonico.numEditor == 0}\"> {{canonico.numEditor}}</a>\r\n            <a type=\"button\" ng-click=\"ctrl.verEdiciones(canonico.id, canonico.nombre, canonico.apellidos, \'IMPR\')\" class=\"label label-success\" ng-if=\"canonico.numImpresor!=null\" title=\"{{\'admin.responsable.impresor\' | translate}}\" ng-class=\"{\'disabled\': canonico.numImpresor == 0}\"> {{canonico.numImpresor}}</a>\r\n            <a type=\"button\" ng-click=\"ctrl.verEdiciones(canonico.id, canonico.nombre, canonico.apellidos, \'TRAD\')\" class=\"label label-info\" ng-if=\"canonico.numTraductor!=null\" title=\"{{\'admin.responsable.traductor\' | translate}}\" ng-class=\"{\'disabled\': canonico.numTraductor == 0}\"> {{canonico.numTraductor}}</a>\r\n            <a type=\"button\" ng-click=\"ctrl.verEdiciones(canonico.id, canonico.nombre, canonico.apellidos, \'OTRO\')\" class=\"label label-warning\" ng-if=\"canonico.numOtros!=null\" title=\"{{\'admin.responsable.otros\' | translate}}\" ng-class=\"{\'disabled\': canonico.numOtros == 0}\">{{canonico.numOtros}}</a>\r\n        </td>\r\n\r\n        <!--Revisado-->\r\n        <td class=\"col-md-1 text-center button-icons\" data-title=\"\'admin.responsable.revisado\'  | translate\">\r\n            <input type=\"checkbox\" ng-model=\"canonico.revisado\" title=\"{{\'admin.responsable.revisado\' | translate}}\" ng-click=\"ctrl.setRevisado(canonico)\">\r\n        </td>\r\n\r\n        <!--Botones-->\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <!--Guardar datos-->\r\n            <a class=\"button glyphicon glyphicon-ok\" ng-click=\"ctrl.save(canonico, canonicoRowForm)\" ng-show=\"canonico.isEditing\" ng-class=\"{\'disabled\': canonicoRowForm.$pristine || canonicoRowForm.$invalid}\" title=\"{{\'admin.form.button.save\' | translate}}\"></a>\r\n\r\n            <!--Cancelar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-remove\" ng-click=\"ctrl.cancel(canonico, canonicoRowForm);\" title=\"{{\'admin.form.button.cancel\' | translate}}\" ng-show=\"canonico.isEditing\"></a>\r\n\r\n            <!--Iniciar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-pencil\" ng-click=\"canonico.isEditing = true; ctrl.saveState(canonico, canonicoRowForm)\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-show=\"!canonico.isEditing\"></a>\r\n\r\n            <!--Eliminar canonicoo-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(canonico)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!canonico.isEditing\"></a>\r\n        </td>\r\n    </tr>\r\n\r\n\r\n    <!--TODO hay que intentar no replicar el código-->\r\n    <!--CODIGO DE LAS VARIANTES------------------------------------------------------------------------------------------>\r\n\r\n    <tr ng-hide=\"canonico.$hideRows\" ng-repeat=\"variante in canonico.variantes track by variante.id\" ng-repeat-end ng-form=\"varianteRowForm\">\r\n\r\n        <td class=\"col-md\" data-title=\"\'admin.responsable.nombre\'  | translate\" ng-switch=\"variante.isEditing\">\r\n\r\n            <div class=\"btn-ctrl form-inline\">\r\n                <span ng-switch-default class=\"editable-text\" style=\"margin-left:10px\">{{variante.nombre}}  {{variante.apellidos}}</span>\r\n\r\n                <form ng-submit=\"ctrl.save(variante, varianteRowForm)\" name=\"form{{variante.id}}\">\r\n                    <!--Edición-->\r\n                    <div class=\"form-group controls\" ng-switch-when=\"true\">\r\n\r\n                        <!--nombre responsable variante-->\r\n                        <div class=\"form-group\" ng-class=\"nombreVarianteForm.$invalid && nombreVarianteForm.$dirty ? \'has-error\' : \'\'\" ng-form=\"nombreVarianteForm\">\r\n                            <input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"variante.nombre\" id=\"\" class=\"editable-input form-control\" placeholder=\"{{\'admin.responsable.edit.nombre\'| translate}}\" autofocus>\r\n                        </div>\r\n\r\n                        <!--apellidos responsable variante-->\r\n                        <div class=\"form-group\" ng-class=\"apellidosVarianteForm.$invalid && apellidosVarianteForm.$dirty ? \'has-error\' : \'\'\" ng-form=\"apellidosVarianteForm\">\r\n                            <input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"variante.apellidos\" id=\"\" class=\"editable-input form-control\" placeholder=\"{{\'admin.responsable.edit.apellidos\' | translate}}\">\r\n                        </div>\r\n\r\n                        <!--Checkbox si es canónico-->\r\n                        <label>\r\n                            {{\'admin.responsable.edit.esCanonico\' | translate}}\r\n                            <input type=\"checkbox\" ng-model=\"variante.es_canonico\" ng-init=\"variante.es_canonico = !variante.responsablecanonico\" ng-disabled=\"variante.responsablecanonico.id\"></label>\r\n\r\n                        <!--Desplegable para seleccionar el canónico-->\r\n                        <div class=\"form-group\" ng-form=\"nombreCanonicoVarianteForm\" ng-class=\"nombreCanonicoVarianteForm.$invalid && nombreCanonicoVarianteForm.$dirty ? \'has-error\' : \'\'\">\r\n                            <tesauro id=\"itemvariante\" ng-model=\"variante.responsablecanonico\" resource=\"ctrl.responsableService\" method=\"canonicoFilter\" restricted=\"true\" multiple=\"false\" min-length=\"0\" eliminable=\"true\" parameters=\"{ size: 20}\" ng-if=\"!variante.es_canonico\" ng-init=\"variante.responsablecanonico = {id: variante.responsablecanonico.id, nombreCompleto: variante.responsablecanonico.nombreCompleto}\" required=\"true\" placeholder=\"{{\'admin.responsable.edit.esCanonico\' | translate}}\" display=\"nombreCompleto\">\r\n                            </tesauro>\r\n                        </div>\r\n                        <!--Para poder hacer submit pulsando ENTER-->\r\n                        <input type=\"submit\" hidden>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </td>\r\n\r\n        <!--Cifras de obras-->\r\n        <td class=\"col-md-2 text-center button-icons-numbers tablaresponsable\" data-title=\"\'admin.responsable.form.obras\'  | translate\" ng-switch=\"variante.isEditing\">\r\n            <a type=\"button\" ng-click=\"ctrl.verRelaciones( variante.id, variante.nombre, variante.apellidos)\" class=\"label label-default\" ng-if=\"variante.numAutor!=null\" title=\"{{\'admin.responsable.autor\' | translate}}\" ng-class=\"{\'disabled\': variante.numAutor == 0}\"> {{variante.numAutor}}</a>\r\n            <a type=\"button\" ng-click=\"ctrl.verEdiciones(variante.id, variante.nombre, variante.apellidos, \'EDIT\')\" class=\"label label-primary\" ng-if=\"variante.numEditor!=null\" title=\"{{\'admin.responsable.editor\' | translate}}\" ng-class=\"{\'disabled\': variante.numEditor == 0}\"> {{variante.numEditor}}</a>\r\n            <a type=\"button\" ng-click=\"ctrl.verEdiciones(variante.id, variante.nombre, variante.apellidos, \'IMPR\')\" class=\"label label-success\" ng-if=\"variante.numImpresor!=null\" title=\"{{\'admin.responsable.impresor\' | translate}}\" ng-class=\"{\'disabled\': variante.numImpresor == 0}\"> {{variante.numImpresor}}</a>\r\n            <a type=\"button\" ng-click=\"ctrl.verEdiciones(variante.id, variante.nombre, variante.apellidos, \'TRAD\')\" class=\"label label-info\" ng-if=\"variante.numTraductor!=null\" title=\"{{\'admin.responsable.traductor\' | translate}}\" ng-class=\"{\'disabled\': variante.numTraductor == 0}\"> {{variante.numTraductor}}</a>\r\n            <a type=\"button\" ng-click=\"ctrl.verEdiciones(variante.id, variante.nombre, variante.apellidos, \'OTRO\')\" class=\"label label-warning\" ng-if=\"variante.numOtros!=null\" title=\"{{\'admin.responsable.otros\' | translate}}\" ng-class=\"{\'disabled\': variante.numOtros == 0}\"> {{variante.numOtros}}</a>\r\n        </td>\r\n\r\n        <!--Revisado-->\r\n        <td class=\"col-md-1 text-center button-icons\" data-title=\"\'admin.responsable.revisado\'  | translate\">\r\n            <input type=\"checkbox\" ng-model=\"variante.revisado\" title=\"{{\'admin.responsable.revisado\' | translate}}\" ng-click=\"ctrl.setRevisado(variante)\">\r\n        </td>\r\n\r\n\r\n        <!--Botones-->\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <!--Guardar datos-->\r\n            <a class=\"button glyphicon glyphicon-ok\" ng-click=\"ctrl.save(variante, varianteRowForm)\" ng-show=\"variante.isEditing\" ng-class=\"{\'disabled\': varianteRowForm.$pristine ||varianteRowForm.$invalid}\" title=\"{{\'admin.form.button.save\' | translate}}\"></a>\r\n\r\n            <!--Cancelar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-remove\" ng-click=\"ctrl.cancel(variante, varianteRowForm);\" title=\"{{\'admin.form.button.cancel\' | translate}}\" ng-show=\"variante.isEditing\"></a>\r\n\r\n            <!--Iniciar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-pencil\" ng-click=\"variante.isEditing = true; ctrl.saveState(variante, varianteRowForm)\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-show=\"!variante.isEditing\"></a>\r\n\r\n            <!--Eliminar variante-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(variante)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!variante.isEditing\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/admin/tesauro/tipologia/tipologia.list.html","<div class=\"btn-ctrl\">\r\n    <a class=\"btn btn-primary btn-crear\" ng-click=\"ctrl.addElementTable()\">\r\n        <span translate=\"admin.tipologia.create.title\"></span>\r\n    </a>\r\n</div>\r\n\r\n<filter filter=\"ctrl.filter.key\"></filter>\r\n\r\n<div class=\"total-elementos\">\r\n    <label>{{\'admin.total-elementos\' | translate}}: {{ctrl.tableParams.total() |number}}</label>\r\n</div>\r\n\r\n<table ng-table=\"ctrl.tableParams\" class=\"table table-condensed table-bordered table-striped table-hover\" class=\"ng-cloak\">\r\n    <tr ng-repeat=\"element in $data track by element.id\" class=\"animate\" ng-form=\"rowForm\">\r\n\r\n\r\n        <td class=\"col-md-11\" data-title=\"\'admin.tipologia.form.nombre\'  | translate\" sortable=\"\'nombre\'\" ng-switch=\"element.isEditing\" ng-form=\"nombreForm\">\r\n\r\n            <div class=\"btn-ctrl form-inline\">\r\n\r\n                <span ng-switch-default class=\"editable-text\">{{element.nombre}}</span>\r\n\r\n                <form ng-submit=\"ctrl.save(element, rowForm)\" name=\"form{{element.id}}\">\r\n                    <!--Edición-->\r\n                    <div class=\"form-group controls\" ng-class=\"nombreForm.$invalid && nombreForm.$dirty ? \'has-error\' : \'\'\" ng-switch-when=\"true\">\r\n                        <input type=\"text\" name=\"name\" size=\"135\" ng-model=\"element.nombre\" class=\"editable-input form-control input\" autofocus required>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n\r\n        </td>\r\n        <td class=\"col-md-1 text-center button-icons\">\r\n            <!--Guardar datos-->\r\n            <a class=\"button glyphicon glyphicon-ok\" ng-click=\"ctrl.save(element, rowForm)\" ng-show=\"element.isEditing\" ng-class=\"{\'disabled\': rowForm.$pristine || rowForm.$invalid}\" title=\"{{\'admin.form.button.save\' | translate}}\"></a>\r\n\r\n            <!--Cancelar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-remove\" ng-click=\"ctrl.cancel(element, rowForm);\" title=\"{{\'admin.form.button.cancel\' | translate}}\" ng-show=\"element.isEditing\"></a>\r\n\r\n            <!--Iniciar edición en línea-->\r\n            <a class=\"button glyphicon glyphicon-pencil\" ng-click=\"element.isEditing = true; ctrl.saveState(element, rowForm)\" title=\"{{\'admin.form.button.edit\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n\r\n            <!--Eliminar elemento-->\r\n            <a ng-click=\"ctrl.showRemoveConfirmation(element.id)\" class=\"button glyphicon glyphicon-trash\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!element.isEditing\"></a>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/components/form/buttons/buttons.form.template.html","<!--Botones de atrás/cancelar y crear/guardar-->\r\n<div class=\"form-bottom-buttons\" ng-switch=\"::$ctrl.canSave\">\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"$root.back()\">\r\n        <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n        <span translate=\"admin.form.button.back\" ng-switch-when=\"false\"></span>\r\n        <span translate=\"admin.form.button.cancel\" ng-switch-when=\"true\"></span>\r\n    </button>\r\n\r\n    <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!$ctrl.canSave\">\r\n        <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n        <span translate=\"admin.form.button.create\" ng-if=\"$ctrl.mode == \'create\'\"></span>\r\n        <span translate=\"admin.form.button.save\" ng-if=\"$ctrl.mode == \'edit\'\"></span>\r\n    </button>\r\n</div>\r\n");
$templateCache.put("app/components/estaticas/admin/estatica-form.admin.html","<form name=\"ctrl.form\" role=\"form\" ng-submit=\"ctrl.save()\" class=\"estatica-form\">\r\n    <div class=\"form-body\">\r\n\r\n        <h3>{{\'estaticas.pagina.\' + ctrl.estatica.nombre | translate}}</h3>\r\n\r\n        <uib-tabset active=\"ctrl.active\" ng-class=\"{\'single-language\': ctrl.idiomas.length === 1}\">\r\n            <uib-tab ng-repeat=\"idioma in ctrl.idiomas\" index=\"$index\" heading=\"{{\'enum.idiomas-app.nombre.\' + idioma | translate}}\" ng-init=\"ctrl.init(ctrl.estatica, $index, idioma)\">\r\n                <div class=\"row\">\r\n                    <!--Título-->\r\n                    <div class=\"col-sm-12\">\r\n                        <div class=\"form-group\">\r\n                            <label-form key=\"estaticas.i18n.titulo\" d=\"titulo_{{idioma}}\" required=\"true\"></label-form>\r\n                            <input type=\"text\" class=\"form-control\" id=\"titulo_{{idioma}}\" required ng-model=\"(ctrl.estatica.estaticasI18n | filter: {idioma: idioma})[0].titulo\">\r\n                        </div>\r\n                    </div>\r\n\r\n                    <!--Contenido-->\r\n                    <div class=\"col-sm-12\">\r\n                        <div class=\"form-group\">\r\n                            <text-area id=\"contenido_{{idioma}}\" label=\"estaticas.i18n.contenido\" model=\"(ctrl.estatica.estaticasI18n | filter: {idioma: idioma})[0].contenido\" tipo=\"estatica\"></text-area>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </uib-tab>\r\n        </uib-tabset>\r\n\r\n        <div class=\"form-bottom-buttons\">\r\n            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"ctrl.validar()\">\r\n                <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.save\" ng-if=\"ctrl.mode == \'edit\'\"></span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/form/date/date-picker.html","<label-form key=\"{{$ctrl.label}}\" for=\"{{$ctrl.id}}\" required=\"$ctrl.required\"></label-form>\r\n\r\n<div class=\"input-group date-picker\">\r\n    <input type=\"text\" class=\"form-control\" id=\"{{$ctrl.id}}\" uib-datepicker-popup=\"{{$ctrl.format}}\" ng-change=\"$ctrl.change($ctrl.model)\" ng-focus=\"$ctrl.openDatePicker()\" ng-model=\"$ctrl.model\" is-open=\"$ctrl.opened\" datepicker-options=\"$ctrl.dateOptions\" ng-required=\"$ctrl.required\" close-text=\"{{\'global.button.close\' | translate}}\" current-text=\"{{\'global.button.currentday\' | translate}}\" clear-text=\"{{\'global.button.clear\' | translate}}\" show-button-bar=\"$ctrl.showBar\" ng-readonly=\"$ctrl.readonly\">\r\n\r\n    <span class=\"input-group-btn\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openDatePicker()\">\r\n            <i class=\"glyphicon glyphicon-calendar\"></i>\r\n        </button>\r\n    </span>\r\n</div>\r\n");
$templateCache.put("app/components/form/delete/entity.delete.modal.html","<form ng-submit=\"ctrl.confirmRemove(ctrl.item)\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"ctrl.dismiss()\">&times;</button>\r\n        <h4 class=\"modal-title\" translate=\"{{ctrl.params.title}}\"></h4>\r\n    </div>\r\n\r\n    <div class=\"modal-body\">\r\n        <alert modal=\"true\"></alert>\r\n\r\n        <p translate=\"{{ctrl.params.body}}\" translate-values=\"{id: \'{{::ctrl.item[ctrl.params.property]}}\'}\"></p>\r\n\r\n    </div>\r\n\r\n    <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.dismiss()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"admin.form.button.cancel\"></span>\r\n        </button>\r\n        <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\">\r\n            <span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"admin.form.button.delete\"></span>\r\n        </button>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/components/form/enum/enum-select.html","<label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\"></label-form>\r\n\r\n<select class=\"form-control\" id=\"ctrl.id\" ng-model=\"ctrl.model\" ng-disabled=\"ctrl.disabled\" ng-required=\"ctrl.required\" ng-change=\"ctrl.onChange(ctrl.model)\">\r\n    <option value=\"\" ng-if=\"!ctrl.required\">{{ctrl.empty | translate}}</option>\r\n    <option ng-repeat=\"value in ctrl.options track by value\" value=\"{{value}}\" required>\r\n        {{ctrl.display ? ctrl.base + \'.\' + value[ctrl.display] : ctrl.base + \'.\' + value | translate}}\r\n    </option>\r\n</select>\r\n");
$templateCache.put("app/components/form/filter/filter.input.template.html","<div class=\"form-inline\">\r\n    <div class=\"form-group\">\r\n        <input id=\"keysFilter\" class=\"form-control\" type=\"text\" ng-model=\"$ctrl.filter\" placeholder=\"{{\'admin.form.filter\' | translate}}\">\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/form/imagenes/imagen.modal.html","<form name=\"form\" role=\"form\" ng-submit=\"formCtrl.save()\" ng-switch=\"::formCtrl.canSave\" show-validation=\"\">\r\n\r\n    <div class=\"modal-body imagenreal\">\r\n        <alert modal=\"true\"></alert>\r\n        <img ng-src=\"{{ctrl.path}}\">\r\n    </div>\r\n\r\n    <div class=\"modal-footer\">\r\n        <!--Botones-->\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.clear()\">\r\n            <span translate=\"admin.form.button.back\"></span>\r\n        </button>\r\n    </div>\r\n\r\n</form>\r\n");
$templateCache.put("app/components/form/imagenes/imagenes.form.html","<div class=\"imagenes\">\r\n\r\n    <!--Carga de imágenes-->\r\n    <div class=\"form-group upload sortable-container\" sv-root sv-part=\"formCtrl.imagenes \" sv-on-sort=\"formCtrl.sortableOptions()\">\r\n        <div class=\"bloque-imagen row-margin-bottom\" ng-repeat=\"imagen in formCtrl.elements\" sv-element>\r\n            <div>\r\n                <imagen id=\"{{formCtrl.idBloque}}_imagen_{{$index}}\" ng-model=\"imagen\" ng-model-radio=\"formCtrl.selected\" ruta-carpeta-imagen=\"{{formCtrl.rutaCarpetaImagen}}\" indice=\"$index\" edicion=\"true\" on-uploaded-image=\"formCtrl.onUploadedImage()\" on-remove-image=\"formCtrl.onRemoveImage(imagen)\" mensaje=\"{{formCtrl.mensaje}}\">\r\n                </imagen>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/form/listform/list-form.html","<fieldset class=\"fieldset-border form-group list-form\">\r\n    <div class=\"row title\">\r\n        <div class=\"col-xs-8\">\r\n            <label-form key=\"{{ctrl.label}}\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n        </div>\r\n\r\n        <div class=\"col-xs-4 text-right\">\r\n            <button type=\"button\" ng-click=\"ctrl.addElement()\" class=\"btn btn-default\" title=\"{{\'admin.form.button.add\' | translate}}\">\r\n                <span class=\"glyphicon glyphicon-plus\"></span>\r\n                {{\'admin.form.button.add\' | translate}}\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row element\" ng-repeat=\"element in ctrl.list track by $index\" ng-class=\"ctrl.acordeon ? \'acordeon\' : \'sin-acordeon\'\">\r\n\r\n        <ng-include src=\"ctrl.templateUrl\"></ng-include>\r\n\r\n        <!--Eliminar-->\r\n        <div class=\"remove button-icons form-center-vertical\">\r\n            <a ng-click=\"ctrl.removeElement(element)\" class=\"glyphicon glyphicon-remove\" title=\"{{\'admin.form.button.delete\' | translate}}\"></a>\r\n        </div>\r\n    </div>\r\n</fieldset>\r\n");
$templateCache.put("app/components/form/tesauro/tesauro.html","<div class=\"tesauro\">\r\n\r\n    <ng-include src=\"\'app/templates/tesauro.templates.html\'\" ng-if=\"ctrl.templateUrl\"></ng-include>\r\n\r\n    <label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n\r\n    <!--Múltiple (ngTagsInput)-->\r\n    <tags-input ng-if=\"ctrl.multiple\" class=\"bootstrap\" ng-class=\"{\'as-list\': ctrl.asList}\" ng-model=\"ctrl.ngModel\" ng-disabled=\"ctrl.disabled\" display-property=\"{{ctrl.display}}\" key-property=\"{{ctrl.key}}\" add-on-blur=\"false\" add-from-autocomplete-only=\"{{ctrl.restricted}}\" on-tag-added=\"ctrl.setElement($tag)\" replace-spaces-with-dashes=\"false\" placeholder=\"{{ctrl.placeholder | translate}}\">\r\n        <auto-complete source=\"ctrl.loadTags($query)\" select-first-match=\"false\" min-length=\"{{ctrl.minLength}}\" load-on-focus=\"true\" load-on-empty=\"{{ctrl.minLength == 0}}\"></auto-complete>\r\n    </tags-input>\r\n\r\n    <!--Simple (Angular Bootstrap)-->\r\n    <div ng-if=\"!ctrl.multiple\" ng-class=\"{\'input-group\': ctrl.eliminable}\">\r\n        <input type=\"text\" class=\"form-control\" id=\"{{ctrl.id}}\" ng-model=\"ctrl.ngModel[ctrl.display]\" ng-required=\"ctrl.required\" ng-disabled=\"ctrl.disabled\" ng-blur=\"ctrl.onBlur()\" typeahead-show-hint=\"true\" typeahead-editable=\"!ctrl.restricted\" uib-typeahead=\"element[ctrl.display] for element in ctrl.loadTags($viewValue)\" typeahead-min-length=\"ctrl.minLength | num\" typeahead-on-select=\"ctrl.setElement($item)\" typeahead-select-on-exact=\"true\" typeahead-template-url=\"{{ctrl.templateUrl}}\" autocomplete=\"off\" placeholder=\"{{ctrl.placeholder | translate}}\">\r\n        <span class=\"input-group-addon\" ng-if=\"ctrl.eliminable\">\r\n            <a type=\"button\" class=\"glyphicon glyphicon-remove\" ng-click=\"ctrl.clear()\" title=\"{{\'admin.form.button.remove\' | translate}}\" ng-class=\"{\'disabled\': !ctrl.ngModel[ctrl.display] || ctrl.disabled}\"></a>\r\n        </span>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/components/form/select/select.form.html","<label-form key=\"{{ctrl.label}}\" for=\"{{ctrl.id}}\" required=\"ctrl.required\" tooltip=\"{{ctrl.tooltip}}\"></label-form>\r\n\r\n<select class=\"form-control\" name=\"{{ctrl.id}}\" ng-model=\"ctrl.model\" ng-change=\"ctrl.change(ctrl.model)\" ng-options=\"value as ctrl.formatElement(value) | translate for value in ctrl.options track by value.id\" ng-required=\"ctrl.required\">\r\n    <option value=\"\" ng-if=\"!ctrl.required\">{{ctrl.empty | translate}}</option>\r\n</select>\r\n");
$templateCache.put("app/components/form/tooltip/tooltip.html","<span class=\"ng-tooltip\">\r\n    <span class=\"icon glyphicon glyphicon-question-sign\" uib-tooltip=\"{{label | translate}}\" tooltip-placement=\"{{position || \'right\'}}\">\r\n    </span>\r\n</span>\r\n");
$templateCache.put("app/public/components/login/login.html","<div has-any-authority=\"ROLE_ANONYMOUS\">\r\n    <social provider=\"google\"></social>\r\n    <social provider=\"facebook\"></social>\r\n\r\n    <form class=\"form\" role=\"form\" show-validation>\r\n        <div class=\"form-group\">\r\n            <label for=\"username\" translate=\"login.form.username.label\"></label>\r\n            <input class=\"form-control\" id=\"username\" ng-model=\"$ctrl.username\" type=\"text\">\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <label for=\"password\" translate=\"login.form.password.label\"></label>\r\n            <input class=\"form-control\" id=\"password\" ng-model=\"$ctrl.password\" type=\"password\">\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n            <a ui-sref=\"recuperar/init\">{{\'login.password.forgot\' | translate}}</a>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n            <label for=\"rememberMe\">\r\n                <input checked=\"true\" id=\"rememberMe\" ng-model=\"$ctrl.rememberMe\" type=\"checkbox\">\r\n                {{\'login.form.rememberme\' | translate}}\r\n            </label>\r\n\r\n            <button class=\"btn btn-primary\" ng-click=\"$ctrl.login()\" translate=\"login.form.button\" type=\"submit\"></button>\r\n        </div>\r\n    </form>\r\n</div>\r\n\r\n");
$templateCache.put("app/public/components/buscador/buscador.avanzado.html","<div class=\"buscador-avanzado\">\r\n    <form name=\"form\" role=\"form\" ng-submit=\"ctrl.search()\">\r\n\r\n        <!--DATOS RELACION------------------------------------------------------------------------------------------>\r\n\r\n        <div class=\"row\">\r\n            <!--Titulo-->\r\n            <div class=\"col-md-12 form-group\">\r\n                <label-form key=\"buscador.avanzado.tituloRelacion\" for=\"tituloRelacion\"></label-form>\r\n                <input type=\"text\" id=\"tituloRelacion\" ng-model=\"ctrl.filter.tituloRelacion\" class=\"form-control\">\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--BDRS-->\r\n            <div class=\"col-md-2 form-group\">\r\n                <label-form key=\"buscador.avanzado.bdrs\" for=\"bdrs\"></label-form>\r\n                <input type=\"text\" id=\"bdrs\" ng-model=\"ctrl.filter.bdrs\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--Lugar acontecimiento-->\r\n            <div class=\"col-md-4 form-group\">\r\n                <label-form key=\"buscador.avanzado.lugarAcontecimiento\" for=\"lugarAcontecimiento\"></label-form>\r\n                <input type=\"text\" id=\"lugarAcontecimiento\" ng-model=\"ctrl.filter.lugarAcontecimiento\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--Año aconotecimiento minimo -->\r\n            <div class=\"form-group col-md-2 auto-margin-bottom\">\r\n                <label-form key=\"buscador.avanzado.anoAcontecimiento\" for=\"anoInicioAcontecimiento\"></label-form>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-3 label-ano\">\r\n                        <label-form key=\"buscador.avanzado.anoInicioAcontecimiento\" for=\"anoInicioAcontecimiento\"></label-form>\r\n                    </div>\r\n                    <div class=\"col-md-9\">\r\n                        <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.filter.anoInicioAcontecimiento\" id=\"anoInicioAcontecimiento\" ng-disabled=\"ctrl.filter.sinAnoAcontecimiento\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Año aconotecimiento maximo -->\r\n            <div class=\"form-group col-md-2\">\r\n\r\n                <div class=\"row bajar-input\">\r\n                    <div class=\"col-md-3 label-ano\">\r\n                        <label-form key=\"buscador.avanzado.anoFinAcontecimiento\" for=\"anoFinAcontecimiento\"></label-form>\r\n                    </div>\r\n                    <div class=\"col-md-9\">\r\n                        <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.filter.anoFinAcontecimiento\" id=\"anoFinAcontecimiento\" ng-disabled=\"ctrl.filter.sinAnoAcontecimiento\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Sin año acontecimiento-->\r\n            <div class=\"col-md-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"sinAnoAcontecimiento\" type=\"checkbox\" ng-model=\"ctrl.filter.sinAnoAcontecimiento\" ng-disabled=\"ctrl.filter.anoInicioAcontecimiento || ctrl.filter.anoFinAcontecimiento\">\r\n                    <label-form key=\"buscador.avanzado.sinAnoAcontecimiento\" for=\"sinAnoAcontecimiento\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Autor-->\r\n            <div class=\"col-md-4 form-group\">\r\n                <label-form key=\"buscador.avanzado.autor\" for=\"autor\"></label-form>\r\n                <input type=\"text\" id=\"autor\" ng-model=\"ctrl.filter.autor\" class=\"form-control\" ng-disabled=\"ctrl.filter.sinAutor\">\r\n            </div>\r\n\r\n            <div class=\"col-md-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"anonima\" type=\"checkbox\" ng-model=\"ctrl.filter.anonima\" ng-disabled=\"ctrl.filter.autor\">\r\n                    <label-form key=\"buscador.avanzado.anonima\" for=\"anonima\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Tipologías-->\r\n            <div class=\"form-group col-md-3\">\r\n                <label-form key=\"buscador.avanzado.tipologia\"></label-form>\r\n                <select-form model=\"ctrl.filter.tipologia \" options=\"ctrl.tipologias\">\r\n                </select-form>\r\n            </div>\r\n\r\n            <!--Subgénero -->\r\n            <div class=\"form-group col-md-3\">\r\n                <label-form key=\"buscador.avanzado.subgenero\"></label-form>\r\n                <select class=\"form-control\" ng-model=\"ctrl.filter.subgenero\" ng-options=\"subgenero as subgenero.nombre for subgenero in ctrl.subgeneros  |filter: {tipologia: {id:ctrl.filter.tipologia.id }} track by subgenero.id\" ng-disabled=\"!ctrl.filter.tipologia\">\r\n                    <option value=\"\"></option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <!--DATOS EDICION-------------------------------------------------------------------------------------------------------->\r\n\r\n        <div class=\"row\">\r\n            <!--Titulo EDICION-->\r\n            <div class=\"col-md-12 form-group\">\r\n                <label-form key=\"buscador.avanzado.tituloEdicion\" for=\"tituloEdicion\"></label-form>\r\n                <input type=\"text\" id=\"tituloEdicion\" ng-model=\"ctrl.filter.tituloEdicion\" class=\"form-control\">\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Lugar edicion-->\r\n            <div class=\"col-md-4 form-group\">\r\n                <label-form key=\"buscador.avanzado.lugarEdicion\" for=\"lugarEdicion\"></label-form>\r\n                <input type=\"text\" id=\"lugarEdicion\" ng-model=\"ctrl.filter.lugarEdicion\" class=\"form-control\" ng-disabled=\"ctrl.filter.sinLugarEdicion\">\r\n            </div>\r\n\r\n            <!--Sin lugar-->\r\n            <div class=\"col-md-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"sinLugarEdicion\" type=\"checkbox\" ng-model=\"ctrl.filter.sinLugarEdicion\" ng-disabled=\"ctrl.filter.lugarEdicion\">\r\n                    <label-form key=\"buscador.avanzado.sinLugarEdicion\" for=\"sinLugarEdicion\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Año Min -->\r\n            <div class=\"form-group col-md-2 auto-margin-bottom\">\r\n                <label-form key=\"buscador.avanzado.anoEdicion\" for=\"anoInicioEdicion\"></label-form>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-3 label-ano\">\r\n                        <label-form key=\"buscador.basico.anoInicioEdicion\" for=\"anoInicioEdicion\"></label-form>\r\n                    </div>\r\n                    <div class=\"col-md-9\">\r\n                        <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.filter.anoInicioEdicion\" id=\"anoInicioEdicion\" ng-disabled=\"ctrl.filter.sinAnoEdicion\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <!--Año maximo-->\r\n            <div class=\"col-md-2 form-group\">\r\n\r\n                <div class=\"row bajar-input\">\r\n                    <div class=\"col-md-3 label-ano\">\r\n                        <label-form key=\"buscador.avanzado.anoEdicionMax\" for=\"anoFinEdicion\"></label-form>\r\n                    </div>\r\n                    <div class=\"col-md-9\">\r\n                        <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.filter.anoFinEdicion\" id=\"anoFinEdicion\" ng-disabled=\"ctrl.filter.sinAnoEdicion\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <!--Sin año-->\r\n            <div class=\"col-md-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"sinAnoEdicion\" type=\"checkbox\" ng-model=\"ctrl.filter.sinAnoEdicion\" ng-disabled=\"ctrl.filter.anoEdicionMin || ctrl.filter.anoEdicionMax\">\r\n                    <label-form key=\"buscador.avanzado.sinAnoEdicion\" for=\"sinAnoEdicion\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--PERSONA-->\r\n        <div class=\"row\">\r\n            <!--Impresor-->\r\n            <div class=\"col-md-4 form-group\">\r\n                <label-form key=\"buscador.avanzado.impresor\" for=\"impresor\"></label-form>\r\n                <input type=\"text\" id=\"impresor\" ng-model=\"ctrl.filter.impresor\" class=\"form-control\" ng-disabled=\"ctrl.filter.sinImpresor\">\r\n            </div>\r\n\r\n            <!--Sin impresor-->\r\n            <div class=\"col-md-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"sinImpresor\" type=\"checkbox\" ng-model=\"ctrl.filter.sinImpresor\" ng-disabled=\"ctrl.filter.impresor\">\r\n                    <label-form key=\"buscador.avanzado.sinImpresor\" for=\"sinImpresor\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Editor-->\r\n            <div class=\"col-md-3 form-group\">\r\n                <label-form key=\"buscador.avanzado.editor\" for=\"editor\"></label-form>\r\n                <input type=\"text\" id=\"editor\" ng-model=\"ctrl.filter.editor\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--Traductor-->\r\n            <div class=\"col-md-3 form-group\">\r\n                <label-form key=\"buscador.avanzado.traductor\" for=\"traductor\"></label-form>\r\n                <input type=\"text\" id=\"traductor\" ng-model=\"ctrl.filter.traductor\" class=\"form-control\">\r\n            </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--Otros-->\r\n            <div class=\"col-md-3 form-group\">\r\n                <label-form key=\"buscador.avanzado.otros\" for=\"otros\"></label-form>\r\n                <input type=\"text\" id=\"otros\" ng-model=\"ctrl.filter.otrosRoles\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--Epiteto-->\r\n\r\n            <div class=\"col-md-3 form-group\">\r\n                <label-form key=\"buscador.avanzado.epiteto\" for=\"epiteto\"></label-form>\r\n                <input type=\"text\" id=\"epiteto\" ng-model=\"ctrl.filter.epiteto\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--MODALIDAD DISCURSO-->\r\n\r\n            <div class=\"col-md-2\">\r\n                <div class=\"form-group\">\r\n                    <enum-select id=\"modalidaddiscurso\" label=\"buscador.avanzado.modalidaddiscurso\" model=\"ctrl.filter.modalidadDiscurso\" options=\"ctrl.modalidades\" base=\"enum.modalidaddiscurso\"></enum-select>\r\n                </div>\r\n            </div>\r\n\r\n            <!--TAMAÑO-->\r\n            <div class=\"col-md-2\">\r\n                <div class=\"form-group\">\r\n                    <enum-select id=\"tamano\" label=\"buscador.avanzado.tamano\" model=\"ctrl.filter.tamano\" options=\"ctrl.tamanos\" base=\"enum.tamano\"></enum-select>\r\n                </div>\r\n            </div>\r\n            <!--Idioma-->\r\n\r\n            <div class=\"col-md-2\">\r\n                <div class=\"form-group\" ng-form=\"idioma\" ng-class=\"idioma.$invalid && idioma.$dirty ? \'has-error\' : \'\'\">\r\n                    <tesauro id=\"idioma\" ng-model=\"ctrl.filter.idioma \" resource=\"ctrl.idiomaService\" method=\"findAll\" restricted=\"true\" multiple=\"false\" min-length=\"0\" eliminable=\"true\" label=\"admin.edicion.form.idioma\" parameters=\"{sortProperty: \'nombre\', size:20}\">\r\n                    </tesauro>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"row\">\r\n            <!--biblioteca-->\r\n            <div class=\"col-md-6\">\r\n                <div class=\"form-group\" ng-form=\"biblioteca\" ng-class=\"biblioteca.$invalid && biblioteca.$dirty ? \'has-error\' : \'\'\">\r\n                    <tesauro id=\"biblioteca\" ng-model=\"ctrl.filter.biblioteca \" resource=\"ctrl.bibliotecaService\" method=\"findAll\" restricted=\"true\" multiple=\"false\" min-length=\"0\" eliminable=\"true\" label=\"buscador.avanzado.biblioteca\" parameters=\"{sortProperty: \'nombre\', size: 20}\" tooltip=\"buscador.avanzado.bibliotecaTooltip\">\r\n                </tesauro></div>\r\n            </div>\r\n\r\n            <!--pais-->\r\n            <div class=\"col-md-3\">\r\n                <div class=\"form-group\">\r\n                    <tesauro id=\"pais_{{$index}}\" ng-model=\"ctrl.filter.pais\" resource=\"ctrl.bibliotecaService\" method=\"findAllPaises\" restricted=\"true\" multiple=\"false\" min-length=\"0\" label=\"buscador.avanzado.pais\" eliminable=\"true\" parameters=\"{sortProperty: \'pais\', size: 20}\"></tesauro>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Revisado y publicado-->\r\n        <div class=\"row more-margin-bottom\" has-any-authority=\"{{\'ROLE_ADMIN\' || \'ROLE_INVESTIGADOR\'}}\">\r\n            <div class=\"col-md-2\">\r\n                <label-form key=\"buscador.avanzado.revisado\" for=\"revisado\"></label-form>\r\n                <enum-select id=\"revisado\" model=\"ctrl.filter.revisado\" options=\"[true, false]\" base=\"enum.boolean\"></enum-select>\r\n            </div>\r\n\r\n            <div class=\"col-md-2\">\r\n                <label-form key=\"buscador.avanzado.publicado\" for=\"publicado\"></label-form>\r\n                <enum-select id=\"publicado\" model=\"ctrl.filter.publicado\" options=\"[true, false]\" base=\"enum.boolean\"></enum-select>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n            </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--varias ediciones-->\r\n            <div class=\"col-md-6 col-lg-4\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"variasEdiciones\" type=\"checkbox\" ng-model=\"ctrl.filter.variasEdiciones\">\r\n                    <b>\r\n                        <label-form key=\"buscador.avanzado.variasEdiciones\" for=\"variasEdiciones\"></label-form>\r\n                    </b>\r\n                </div>\r\n            </div>\r\n\r\n            <!--ejemplar digitalizado-->\r\n            <div class=\"col-md-6 col-lg-4\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"digitalizadas\" type=\"checkbox\" ng-model=\"ctrl.filter.ejemplarDigitalizado\">\r\n                    <label-form key=\"buscador.avanzado.digitalizadas\" for=\"digitalizadas\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Tiene ilustraciones-->\r\n            <div class=\"col-md-6 col-lg-4\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"tieneIlustraciones\" type=\"checkbox\" ng-model=\"ctrl.filter.tieneIlustraciones\">\r\n                    <label-form key=\"buscador.avanzado.tieneIlustraciones\" for=\"tieneIlustraciones\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Creadas recientemente-->\r\n            <div class=\"col-md-6 col-lg-4\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"creadasRecientemente\" type=\"checkbox\" ng-model=\"ctrl.filter.creadasRecientemente\">\r\n                    <label-form key=\"buscador.basico.creadasRecientemente\" for=\"creadasRecientemente\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Modificadas recientemente-->\r\n            <div class=\"col-md-6 col-lg-4 auto-margin-bottom\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"modificadasRecientemente\" type=\"checkbox\" ng-model=\"ctrl.filter.modificadasRecientemente\">\r\n                    <label-form key=\"buscador.basico.modificadasRecientemente\" for=\"modificadasRecientemente\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Es Traduccion-->\r\n            <div class=\"col-md-6 col-lg-4 auto-margin-bottom\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"esTraduccion\" type=\"checkbox\" ng-model=\"ctrl.filter.esTraduccion\">\r\n                    <label-form key=\"buscador.basico.esTraduccion\" for=\"esTraduccion\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Botón buscar-->\r\n        <div class=\"buscador-buttons row form-group\">\r\n            <div class=\"col-sm-12 text-right\">\r\n                <button type=\"button\" class=\"btn btn-default space-button-clean\" ng-click=\"ctrl.clear()\">\r\n                    {{\'buscador.avanzado.limpiar\' | translate}}\r\n                </button>\r\n                <button type=\"submit\" class=\"btn btn-primary-public space-button-find\">\r\n                    {{\'buscador.avanzado.buscar\' | translate}}&nbsp; <i class=\"fa fa-search\"></i>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</div>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n");
$templateCache.put("app/public/components/buscador/buscador.basico.html","<div class=\"buscador-basico\">\r\n    <form name=\"form\" role=\"form\" ng-submit=\"ctrl.search()\">\r\n        <div class=\"row\">\r\n\r\n            <!--General-->\r\n            <div class=\"col-md-6 form-group\">\r\n                <label-form key=\"buscador.basico.general\" for=\"general\"></label-form>\r\n                <input type=\"text\" id=\"general\" ng-model=\"ctrl.filter.general\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--Titulo-->\r\n            <div class=\"col-md-6 form-group\">\r\n                <label-form key=\"buscador.avanzado.tituloRelacion\" for=\"tituloRelacion\"></label-form>\r\n                <input type=\"text\" id=\"tituloRelacion\" ng-model=\"ctrl.filter.tituloRelacion\" class=\"form-control\">\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!--LUGARES - PERSONA-->\r\n        <div class=\"row\">\r\n\r\n            <!--Persona-->\r\n            <div class=\"col-md-6 form-group\">\r\n                <label-form key=\"buscador.basico.persona\" for=\"persona\"></label-form>\r\n                <tooltip label=\"buscador.basico.personaTooltip\"></tooltip>\r\n                <input type=\"text\" id=\"persona\" ng-model=\"ctrl.filter.persona\" class=\"form-control\">\r\n            </div>\r\n\r\n            <!--Lugar edicion-->\r\n            <div class=\"col-md-4 form-group\">\r\n                <label-form key=\"buscador.basico.lugarEdicion\" for=\"lugarEdicion\"></label-form>\r\n                <input type=\"text\" id=\"lugarEdicion\" ng-model=\"ctrl.filter.lugarEdicion\" class=\"form-control\" ng-disabled=\"ctrl.filter.sinLugarEdicion\">\r\n            </div>\r\n\r\n\r\n            <!--Sin lugar-->\r\n            <div class=\"col-md-2 form-center-vertical\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"sinLugarEdicion\" type=\"checkbox\" ng-model=\"ctrl.filter.sinLugarEdicion\" ng-disabled=\"ctrl.filter.lugarEdicion\">\r\n                    <label-form key=\"buscador.basico.sinLugarEdicion\" for=\"sinLugarEdicion\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!--AÑOS-->\r\n        <div class=\"row\">\r\n            <!--Año edición -->\r\n            <div class=\"form-group col-md-2\">\r\n                <label-form key=\"buscador.basico.anoEdicion\" for=\"anoEdicion\"></label-form>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.filter.anoEdicion\" id=\"anoEdicion\" ng-disabled=\"ctrl.filter.sinAnoEdicion || ctrl.filter.anoInicioEdicion || ctrl.filter.anoFinEdicion\">\r\n            </div>\r\n            <!--Año minimo -->\r\n            <div class=\"form-group col-md-2\">\r\n                <label-form key=\"buscador.basico.anoInicioEdicion\" for=\"anoInicioEdicion\"></label-form>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.filter.anoInicioEdicion\" id=\"anoInicioEdicion\" ng-disabled=\"ctrl.filter.sinAnoEdicion || ctrl.filter.anoEdicion\">\r\n            </div>\r\n            <!--Año maximo -->\r\n            <div class=\"form-group col-md-2\">\r\n                <label-form key=\"buscador.basico.anoFinEdicion\" for=\"anoFinEdicion\"></label-form>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.filter.anoFinEdicion\" id=\"anoFinEdicion\" ng-disabled=\"ctrl.filter.sinAnoEdicion || ctrl.filter.anoEdicion\">\r\n            </div>\r\n            <!--Sin año-->\r\n            <div class=\"col-md-6 form-center-vertical checkbox-center\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"sinAnoEdicion\" type=\"checkbox\" ng-model=\"ctrl.filter.sinAnoEdicion\" ng-disabled=\"ctrl.filter.anoEdicion ||ctrl.filter.anoInicioEdicion ||ctrl.filter.anoFinEdicion \">\r\n                    <label-form key=\"buscador.basico.sinAnoEdicion\" for=\"sinAnoEdicion\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <!--varias ediciones-->\r\n            <div class=\"col-sm-6 less-margin\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"variasEdiciones\" type=\"checkbox\" ng-model=\"ctrl.filter.variasEdiciones\">\r\n                    <b>\r\n                        <label-form key=\"buscador.avanzado.variasEdiciones\" for=\"variasEdiciones\"></label-form>\r\n                    </b>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Creadas recientemente-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"creadasRecientemente\" type=\"checkbox\" ng-model=\"ctrl.filter.creadasRecientemente\">\r\n                    <label-form key=\"buscador.basico.creadasRecientemente\" for=\"creadasRecientemente\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Modificadas recientemente-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"modificadasRecientemente\" type=\"checkbox\" ng-model=\"ctrl.filter.modificadasRecientemente\">\r\n                    <label-form key=\"buscador.basico.modificadasRecientemente\" for=\"modificadasRecientemente\"></label-form>\r\n                </div>\r\n            </div>\r\n\r\n            <!--Digitalizado-->\r\n            <div class=\"col-sm-6\">\r\n                <div class=\"form-group\">\r\n                    <input id=\"ejemplarDigitalizado\" type=\"checkbox\" ng-model=\"ctrl.filter.ejemplarDigitalizado\">\r\n                    <label-form key=\"buscador.basico.ejemplarDigitalizado\" for=\"ejemplarDigitalizado\"></label-form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <!--Botón buscar-->\r\n        <div class=\"buscador-buttons row form-group\">\r\n            <div class=\"col-sm-12 text-right\">\r\n                <button type=\"button\" class=\"btn btn-default space-button-clean\" ng-click=\"ctrl.clear()\">\r\n                    {{\'buscador.basico.limpiar\' | translate}}\r\n                </button>\r\n                <button type=\"submit\" class=\"btn btn-primary-public space-button-find\">\r\n                    {{\'buscador.basico.buscar\' | translate}}&nbsp; <i class=\"fa fa-search\"></i>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</div>\r\n\r\n<loading is-loading=\"ctrl.loading\" class=\"center-block\"></loading>\r\n\r\n");
$templateCache.put("app/public/components/listado/edicion.list.html","<div class=\"edicion-list\">\r\n\r\n    <div class=\"row edicion-list\" ng-repeat=\"edicion in ctrl.ediciones track by edicion.id\">\r\n        <!--Titulo-->\r\n        <div class=\"titulo col-sm-12\">\r\n            <input id=\"check_edicion_{{$index}}\" type=\"checkbox\" ng-if=\"ctrl.check\" ng-model=\"edicion.seleccionada\">\r\n            <a ui-sref=\"edicionDetails({bdrs: edicion.bdrs, edicionId: edicion.id})\">\r\n                <i class=\"fa fa-picture-o\" ng-if=\"edicion.estaDigitalizada\" title=\"{{\'listado.estaDigitalizada\' | translate}}\"></i>\r\n                <i class=\"fa fa-check\" ng-if=\"edicion.vista\" title=\"{{\'listado.vista\' | translate}}\"></i>\r\n                <i class=\"fa fa-forward\" ng-if=\"edicion.modificadaRecientemente\" title=\"{{\'listado.modificadaRecientemente\' | translate}}\"></i>\r\n                <i class=\"fa fa-list-ul\" ng-if=\"edicion.hermanas>1\" title=\"{{\'listado.numeroEdiciones\' | translate}}\"></i>\r\n                <b ng-repeat=\"autor in edicion.autores\"> <b class=\"uppercase\">{{autor.apellidos}}</b><b ng-if=\" autor.apellidos != null\">, </b><b>{{autor.nombre}}{{$last ? \':\' : \'; \'}} </b>\r\n                </b>\r\n                <i>{{edicion.titulo}}</i>\r\n            </a>\r\n        </div>\r\n\r\n        <!--Otros datos-->\r\n        <div class=\"datos col-sm-12\">\r\n             <span ng-if=\"edicion.esLugarDeducido\">[</span><span ng-if=\"edicion.lugar !=null\">{{edicion.lugar.nombre}}</span><span ng-if=\"edicion.lugar ==null\">S.L</span><span ng-if=\"edicion.esLugarProbable\">?</span><span ng-if=\"edicion.esLugarDeducido\">]</span><span>, </span>\r\n            <span ng-repeat=\"responsableDTO in edicion.responsables\">{{responsableDTO.nombreFormateado}}{{$last ? \',\' : \' - \'}}\r\n            </span>\r\n            <span ng-if=\"!edicion.tieneImpresor\"> [S.I.],\r\n        </span>\r\n            <span ng-if=\"edicion.esAnoDeducido || edicion.anoInicio ==null\">[</span><span ng-if=\"edicion.anoInicio !=null\">{{edicion.anoInicio}}</span><span ng-if=\"edicion.anoInicio ==null\">S.A.</span><span ng-if=\"edicion.esAnoAproximado\">?</span><span ng-if=\"edicion.esAnoDeducido || edicion.anoInicio ==null\">]</span><span ng-if=\"(edicion.anoInicio || (edicion.esAnoAproximado||edicion.esAnoDeducido))\">.</span><span ng-if=\"edicion.bdrs\" class=\"bdrs\"> CBDRS {{edicion.bdrs}}{{edicion.letra}} </span>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/public/components/pagination/pagination.html","<ul uib-pagination max-size=\"10\" total-items=\"ctrl.totalElements\" ng-model=\"ctrl.currentPage\" ng-change=\"ctrl.pageChanged()\" items-per-page=\"ctrl.itemsPerPage\" boundary-link-numbers=\"true\" next-text=\"»\" previous-text=\"«\" ng-if=\"ctrl.itemsPerPage < ctrl.totalElements\"></ul>\r\n");
$templateCache.put("app/public/edicion/ayuda/ayuda.modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"ctrl.dismiss()\">&times;</button>\r\n        <h4 class=\"modal-title\" translate=\"{{\'Leyenda e instrucciones del buscador\'}}\"></h4>\r\n    </div>\r\n    <estatica id=\"buscador\" bd=\"false\" on-buscar=\"ctrl.buscar\"></estatica>\r\n</div>\r\n");
$templateCache.put("app/public/components/password/password.html","<form name=\"form\" ng-submit=\"ctrl.save()\" novalidate=\"novalidate\" role=\"form\" autocomplete=\"off\" spl-form-show-validation=\"\">\r\n\r\n    <div class=\"form-group\">\r\n        <label translate=\"admin.changepassword.oldpassword\" for=\"password\"></label>\r\n        <input class=\"form-control\" id=\"password\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.form.password\" required=\"required\" type=\"password\">\r\n        <div ng-show=\"form.password.$dirty &amp;&amp; form.password.$invalid\">\r\n            <p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"admin.form.error.required\"></p>\r\n            <p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"admin.form.error.minlength\"></p>\r\n            <p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"admin.form.error.maxlength\"></p>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label translate=\"admin.changepassword.newpassword\" for=\"newPassword\"></label>\r\n        <input class=\"form-control\" id=\"newPassword\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.form.newpassword\" required=\"required\" type=\"password\">\r\n        <div ng-show=\"form.confirmPassword.$dirty &amp;&amp; form.form.newpassword.$invalid\">\r\n            <p class=\"help-block\" ng-show=\"form.newpassword.$error.required\" translate=\"admin.form.error.required\"></p>\r\n            <p class=\"help-block\" ng-show=\"form.newpassword.$error.minlength\" translate=\"admin.form.error.minlength\"></p>\r\n            <p class=\"help-block\" ng-show=\"form.newpassword.$error.maxlength\" translate=\"admin.form.error.maxlength\"></p>\r\n        </div>\r\n        <password-strength-bar password-to-check=\"ctrl.form.newpassword\"></password-strength-bar>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label translate=\"admin.form.confirmpassword\" for=\"confirmPassword\"></label>\r\n        <input class=\"form-control\" id=\"confirmPassword\" ng-maxlength=\"50\" ng-minlength=\"1\" ng-model=\"ctrl.confirmPassword\" required=\"required\" type=\"password\">\r\n        <div ng-show=\"form.confirmPassword.$dirty &amp;&amp; form.confirmPassword.$invalid\">\r\n            <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"admin.form.error.required\"></p>\r\n            <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"admin.form.error.minlength\"></p>\r\n            <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"admin.form.error.maxlength\"></p>\r\n        </div>\r\n    </div>\r\n\r\n    <!--Botones-->\r\n    <div class=\"form-bottom-buttons\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$root.back()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>\r\n            <span translate=\"admin.form.button.cancel\"></span>\r\n        </button>\r\n        <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"form.$invalid\">\r\n            <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.edit\"></span>\r\n        </button>\r\n    </div>\r\n</form>\r\n\r\n");
$templateCache.put("app/public/edicion/email/email.form.modal.html","<form name=\"form\" role=\"form\" ng-submit=\"ctrl.save()\" show-validation=\"\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"ctrl.dismiss()\">&times;</button>\r\n        <h4 class=\"modal-title\" translate=\"buscador.basico.ventanaEmail\"></h4>\r\n    </div>\r\n\r\n    <div class=\"modal-body geonames\">\r\n        <alert modal=\"true\"></alert>\r\n\r\n        <div class=\"form-group\">\r\n            <p class=\"info\">{{\'buscador.basico.direccionEmail\' | translate}}</p>\r\n            <input type=\"email\" id=\"email\" ng-model=\"ctrl.item.email\" class=\"form-control\">\r\n            <loading is-loading=\"ctrl.cargando\" class=\"center-block loading-mail\"></loading>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"modal-footer\">\r\n        <!--Botones-->\r\n        <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"ctrl.cargando\" ng-click=\"ctrl.clear()\">\r\n            <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.cancel\"></span>\r\n        </button>\r\n        <button type=\"submit\" ng-disabled=\"form.$invalid || ctrl.cargando\" class=\"btn btn-primary\">\r\n            <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n            <span translate=\"admin.form.button.send\"></span>\r\n        </button>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/admin/tesauro/lugar/ubicacion/ubicacion.form.modal.html","<div class=\"modal-map\">\r\n    <form name=\"form\" role=\"form\" ng-submit=\"ctrl.save()\" show-validation=\"\">\r\n        <div class=\"modal-header modalmap\">\r\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"ctrl.clear()\">&times;\r\n            </button>\r\n            <h4>{{ctrl.item.nombre}}</h4>\r\n        </div>\r\n\r\n        <div class=\"modal-body geonames\">\r\n            <alert modal=\"true\"></alert>\r\n\r\n            <p class=\"info\">{{\'admin.lugar.geonames.info\' | translate}}</p>\r\n\r\n            <!--Coordenadas-->\r\n            <div class=\"form-inline coordenadas\">\r\n                <div class=\"form-group\">\r\n                    <label translate=\"admin.lugar.form.lat\" for=\"lat\"></label>\r\n                    <input type=\"number\" name=\"name\" ng-model=\"ctrl.item.lat\" id=\"lat\" class=\"editable-input form-control input-sm\" step=\"0.00000000000000001\" required ng-change=\"ctrl.onChangeLatLong()\">\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label translate=\"admin.lugar.form.lng\" for=\"long\"></label>\r\n                    <input type=\"number\" name=\"name\" ng-model=\"ctrl.item.lng\" id=\"long\" class=\"editable-input form-control input-sm\" step=\"0.00000000000000001\" required ng-change=\"ctrl.onChangeLatLong()\">\r\n                </div>\r\n\r\n                <div class=\"form-group\" ng-show=\"ctrl.item.lat != null && ctrl.item.lng != null\">\r\n                    <a class=\"btn btn-default pull-right\" href=\"http://maps.google.com/maps?q=loc:{{ctrl.item.lat}},{{ctrl.item.lng}}\" target=\"_blank\">{{\'admin.lugar.geonames.googlemaps\' | translate}}</a>\r\n                </div>\r\n\r\n            </div>\r\n\r\n            <!--Lista de elementos de Geonames-->\r\n            <div class=\"geonames-form row\">\r\n                <div class=\"col-md-8\">\r\n                    <leaflet id=\"mymap\" defaults=\"ctrl.defaults\" lf-center=\"ctrl.center\" event-broadcast=\"ctrl.events\" markers=\"ctrl.markers\"></leaflet>\r\n                </div>\r\n\r\n                <div class=\"col-md-4\">\r\n                    <div class=\"text-center\" ng-if=\"ctrl.loading\">\r\n                        <loading is-loading=\"ctrl.loading\"></loading>\r\n                    </div>\r\n\r\n                    <div class=\"titulo\" translate=\"admin.lugar.geonames.title\"></div>\r\n\r\n                    <p class=\"empty\" ng-if=\"!ctrl.loading && (!ctrl.propuestas || !ctrl.propuestas.length)\" translate=\"admin.lugar.geonames.empty\"></p>\r\n\r\n                    <div class=\"form-group row lugar\" ng-repeat=\"lugar in ctrl.propuestas\">\r\n                        <radio class=\"principal\" model=\"ctrl.selected\" value=\"$index\" change=\"ctrl.onChangeRadio()\" label=\"{{lugar.name}} ({{lugar.countryName}})\"></radio>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"modal-footer\">\r\n            <!--Botones-->\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.clear()\">\r\n                <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.cancel\"></span>\r\n            </button>\r\n            <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\">\r\n                <span class=\"glyphicon glyphicon-ok\"></span>&nbsp;\r\n                <span translate=\"admin.form.button.save\"></span>\r\n            </button>\r\n        </div>\r\n    </form>\r\n</div>\r\n");
$templateCache.put("app/components/form/archivos/fileupload/file-upload.html","<ng-form name=\"ficheroForm\">\r\n    <div class=\"form-group\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <!--<div ng-if=\"!ctrl.archivo\" class=\"datos-archivo pull-left\">{{\'upload.file.vacio\' | translate}}</div>-->\r\n                <div ng-if=\"ctrl.archivo\" class=\"datos-archivo pull-left\">\r\n                    <download ng-if=\"ctrl.url && !ctrl.archivoTemporal\" archivo=\"ctrl.archivo\" url=\"{{ctrl.url}}\" show-label=\"false\" has-any-authority=\"{{ctrl.authorities}}\"></download>\r\n\r\n                    <span ng-if=\"!ctrl.progresoArchivo\" class=\"glyphicon glyphicon-remove clickable eliminar-archivo\" title=\"Eliminar\" ng-click=\"ctrl.eliminarArchivo()\"></span>\r\n\r\n                    <span>{{ctrl.archivo}}</span>\r\n                </div>\r\n\r\n                <loading is-loading=\"ctrl.progresoArchivo\"></loading>\r\n\r\n                <input id=\"{{ctrl.id}}\" name=\"archivo\" type=\"file\" class=\"oculto\" ngf-select accept=\"{{ctrl.accept}}\" ngf-change=\"ctrl.onArchivoSelect($files, ficheroForm)\">\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <button type=\"button\" ng-disabled=\"ctrl.progresoArchivo\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"ctrl.upload()\">\r\n                    {{\'upload.file.title\' | translate}}\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-form>\r\n");
$templateCache.put("app/components/form/archivos/imagen/imagen.html","<div class=\"col-sm-3 imagen\" ng-if=\"!ctrl.ngModel.eliminar\">\r\n    <div class=\"form-group\">\r\n        <ng-form name=\"imagenForm\">\r\n\r\n            <div class=\"enxe-boton-elegir\" ng-show=\"ctrl.edicion && !ctrl.ngModel.rutaImagen && !ctrl.progresoImagen\">\r\n                <button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-disabled=\"ctrl.progresoImagen\" ng-click=\"ctrl.clickUpload()\" ng-if=\"ctrl.mensaje != null\">\r\n                    {{ctrl.mensaje}}\r\n                </button>\r\n                <span sv-handle ng-show=\"false\"></span>\r\n            </div>\r\n\r\n            <div class=\"imagen\" ng-if=\"ctrl.ngModel.rutaImagen && ctrl.edicion\" ng-class=\"{\'imagen-profile\' : ctrl.profile}\" sv-handle>\r\n                <div class=\"imagen-wrap\" ng-if=\"ctrl.ngModel.path\">\r\n\r\n                    <span class=\"glyphicon glyphicon-remove clickable close\" ng-click=\"ctrl.eliminarImagen()\" title=\"{{\'admin.form.button.delete\' | translate}}\"></span>\r\n\r\n                    <img draggable=\"false\" class=\"enxe-img pull-left\" ng-src=\"{{ctrl.ngModel.rutaImagen}}\">\r\n\r\n                    <radio ng-if=\"ctrl.ngModelRadio\" class=\"principal\" model=\"ctrl.ngModelRadio\" value=\"{{ctrl.id}}\"></radio>\r\n                </div>\r\n\r\n                <loading is-loading=\"ctrl.progresoImagen\"></loading>\r\n            </div>\r\n\r\n            <input id=\"inputFoto{{ctrl.id}}\" type=\"file\" ngf-select=\"\" class=\"oculto\" ngf-change=\"ctrl.onImagenSelect($files, imagenForm)\" accept=\".jpg,.png,.gif,.jpeg\">\r\n\r\n        </ng-form>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/components/form/archivos/imagenperfil/imagen-perfil.html","<div class=\"form-group imagen-perfil\">\r\n    <ng-form name=\"imagenPerfilForm\">\r\n\r\n        <div class=\"enxe-boton-elegir\" ng-show=\"!ctrl.editPreview && !ctrl.ngModel.path && !ctrl.progresoImagen || !ctrl.myCroppedImage\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"ctrl.progresoImagen\" ng-click=\"ctrl.clickUpload()\">\r\n                {{\'imagen.form.uploadperfil\' | translate}}\r\n            </button>\r\n        </div>\r\n\r\n        <div class=\"imagen imagen-profile\" ng-show=\"ctrl.ngModel.path || ctrl.editPreview && ctrl.myCroppedImage\">\r\n            <div class=\"imagen-wrap\">\r\n                <span class=\"glyphicon glyphicon-remove clickable close\" ng-click=\"ctrl.eliminarImagen()\" title=\"{{\'admin.form.button.delete\' | translate}}\" ng-show=\"!ctrl.editPreview\"></span>\r\n\r\n                <img class=\"enxe-img pull-left redonda\" ng-src=\"{{ctrl.myCroppedImage}}\" ng-show=\"!ctrl.editPreview\">\r\n\r\n                <div class=\"crop-area pull-left\" ng-show=\"ctrl.editPreview\">\r\n                    <ui-cropper image=\"ctrl.myImage\" area-type=\"circle\" result-image=\"ctrl.myCroppedImage\" live-view=\"ctrl.blockingObject\" aspect-ratio=\"1\" area-min-size=\"50\" result-image-size=\"200\"></ui-cropper>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <loading is-loading=\"ctrl.progresoImagen\"></loading>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <button type=\"button\" class=\"btn btn-default btn-confirm\" ng-show=\"ctrl.editPreview && ctrl.myCroppedImage\" ng-click=\"ctrl.onImagenSelect(ctrl.myCroppedImage, imagenPerfilForm)\">\r\n                    {{\'imagen.form.setperfil\' | translate}}\r\n                </button>\r\n            </div>\r\n        </div>\r\n\r\n        <input id=\"inputFoto{{ctrl.indice}}\" type=\"file\" ngf-select=\"\" class=\"oculto\" ngf-change=\"ctrl.preview($files)\" accept=\".jpg,.png,.gif,.jpeg\">\r\n\r\n    </ng-form>\r\n</div>\r\n");
$templateCache.put("app/components/form/archivos/download/download.html","<!--<span ng-if=\"ctrl.showLabel\">{{ctrl.archivo || \'-\'}}</span>-->\r\n\r\n<span ng-if=\"ctrl.archivo && ctrl.url\" ng-click=\"ctrl.descargarArchivo()\" title=\"Descargar\" class=\"glyphicon glyphicon-download-alt boton-descarga\"></span>\r\n");
$templateCache.put("app/components/form/archivos/imagenperfilver/imagen-perfil-ver.html","<div class=\"imagen-perfil\">\r\n    <span class=\"glyphicon glyphicon-user\" ng-if=\"!ctrl.usuario.foto\"></span>\r\n    <img class=\"imagen-header\" ng-class=\"ctrl.mini ? \'mini\' : \'normal\'\" ng-src=\"upload/usuarios/{{ctrl.usuario.id}}/perfil/n_{{ctrl.usuario.foto}}\" ng-if=\"ctrl.usuario.foto\">\r\n</div>\r\n");}]);})();